(() => {
'use strict';
const $ = id => document.getElementById(id);
const cv = $('cv');
let ctx = cv.getContext('2d');   // 背景の区画を作るあいだだけ描き先を切り替える（bgTile）
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
const TAU = Math.PI * 2;
const C = { ground:'#E3F2E6', line:'#CBE5D2', leaf:'#1FA35C', deep:'#157A44', ink:'#1E4A35', spark:'#F4B400' };
const STORE_URL = 'https://shop.light-technical.com/products/';

/* ---------- 商品データ ----------
   ストアのゲームページ（テーマ）では、ページを開いた時点の最新の商品・価格・セールを
   window.TERAISM_GAME で受け取る（Liquid が書き出す）。ログインの有無と受付の入口もここに入る。
   公開ページ（claude.ai）では、埋め込んだ控え（DATA の印の間）を使い、起動後に Shopify コネクタで読み直す。 */
const SHOPCFG = window.TERAISM_GAME || null;
const SNAPSHOT = SHOPCFG ? SHOPCFG.data : /*DATA*/null/*END*/;
const DB = { byH:{}, byG:{}, dailyDeal:SNAPSHOT.dailyDeal || {}, promo:SNAPSHOT.promo || {events:[]}, dailyCol:SNAPSHOT.dailyCollection || [], source:'snapshot', demo:false };
for (const raw of SNAPSHOT.products){
  const p = normalizeProduct(raw);
  if (!p) continue;
  DB.byH[p.h] = p; (DB.byG[p.g] = DB.byG[p.g] || []).push(p);
}
// 商品名「型番｜呼称」から型番を取り出し、パーツの種類（シリーズ）を決める。控えの build_data.py と同じ決まり
function normalizeProduct(raw){
  const p = {...raw};
  // テーマから来た価格は最小単位（×100）。円に直す
  if (p.pc != null){ p.price = Math.round(p.pc / 100); p.cmp = p.cc ? Math.round(p.cc / 100) : null; }
  if (!p.code){ const t = String(p.title || ''), i = t.indexOf('｜'); p.code = i >= 0 ? t.slice(0, i) : t; p.name = i >= 0 ? t.slice(i + 1) : t; }
  if (!p.g) p.g = groupOf(p);
  if (!p.g) return null;
  if ((p.tags || []).includes('数量限定')) p.lim = true;
  return p;
}
function groupOf(p){
  const code = p.code, t = code + '｜' + p.name, tags = p.tags || [];
  const first = code.split(/[＆&/ ]/)[0];
  const st = (x) => first.startsWith(x);
  if (tags.includes('Bグレード') || tags.includes('数量限定')) return null;
  if (st('FR-') || st('EO-') || t.includes('T-GUM')) return 'fluid';
  if (['EC-17', 'EC-06', 'EC-07'].includes(first)) return 'spark';
  if (first === 'EC-15B2') return 'amount';
  if (['EC-13', 'EC-13SP'].includes(first)) return 'cd';
  if (st('SB-')) return 'thermo';
  if (st('EB-')) return 'band';
  if (st('FC-') || st('DO-') || (t.includes('Joy') && t.includes('銅'))) return 'copper';
  if (st('TA-01')) return 'boomer';
  if (st('TW-02') || st('TW-03') || st('TW-05')) return 'speed';
  if (st('TA-03') || code.includes('チタン') || st('TW-04') || t.includes('Ti-Pro') || st('AE-06')) return 'ti';
  if (st('AE-07')) return 'magnet';
  if (st('AE-') || st('PF-84') || st('BN-02')) return 'alu';
  if (st('DN-')) return 'revive';
  if (st('BCD-')) return 'luck';
  if (st('FS-')) return 'hp';
  if (st('PF-21') || st('PF-22')) return 'blade';
  if (st('RP-') || st('PF-')) return 'area';
  if (st('EX-01') || st('EC-14')) return 'nuke';
  if (code.includes('ステンレス') || code.includes('真鍮') || st('BN-01')) return 'armor';
  if (t.includes('Joy') && !t.includes('銅')) return 'crit';
  if (st('EX-') || st('EC-14') || st('BN-01') || code.includes('ステンレス') || code.includes('真鍮') || t.includes('Joy')) return 'power';
  return null;
}

const todayJST = () => new Date(Date.now() + 9 * 3600e3).toISOString().slice(0, 10);
const yen = n => '¥' + Math.round(n).toLocaleString('ja-JP');
const md = s => { const [, m, d] = s.split('-'); return (+m) + '/' + (+d); };

// 定価：定価より安く売っているときは compareAt、それ以外は価格
const listPrice = p => (p.cmp && p.cmp > p.price) ? p.cmp : p.price;
function saleOf(p){
  const today = todayJST(), dd = DB.dailyDeal || {};
  const inDaily = DB.dailyCol.includes(p.h) || (dd.date === today && ((dd.handles || []).includes(p.h) || dd.handle === p.h));
  if (inDaily){ const pct = dd.percent || 30; return {kind:'daily', label:'日替わりセール', pct, now:Math.round(p.price * (1 - pct / 100))}; }
  if (p.cmp && p.cmp > p.price) return {kind:'sale', label:'セール中', pct:Math.round((1 - p.price / p.cmp) * 100), now:p.price};
  return null;
}
// 性能：定価の平方根に比例（4,000円で1.00倍、0.70〜2.00倍）。セール中はさらに2倍
const pricePower = p => Math.max(0.7, Math.min(2.0, Math.sqrt(listPrice(p) / 4000)));
const powerOf = p => pricePower(p) * (saleOf(p) ? 2 : 1);
function activeCampaign(){
  const t = todayJST();
  for (const e of (DB.promo.events || [])){
    if (e.kind === 'campaign' && e.from <= t && t <= e.to){
      const m = /(\d+)\s*%/.exec(e.label || ''); return {...e, rate: m ? +m[1] : 0};
    }
  }
  return null;
}

// ---------- パーツ（商品シリーズ）の定義 ----------
const GROUPS = {
  spark:{kind:'w', role:'火花ショット', rep:'teraism-ec-17', max:8,
    desc:['近くの敵へ火花を3連射','ダメージアップ','連射が速くなる','火花が2体まで貫通','ダメージと連射アップ','5連射になる','火花が3体まで貫通・ダメージアップ','7連射・連射アップ']},
  alu:{kind:'w', role:'周回プレート', rep:'teraism-ae-08-1-sheet-a', max:8,
    desc:['2枚のプレートが車体を周回','ダメージアップ','プレート +1枚','回転の半径と速さアップ','プレート +1枚','プレート +1枚','ダメージアップ・プレート +1枚','大きく速く回る・ダメージ大幅アップ']},
  ti:{kind:'w', role:'貫通ロッド', rep:'teraism-ta-03-4-pc-64-ti', max:8,
    desc:['近くの敵へ貫通するロッドを投げる','ダメージアップ','本数 +1','連射が速くなる','本数 +1','本数 +1・ダメージアップ','本数 +1','ダメージ大幅アップ・連射アップ']},
  band:{kind:'w', role:'衝撃リング', rep:'teraism-eb-13-21mm-38mm-2-pc-set', max:8,
    desc:['衝撃の輪で周りを押し返す','範囲アップ','ダメージアップ','発動が速くなる','範囲アップ','ダメージと範囲アップ','2重のリング','ダメージ大幅アップ']},
  copper:{kind:'w', role:'連鎖電撃', rep:'teraism-fc-09-copper-1-pc', max:8,
    desc:['電撃が敵から敵へ3体に連鎖','連鎖 +1','ダメージアップ','連鎖 +1・発動が速く','連鎖 +1','ダメージアップ・連鎖 +1','連鎖 +2','2本の電撃が同時に走る']},
  thermo:{kind:'w', role:'熱のオーラ', rep:'teraism-sb-02-40cm', max:8,
    desc:['車体の周りに熱のオーラ','範囲アップ','ダメージアップ','範囲アップ','ダメージアップ','範囲とダメージが大きく上がる','オーラの中の敵が遅くなる','ダメージ大幅アップ']},
  fluid:{kind:'w', role:'ダメージ床', rep:'teraism-fr-01', max:8,
    desc:['敵の足元にダメージ床をまく','範囲アップ','ダメージアップ','まく間隔が短くなる','持続時間アップ','範囲とダメージが大きく上がる','2か所にまく','範囲とダメージ大幅アップ']},
  blade:{kind:'w', role:'近接ブレード', rep:'teraism-pf-22-2-sheet', max:8,
    desc:['近くの敵を扇形になぎ払う（近距離）','ダメージアップ','範囲アップ','前と後ろを同時に斬る','振りが速くなる','全周をなぎ払う','ダメージと範囲アップ','2回斬り']},
  nuke:{kind:'w', role:'全放電バースト', rep:'teraism-ex-01sp', max:8,
    desc:['一定時間ごとに、画面の敵すべてに大ダメージ','ダメージアップ','発動が速くなる','ダメージアップ','発動が速くなる','落ちているポイントも全部回収','発動が速くなる','ダメージ大幅アップ']},
  boomer:{kind:'w', role:'回転キャップ', rep:'teraism-ta-01-gunmetal-2', max:8,
    desc:['行って戻る回転キャップを投げる（貫通）','ダメージアップ','本数 +1','速く・遠くへ','本数 +1','本数 +1・ダメージアップ','本数 +1','ダメージ大幅アップ']},
  speed:{kind:'p', role:'移動速度', rep:'teraism-tw-05-3-0mm-2-pc-set', max:8, unit:'移動速度 +{8}%'},
  hp:{kind:'p', role:'最大HP・回復', rep:'teraism-fs-25-1-pc', max:8, unit:'最大HP +{15}・毎秒回復 +{0.15}'},
  cd:{kind:'p', role:'連射', rep:'teraism-ec-13sp-usb', max:8, unit:'全武器の発動間隔 -{6}%'},
  power:{kind:'p', role:'威力', rep:'teraism-ex-02sp-1-pc', max:8, unit:'全武器のダメージ +{10}%'},
  area:{kind:'p', role:'範囲', rep:'teraism-rp-01b-stealth-black-1-pc', max:8, unit:'全武器の範囲 +{8}%'},
  magnet:{kind:'p', role:'吸い寄せ', rep:'teraism-ae-07sp', max:8, unit:'ポイント吸い寄せ範囲 +{25}%'},
  // 10/5 追加の能力
  armor:{kind:'p', role:'防御力', rep:'teraism-m6-15mm-2-pc', max:8, unit:'受けるダメージ -{5}%（最大60%）'},
  crit:{kind:'p', role:'会心', rep:'teraism-joy-m10-2-pc-p1-5', max:8, unit:'会心率 +{5}%（会心はダメージ2倍）'},
  revive:{kind:'p', role:'復活', rep:'teraism-dn-01-1-pc', max:3, unit:'倒れても1回、HP半分で復活（1段階ごとに1回）'},
  amount:{kind:'p', role:'弾数', rep:'teraism-ec-15b2-usb-usb', max:4, unit:'火花・ロッド・キャップ・電撃の数 +1（1段階ごと）'},
  luck:{kind:'p', role:'運', rep:'teraism-bcd-01', max:5, unit:'回復・宝箱などのアイテムが出やすい +{20}%'},
};
const STARTERS = ['spark','alu','ti'];
const SLOT_MAX = {w:6, p:6};   // 持てる武器・能力の数（何を選ぶかを大事にするため）
const passiveText = (g, pw) => GROUPS[g].unit.replace(/\{([\d.]+)\}/g, (_, n) => { const v = +n * pw; return v < 1 ? v.toFixed(2) : (Math.round(v * 10) / 10); });

const inStock = p => p && p.inv > 0 && !p.lim; // 数量限定品はゲームに出さない
// そのシリーズで今日出す商品：セール中を優先、なければ在庫のある商品から1つ
function productFor(g, preferRep){
  const list = (DB.byG[g] || []).filter(inStock);
  const onSale = list.filter(saleOf);
  if (onSale.length) return onSale[(Math.random() * onSale.length) | 0];
  if (preferRep && inStock(DB.byH[GROUPS[g].rep])) return DB.byH[GROUPS[g].rep];
  return list.length ? list[(Math.random() * list.length) | 0] : DB.byH[GROUPS[g].rep];
}

/* エンドレスの難しさ（10/5、依頼者「10分でクリア率1%ぐらい」）。t は秒。
   試しのプレイヤー（sim）で何十回も走らせて決めた値。チャレンジ（1分・3分）はこれまでどおり */
const DIFF = {
  endless: {
    spawn: t => 1.2 + t / 14 + Math.pow(t / 300, 2) * 4,
    // 序盤〜中盤はゆるやかに、8分すぎから急に厳しく（試算ボットで10分到達がごくわずかになるよう合わせた）
    hp: t => 1 + t / 45 + Math.pow(t / 380, 5) * 26,
    dmg: t => 0.9 + t / 180 + Math.pow(t / 440, 6) * 12,
    speed: t => 1 + Math.max(0, t - 420) / 500,              // 7分から足が速くなり、10分で1.36倍（逃げ回るだけでは振り切れない）
    cap: t => Math.min(380, 170 + t / 2),
    elite: t => t < 240 ? 0 : Math.min(0.14, (t - 240) / 2600),
    bossHp: (t, n) => (1 + t / 70) * (1 + 0.3 * (n - 1)),     // ボスは倒せる硬さに（居座ると道中が楽になるだけでなく体当たりで終わる）
    bossDmg: t => 0.8 + t / 500,
  },
  // 1分・3分チャレンジ：ゲームに慣れていない方でもクリアしやすく（10/11、依頼者の声「50代の方が難しいと言っている」）
  normal: { spawn: t => 0.8 + t / 13, hp: t => 1 + t / 40, dmg: () => 0.6, cap: () => 220, elite: () => 0, speed: () => 0.9,
    bossHp: (t, n) => (1 + t / 45) * (1 + 0.35 * (n - 1)), bossDmg: () => 0.6 },
  // 3分チャレンジ（NORMAL）：1分（EASY）より少し難しく（10/11 依頼者）。易しくする前の設定との、ほぼ中間
  c3: { spawn: t => 0.9 + t / 11, hp: t => 1 + t / 34, dmg: () => 0.8, cap: () => 260, elite: () => 0, speed: () => 0.95,
    bossHp: (t, n) => (1 + t / 40) * (1 + 0.42 * (n - 1)), bossDmg: () => 0.8 },
  // クライマックス：1秒に26体わいて、どの攻撃でも1撃で倒れる。こちらは傷つかない。重くならないよう同時に200体まで
  rush: { spawn: () => 26, hp: () => 0.02, dmg: () => 0, cap: () => 200, elite: () => 0, speed: () => 1,
    bossHp: () => 1, bossDmg: () => 0 },
};
const diff = () => DIFF[G.mode === 'endless' ? 'endless' : G.mode === 'c3' ? 'c3' : G.mode === 'rush' ? 'rush' : 'normal'];
const ET = {
  spark:{r:10,hp:7,sp:74,dmg:5,xp:1,col:'#8E7CF3'},
  heat:{r:11,hp:12,sp:104,dmg:6,xp:2,col:'#F27B5F'},
  rust:{r:15,hp:30,sp:50,dmg:9,xp:3,col:'#C8804A'},
  resist:{r:19,hp:80,sp:42,dmg:12,xp:5,col:'#7F9CB5'},
  boss:{r:44,hp:650,sp:62,dmg:22,xp:30,col:'#6C5CE7'},
  // 10/5 追加の敵
  noise:{r:8,hp:5,sp:150,dmg:4,xp:1,col:'#6FD3F0'},       // ノイズ：素早い群れ（2分〜）
  shooter:{r:14,hp:40,sp:60,dmg:8,xp:4,col:'#F4B400'},    // 電圧スパイク：離れて弾を撃つ（3分〜）
  split:{r:24,hp:120,sp:38,dmg:14,xp:6,col:'#A65E2E'},    // 錆の塊：倒すと錆3体に割れる（4分〜）
  coil:{r:20,hp:150,sp:34,dmg:10,xp:8,col:'#7EA6E6'},     // 磁界コイル：近くにいると引き寄せる（2分半〜）
};
// 敵のアビリティ：引力（磁界コイル・ボス）、突進（熱ダレの一部）、減速（抵抗のまわり）
const COIL_R = 300, RESIST_R = 95, BOSS_PULL_R = 520;
const pullRes = () => Math.max(0.4, 1 - 0.075 * lvOf('armor'));   // 防御のパーツで引き寄せに踏ん張る（最大6割減）
const ABIL_MSG = {coil:'磁界コイル出現！ 近づくと引き寄せられる', resist:'抵抗のまわりに入ると動きが鈍る', dash:'熱ダレが突進してくる！ 赤い線に注意'};

let W = 0, H = 0, DPR = 1, ZOOM = 1, VW = 0, VH = 0;
function resize(){
  const g = $('game');
  W = g.clientWidth; H = g.clientHeight;
  // 大きな画面では1コマに塗る点が増えすぎて重くなるので、約240万点までに抑える
  DPR = Math.min(window.devicePixelRatio || 1, 2, Math.sqrt(2.4e6 / Math.max(1, W * H)));
  cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
  ZOOM = Math.max(0.72, Math.min(1, Math.min(W, H) / 620));
  VW = W / ZOOM; VH = H / ZOOM;
}
addEventListener('resize', resize); resize();

// ---------- 状態 ----------
let G = null, state = 'title', keys = new Set(), S = {};
/* 遊び方。win は勝ちになる秒数（0 は倒れるまで）。大群とボスの時刻（秒） */
const MODES = {
  c1: {label:'1分チャレンジ', win:60, waves:[20, 40], bossAt:[40]},
  c3: {label:'3分チャレンジ', win:180, waves:[30, 90, 140], bossAt:[60, 120, 160]},
  endless: {label:'エンドレス', win:0, waves:[30], bossAt:[90]},
  // クライマックス（10/17 依頼者）：広告から来た人向けの30秒の体験版。フル装備・敵は大量で1撃・こちらはやられない
  rush: {label:'クライマックス', win:30, waves:[3, 8, 13, 18, 23, 27], bossAt:[]},
};
const PLAY_MODES = ['c1', 'c3', 'endless'];   // タイトルで選べる遊び方（クライマックスは広告から来た人だけ）
let mode = (() => { try { const m = localStorage.getItem('teraism-survivor-mode'); return MODES[m] ? m : 'c3'; } catch(e){ return 'c3'; } })();
const endless = () => G && G.mode === 'endless';
const lvOf = g => (G && G.lv_[g]) || 0;

function recompute(){
  const s = g => G.psum[g] || 0;
  const camp = activeCampaign();
  S = {
    speed: 1 + 0.08 * s('speed'),
    cd: Math.max(0.5, 1 - 0.06 * s('cd')),
    dmg: 1 + 0.10 * s('power'),
    area: 1 + 0.08 * s('area'),
    magnet: 70 * (1 + 0.25 * s('magnet')),
    regen: 0.15 * s('hp'),
    xp: 1 + (camp ? camp.rate / 100 : 0),
    armor: Math.min(0.6, 0.05 * s('armor')),
    crit: Math.min(0.6, 0.05 * s('crit')),
    amount: lvOf('amount'),
    luck: 1 + 0.2 * s('luck'),
  };
  const newMax = Math.round(100 + 15 * s('hp'));
  if (G.p.maxHp !== newMax){ G.p.hp += newMax - G.p.maxHp; G.p.maxHp = newMax; }
}
// 武器の威力は、取り付けた商品のうち一番強いもの
const wp = g => G.wpow[g] || 1;

function newGame(g, prod){
  G = {
    t:0, lv:1, xp:0, pts:0, kills:0, pending:0, chest:0,
    p:{x:0, y:0, r:14, hp:100, maxHp:100, inv:0, face:0},
    lv_:{}, wpow:{}, psum:{}, timers:{}, order:[], installed:[],
    enemies:[], bullets:[], rings:[], lines:[], puddles:[], gems:[], items:[], parts:[], texts:[],
    spawnAcc:0, aeAng:0, sbT:0, slashes:[], flash:0, fx:[], warn:0, warned:-1, lvDelay:null, mode, ebullets:[], revived:0, reached10:false, shake:0, boss:null, bossN:0,
    seenAb:{}, pullX:0, pullY:0, slow:false,
    wx:null, wxNext: mode === 'endless' ? 150 : mode === 'c3' ? 100 : 1e9,
    waves: MODES[mode].waves.slice(), bossAt: MODES[mode].bossAt.slice(), attempt:null, result:null,
  };
  install(g, prod);
  if (mode === 'rush'){   // フル装備：武器を全種類、最大の強さで積む
    G.quiet = true; G.pre = 3;
    for (const k of Object.keys(GROUPS)){
      if (GROUPS[k].kind !== 'w') continue;
      const p = productFor(k, true); if (!p) continue;
      while (lvOf(k) < GROUPS[k].max) install(k, p);
    }
    G.quiet = false;
  }
  recompute();
  setState('play');
}
function install(g, prod){
  const pw = powerOf(prod), sale = saleOf(prod);
  if (!G.lv_[g]){ G.order.push(g); G.timers[g] = 0.3; }
  G.lv_[g] = (G.lv_[g] || 0) + 1;
  if (GROUPS[g].kind === 'w') G.wpow[g] = Math.max(G.wpow[g] || 0, pw);
  else G.psum[g] = (G.psum[g] || 0) + pw;
  if (!G.installed.find(x => x.h === prod.h)) G.installed.push({h:prod.h, g, sale:!!sale});
  if (sale && !G.quiet) toast(`${sale.label}の特典：${prod.code} の効果が2倍！`, true);
  renderSlots();
}
const need = lv => Math.floor(4 + lv * 3 + lv * lv * 0.25);

// ---------- 入力 ----------
addEventListener('keydown', e => {
  const k = e.key.toLowerCase();
  keys.add(k);
  if (['arrowup','arrowdown','arrowleft','arrowright',' '].includes(k) && state === 'play') e.preventDefault();
  if ((k === 'escape' || k === 'p') && (state === 'play' || state === 'pause')) togglePause();
  if (state === 'lot'){
    if (LOT && LOT.pick && !LOT.revealed && ['1','2','3'].includes(k)) LOT.pick(+k - 1);
    else if ([' ', 'enter'].includes(k)){ e.preventDefault(); lotSkip(); }
  }
  if (state === 'lvup' && ['1','2','3'].includes(k)){ const b = $('choices').children[+k - 1]; if (b) b.click(); }
  if (state === 'title' && titleStep === 'part' && ['1','2','3'].includes(k)){ const b = $('starters').children[+k - 1]; if (b) b.click(); }
});
addEventListener('keyup', e => keys.delete(e.key.toLowerCase()));
addEventListener('blur', () => { keys.clear(); if (state === 'play') togglePause(); });
document.addEventListener('visibilitychange', () => { if (document.hidden && state === 'play') togglePause(); });
// ページを閉じる・別のページへ移るとき、遊んでいる途中なら「途中でやめた」を送る
addEventListener('pagehide', () => { if (G && state !== 'title' && state !== 'end') beaconEnd(G, {quit:true}); });

const joy = { on:false, id:null, ox:0, oy:0, x:0, y:0 };
cv.addEventListener('pointerdown', e => {
  if (state !== 'play') return;
  joy.on = true; joy.id = e.pointerId; joy.ox = joy.x = e.clientX; joy.oy = joy.y = e.clientY;
  try { cv.setPointerCapture(e.pointerId); } catch(_){}
});
cv.addEventListener('pointermove', e => { if (joy.on && e.pointerId === joy.id){ joy.x = e.clientX; joy.y = e.clientY; } });
const joyEnd = e => { if (e.pointerId === joy.id){ joy.on = false; joy.id = null; } };
cv.addEventListener('pointerup', joyEnd); cv.addEventListener('pointercancel', joyEnd);
cv.addEventListener('contextmenu', e => e.preventDefault());

function inputVec(){
  if (joy.on){
    const dx = joy.x - joy.ox, dy = joy.y - joy.oy, d = Math.hypot(dx, dy);
    if (d > 6){ const m = Math.min(1, d / 45); return {x: dx / d * m, y: dy / d * m}; }
  }
  let x = 0, y = 0;
  if (keys.has('a') || keys.has('arrowleft')) x--;
  if (keys.has('d') || keys.has('arrowright')) x++;
  if (keys.has('w') || keys.has('arrowup')) y--;
  if (keys.has('s') || keys.has('arrowdown')) y++;
  const d = Math.hypot(x, y);
  return d ? {x: x / d, y: y / d} : {x:0, y:0};
}

// ---------- 効果音（その場で合成。音のファイルは使わない） ----------
let AC = null, MASTER = null, NOISE = null;
// 音量のつり合い（10/11 依頼者「音楽を小さく、効果音を大きく」で調整）。ここだけ変えればよい
const VOL = { sfx:1.0, bgm:0.2, bgmSelect:0.11, title:0.2 };
let soundOn = (() => { try { return localStorage.getItem('teraism-survivor-sound') !== 'off'; } catch(e){ return true; } })();
const lastPlay = {};
function audioInit(){
  try {
    if (!AC){
      AC = new (window.AudioContext || window.webkitAudioContext)();
      const comp = AC.createDynamicsCompressor(); comp.threshold.value = -12; comp.ratio.value = 4;   // 割れない程度に押さえる（強すぎると効果音がこもる）
      MASTER = AC.createGain(); MASTER.gain.value = soundOn ? VOL.sfx : 0;
      MASTER.connect(comp).connect(AC.destination);
      const len = AC.sampleRate;   // 1秒のホワイトノイズ（爆発・風切り音の素）
      NOISE = AC.createBuffer(1, len, AC.sampleRate);
      const d = NOISE.getChannelData(0); for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    }
    if (AC.state === 'suspended') AC.resume();
  } catch(e){ AC = null; }
}
/* BGM（依頼者が作った曲。最後の無音を切り、96kbps に縮めた）
   bgm.mp3＝「Chasing the Sunrise」：遊んでいる画面とレベルアップ・抽選の選択中に繰り返し流す。
   bgm-title.mp3＝「Sunny Day Speed Run」：タイトル画面の曲。ブラウザは画面に触れるまで音を出せないので、
   最初にタップ・キーを押したときから流れる。「音 ON／OFF」で効果音と一緒に切り替わる。
   スマホで読み込みを重くしないよう、使う場面になって初めて読み込む */
let BGM = null, BGM_T = null;
const bgmNew = (n, vol) => { const a = new Audio(sprUrl(n, 'mp3')); a.loop = true; a.volume = vol; a.preload = 'auto'; return a; };
const bgmPlay = a => { if (a.paused){ const pr = a.play(); if (pr && pr.catch) pr.catch(() => {}); } };
function bgmNewRun(){ if (BGM) BGM.currentTime = 0; }   // 新しく遊び始めたら最初から
function bgmSync(){
  const want = soundOn && (state === 'play' || state === 'lvup' || state === 'lot');
  const wantT = soundOn && state === 'title';
  if (want && !BGM){ try { BGM = bgmNew('bgm', VOL.bgm); } catch(e){ BGM = null; } }
  if (wantT && !BGM_T){ try { BGM_T = bgmNew('bgm-title', VOL.title); } catch(e){ BGM_T = null; } }
  if (BGM){
    BGM.volume = state === 'play' ? VOL.bgm : VOL.bgmSelect;   // 選択中は少し小さく
    if (want) bgmPlay(BGM); else if (!BGM.paused) BGM.pause();
  }
  if (BGM_T){ if (wantT) bgmPlay(BGM_T); else if (!BGM_T.paused){ BGM_T.pause(); BGM_T.currentTime = 0; } }
}
// タイトルの曲は、最初に画面へ触れたときに鳴らし始める（自動再生の制限のため）
for (const ev of ['pointerdown', 'keydown']) addEventListener(ev, () => { if (state === 'title') bgmSync(); }, {once:true, capture:true});
function setSound(on){
  soundOn = on;
  try { localStorage.setItem('teraism-survivor-sound', on ? 'on' : 'off'); } catch(e){}
  if (MASTER) MASTER.gain.value = on ? VOL.sfx : 0;
  for (const id of ['soundBtn', 'soundBtnTitle']){ const b = $(id); if (b){ b.textContent = on ? '音 ON' : '音 OFF'; b.setAttribute('aria-pressed', String(on)); } }
  bgmSync();
}
// 音程が動く音（f1→f2、dur秒）
function tone(f1, f2, dur, type, vol, when = 0){
  const t = AC.currentTime + when, o = AC.createOscillator(), g = AC.createGain();
  o.type = type; o.frequency.setValueAtTime(f1, t); o.frequency.exponentialRampToValueAtTime(Math.max(20, f2), t + dur);
  g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + 0.008); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(MASTER); o.start(t); o.stop(t + dur + 0.02);
}
// ざらっとした音（フィルターの周波数を f1→f2 に動かす）
function hiss(dur, vol, f1, f2, ftype = 'bandpass', q = 1, when = 0){
  const t = AC.currentTime + when, src = AC.createBufferSource(), f = AC.createBiquadFilter(), g = AC.createGain();
  src.buffer = NOISE; f.type = ftype; f.Q.value = q;
  f.frequency.setValueAtTime(f1, t); f.frequency.exponentialRampToValueAtTime(Math.max(30, f2), t + dur);
  g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  src.connect(f).connect(g).connect(MASTER); src.start(t, Math.random() * 0.5); src.stop(t + dur + 0.02);
}
const NOTE = (n) => 440 * Math.pow(2, (n - 69) / 12);   // MIDIの音番号→周波数
const SFX = {
  shoot(){ tone(1500, 700, 0.06, 'square', 0.03); },
  hit(){ tone(420, 200, 0.045, 'triangle', 0.035); },
  pop(){ tone(380, 900, 0.08, 'triangle', 0.06); hiss(0.06, 0.05, 3000, 1500); },
  gem(step){ tone(NOTE(84 + step), NOTE(84 + step) * 1.01, 0.09, 'sine', 0.05); tone(NOTE(91 + step), NOTE(91 + step), 0.07, 'sine', 0.025, 0.03); },
  levelup(){ [72, 76, 79, 84].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.16, 'square', 0.045, i * 0.07)); tone(NOTE(96), NOTE(96), 0.3, 'sine', 0.04, 0.28); },
  hurt(){ tone(200, 70, 0.2, 'sawtooth', 0.09); hiss(0.14, 0.12, 900, 200, 'lowpass'); },
  zap(){ hiss(0.1, 0.07, 6000, 2500, 'highpass'); tone(1600, 500, 0.08, 'sawtooth', 0.025); },
  swish(){ hiss(0.14, 0.12, 2400, 500, 'bandpass', 2); },
  ring(){ tone(260, 90, 0.28, 'sine', 0.1); hiss(0.2, 0.04, 800, 200, 'lowpass'); },
  throwcap(){ tone(700, 1100, 0.1, 'triangle', 0.025); },
  nuke(){ hiss(1.1, 0.35, 4000, 120, 'lowpass'); tone(90, 30, 0.9, 'sine', 0.3); tone(1200, 200, 0.4, 'sawtooth', 0.04); },
  warn(){ for (let i = 0; i < 3; i++){ tone(NOTE(81), NOTE(81), 0.18, 'square', 0.05, i * 0.42); tone(NOTE(77), NOTE(77), 0.18, 'square', 0.05, i * 0.42 + 0.2); } },
  bossdie(){ hiss(1.2, 0.4, 2500, 80, 'lowpass'); tone(160, 35, 1.0, 'sawtooth', 0.12); [79, 84, 88].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.2, 'square', 0.04, 0.5 + i * 0.09)); },
  wave(){ tone(70, 50, 0.7, 'sawtooth', 0.06); hiss(0.7, 0.06, 400, 100, 'lowpass'); },
  item(){ tone(NOTE(81), NOTE(88), 0.14, 'triangle', 0.06); },
  chest(){ [76, 79, 83, 88].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.12, 'triangle', 0.06, i * 0.06)); },
  sale(){ [84, 88, 91].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.1, 'sine', 0.05, i * 0.05)); },
  click(){ tone(900, 1200, 0.035, 'triangle', 0.035); },
  blackout(){ tone(320, 60, 0.6, 'sawtooth', 0.08); hiss(0.5, 0.12, 1800, 200, 'lowpass'); tone(NOTE(60), NOTE(48), 0.4, 'square', 0.04, 0.15); },
  tick(){ tone(2200, 2000, 0.025, 'square', 0.018); },
  reel(){ tone(520, 260, 0.08, 'square', 0.05); hiss(0.05, 0.05, 2500, 900); },
  reach(){ [79, 83, 86].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.12, 'square', 0.04, i * 0.08)); },
  flip(){ hiss(0.12, 0.08, 3200, 1200, 'bandpass', 2); tone(600, 900, 0.06, 'triangle', 0.03); },
  win(){ [72, 76, 79, 84, 88].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.14, 'square', 0.045, i * 0.07)); },
  jackpot(){ [72, 76, 79, 84, 79, 84, 88, 91].forEach((n, i) => tone(NOTE(n), NOTE(n), i === 7 ? 0.7 : 0.11, 'square', 0.05, i * 0.085)); tone(NOTE(96), NOTE(96), 0.8, 'sine', 0.04, 0.7); },
  clear(){ [72, 72, 72, 76, 79, 84].forEach((n, i) => tone(NOTE(n), NOTE(n), i === 5 ? 0.6 : 0.12, 'square', 0.05, [0, 0.12, 0.24, 0.36, 0.5, 0.66][i])); },
  count(n){ const hi = n <= 3; tone(hi ? 1320 : 880, hi ? 1320 : 880, hi ? 0.16 : 0.09, 'square', hi ? 0.07 : 0.05); if (hi) tone(NOTE(88), NOTE(88), 0.14, 'triangle', 0.05, 0.03); },
  gameclear(){ [72, 76, 79, 84, 79, 84, 88].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.11, 'square', 0.06, i * 0.08)); [84, 88, 91, 96].forEach(n => tone(NOTE(n), NOTE(n), 1.1, 'triangle', 0.045, 0.6)); hiss(0.9, 0.05, 6000, 2500, 'highpass', 1, 0.6); },
  over(){ [67, 64, 60, 55].forEach((n, i) => tone(NOTE(n), NOTE(n) * 0.97, 0.22, 'triangle', 0.07, i * 0.18)); },
};
// 同じ音を重ねすぎない間隔（秒）
const SFX_GAP = { tick:0.03, hit:0.05, pop:0.035, shoot:0.05, gem:0.03, zap:0.06, swish:0.08, throwcap:0.08 };
function sfx(name, arg){
  if (!AC || !soundOn || !SFX[name]) return;
  const now = AC.currentTime;
  if (lastPlay[name] && now - lastPlay[name] < (SFX_GAP[name] || 0.02)) return;
  lastPlay[name] = now;
  try { SFX[name](arg); } catch(e){}
}
let toastT = 0;
function toast(s, sale){ const t = $('toast'); t.textContent = s; t.className = sale ? 'sale' : ''; t.hidden = false; toastT = 2.4; }

// ---------- ヘルパー ----------
const rnd = (a, b) => a + Math.random() * (b - a);
const d2 = (a, b) => (a.x - b.x) ** 2 + (a.y - b.y) ** 2;
function nearest(from, maxD = Infinity, skip){
  let best = null, bd = maxD * maxD;
  for (const e of G.enemies){ if (e.dead || (skip && skip.has(e))) continue; const d = d2(from, e); if (d < bd){ bd = d; best = e; } }
  return best;
}
function hurt(e, dmg, kx = 0, ky = 0){
  if (e.dead) return;
  const cr = Math.random() < S.crit;
  const d = dmg * S.dmg * (cr ? 2 : 1);
  e.hp -= d; e.flash = 0.08; e.hitAt = G.t; sfx('hit');
  const k = e.type === 'boss' ? 0.1 : 1; e.vx += kx * k; e.vy += ky * k;
  if (G.texts.length < 70) G.texts.push({x:e.x + rnd(-6, 6), y:e.y - e.r, v:Math.round(d) + (cr ? '!' : ''), life:0.55, col:cr ? '#E0604A' : null, crit:cr});
  if (e.hp <= 0) kill(e);
}
function kill(e){
  e.dead = true; G.kills++;
  sfx('pop');
  const big = e.type === 'boss';
  for (let i = 0; i < (big ? 40 : 7) && G.parts.length < 300; i++){
    const a = rnd(0, TAU), s = rnd(60, big ? 320 : 170);
    G.parts.push({x:e.x, y:e.y, vx:Math.cos(a) * s, vy:Math.sin(a) * s, life:rnd(0.25, big ? 0.9 : 0.5), col:i % 3 ? e.col : '#FFF4C2', r:rnd(2, big ? 6 : 4)});
  }
  if (G.fx.length < 60) G.fx.push({k:'ring', x:e.x, y:e.y, r0:e.r * 0.5, r1:e.r * (big ? 4 : 2.2), col:e.col, life:big ? 0.6 : 0.28, max:big ? 0.6 : 0.28});
  if (G.fx.length < 80) G.fx.push({k:'burst', x:e.x, y:e.y, s:e.r * (big ? 5 : 2.8), life:big ? 0.4 : 0.2, max:big ? 0.4 : 0.2});
  // やられた絵を少しだけ残して、けむりと一緒に消す（ボスは倒れた絵）
  { const dn = big ? bossSpr(e) + '-down' : enemySpr(e) + '-hit', w = e.r * (big ? 2.7 : e.r < 13 ? 3 : 2.6);
    if (SPR[dn] && G.fx.length < 100) G.fx.push({k:'gone', n:dn, x:e.x, y:e.y, w, life:big ? 1 : 0.24, max:big ? 1 : 0.24});
    if (SPR['fx-smoke'] && G.fx.length < 100) G.fx.push({k:'smoke', x:e.x, y:e.y, s:e.r * (big ? 5 : 2.6), life:big ? 0.8 : 0.34, max:big ? 0.8 : 0.34}); }
  if (big){
    G.items.push(clearSpot({x:e.x, y:e.y, type:'chest'})); G.boss = null; G.shake = reduceMotion ? 0 : 14;
    G.fx.push({k:'ring', x:e.x, y:e.y, r0:e.r, r1:e.r * 7, col:'#F4B400', life:0.9, max:0.9});
    sfx('bossdie');
  }
  if (G.gems.length < 320) G.gems.push(clearSpot({x:e.x, y:e.y, v:e.xp, mag:false}));
  else { const g = G.gems[(Math.random() * G.gems.length) | 0]; g.v += e.xp; }
  const r = Math.random() / S.luck;
  if (r < 0.008) G.items.push(clearSpot({x:e.x + 8, y:e.y, type:'heal'}));
  else if (r < 0.012) G.items.push(clearSpot({x:e.x + 8, y:e.y, type:'mag'}));
  if (e.elite && Math.random() < 0.25 * S.luck) G.items.push(clearSpot({x:e.x - 8, y:e.y, type:'chest'}));
  // 錆の塊は割れる
  if (e.type === 'split') for (let i = 0; i < 3; i++){ const a = i / 3 * TAU; const c = spawn('rust', {x:e.x + Math.cos(a) * 20, y:e.y + Math.sin(a) * 20}); c.age = 0.25; }
}

// ---------- 敵の出現 ----------
function spawnPos(){
  // クライマックスは画面の端のすぐ内側に出す（外から来ると、見える前に倒されて「大量」に見えないため）
  const a = rnd(0, TAU), dist = G.mode === 'rush' ? Math.min(VW, VH) / 2 * rnd(0.85, 1.05) : Math.hypot(VW, VH) / 2 + 40;
  return {x:G.p.x + Math.cos(a) * dist, y:G.p.y + Math.sin(a) * dist};
}
function spawn(type, pos){
  const b = ET[type], p = pos || spawnPos();
  const D = diff();
  const boss = type === 'boss';
  const hpMul = boss ? D.bossHp(G.t, G.bossN) : D.hp(G.t);
  const e = {type, x:p.x, y:p.y, r:b.r, hp:b.hp * hpMul, max:b.hp * hpMul, sp:b.sp * rnd(0.9, 1.1) * (!boss && D.speed ? D.speed(G.t) : 1), dmg:b.dmg * (boss ? D.bossDmg(G.t) : D.dmg(G.t)), xp:b.xp, col:b.col,
    vx:0, vy:0, flash:0, cdAe:0, dead:false, wob:rnd(0, TAU), tick:rnd(1, 2.6)};
  // エリート：強い個体（エンドレスの4分〜）。金の輪で見分ける。宝箱を落とすことがある
  if (type !== 'boss' && !pos && Math.random() < D.elite(G.t)){
    e.elite = true; e.r *= 1.35; e.hp *= 6; e.max *= 6; e.dmg *= 1.5; e.xp *= 5; e.sp *= 0.9;
  }
  if (type === 'heat' && endless() && G.t > 150 && Math.random() < 0.25){ e.dasher = true; e.dcd = rnd(1, 3); }   // 突進はエンドレスだけ
  const ab = e.dasher ? 'dash' : type;
  if (ABIL_MSG[ab] && !G.seenAb[ab]){ G.seenAb[ab] = true; toast(ABIL_MSG[ab]); }
  G.enemies.push(e);
  return e;
}
function pickType(){
  if (G.mode === 'rush') return pickOne(['spark', 'spark', 'heat', 'rust']);   // 特別な動きをする敵は出さない
  const t = G.t;
  const w = [['spark',60],['heat',t > 20 ? 30 : 0],['rust',t > 50 ? 25 : 0],['resist',t > 100 ? 15 + t / 20 : 0],
    ['noise', t > 120 ? 25 + t / 20 : 0], ['shooter', t > 180 ? 8 + t / 60 : 0], ['split', t > 240 ? 6 + t / 80 : 0], ['coil', t > 150 && endless() ? 3 + t / 160 : 0]];   // 磁界コイルはエンドレスだけ
  let r = Math.random() * w.reduce((s, x) => s + x[1], 0);
  for (const [k, v] of w){ if ((r -= v) < 0) return k; }
  return 'spark';
}

// ---------- 武器 ----------
function fireWeapons(dt){
  const P = G.p;
  for (const g of G.order){
    const L = G.lv_[g];
    if (GROUPS[g].kind !== 'w' || g === 'alu' || g === 'thermo') continue;
    G.timers[g] -= dt;
    if (G.timers[g] > 0) continue;
    const pw = wp(g);
    if (g === 'spark'){
      G.timers[g] = Math.max(0.25, (1.0 - 0.1 * (L >= 3) - 0.1 * (L >= 5) - 0.1 * (L >= 8) - 0.03 * L) * S.cd);
      const tg = nearest(P, 520);
      const base = tg ? Math.atan2(tg.y - P.y, tg.x - P.x) : P.face;
      const n = (L >= 8 ? 7 : L >= 6 ? 5 : 3) + S.amount, dmg = (7 + 3 * L + 4 * (L >= 5) + 6 * (L >= 7)) * pw;
      for (let i = 0; i < n; i++){
        const a = base + (i - (n - 1) / 2) * 0.16;
        G.bullets.push({kind:'spark', x:P.x, y:P.y, vx:Math.cos(a) * 430, vy:Math.sin(a) * 430, r:5, dmg, pierce:L >= 7 ? 3 : L >= 4 ? 2 : 1, life:1.1, hit:new Set()});
      }
      sfx('shoot');
    } else if (g === 'ti'){
      G.timers[g] = Math.max(0.4, (1.4 - (L >= 4 ? 0.3 : 0) - (L >= 8 ? 0.25 : 0)) * S.cd);
      const n = [0,1,1,2,2,3,4,5,5][L] + S.amount, dmg = (14 + 5 * L + 8 * (L >= 6) + 20 * (L >= 8)) * pw;
      const tgT = nearest(P, 480);
      const aimT = tgT ? Math.atan2(tgT.y - P.y, tgT.x - P.x) : P.face;   // 近くの敵へ（逃げながらでも当たるように）
      for (let i = 0; i < n; i++){
        const a = aimT + (i - (n - 1) / 2) * 0.22;
        G.bullets.push({kind:'ti', x:P.x, y:P.y, vx:Math.cos(a) * 520, vy:Math.sin(a) * 520, r:8, dmg, pierce:999, life:1.3, hit:new Set()});
      }
    } else if (g === 'band'){
      G.timers[g] = Math.max(0.9, (2.6 - (L >= 4 ? 0.6 : 0) - 0.08 * L) * S.cd);
      const max = (85 + 22 * ((L >= 2) + (L >= 5) + (L >= 6)) + 4 * L) * S.area;
      const dmg = (12 + 3 * L + 6 * ((L >= 3) + (L >= 6)) + 18 * (L >= 8)) * pw;
      G.rings.push({r:10, max, dmg, hit:new Set()}); sfx('ring');
      if (L >= 7) G.rings.push({r:-60, max, dmg, hit:new Set()});   // 2重のリング（少し遅れて広がる）
    } else if (g === 'copper'){
      G.timers[g] = Math.max(0.55, (1.6 - (L >= 4 ? 0.3 : 0) - 0.05 * L) * S.cd);
      const jumps = 3 + (L >= 2) + (L >= 4) + (L >= 5) + (L >= 6) + 2 * (L >= 7) + S.amount;
      const dmg = (10 + 3 * L + 5 * ((L >= 3) + (L >= 6))) * pw;
      const hit = new Set();
      for (let k = 0; k < (L >= 8 ? 2 : 1); k++){   // Lv8：2本の電撃
        const pts = [{x:P.x, y:P.y}];
        let tg = nearest(P, 300, hit);
        for (let i = 0; i < jumps && tg; i++){
          hit.add(tg); pts.push({x:tg.x, y:tg.y}); hurt(tg, dmg);
          tg = nearest(tg, 170, hit);
        }
        if (pts.length > 1){ G.lines.push({pts, life:0.18}); sfx('zap'); }
      }
    } else if (g === 'blade'){
      // 近距離：向いている方向を扇形に斬る。Lv4 で前後、Lv6 で全周
      G.timers[g] = Math.max(0.35, (0.95 - (L >= 5 ? 0.25 : 0) - 0.03 * L) * S.cd);
      const rad = (72 + 16 * (L >= 3) + 14 * (L >= 7) + 3 * L) * S.area, dmg = (12 + 4 * L + 10 * (L >= 7)) * pw;
      if (L >= 8 && !G.bladeEcho){ G.bladeEcho = 0.18; }   // Lv8：少しあとにもう一度斬る
      const span = L >= 6 ? TAU : 2.2;
      const tgB = nearest(P, rad + 60);
      const aimB = tgB ? Math.atan2(tgB.y - P.y, tgB.x - P.x) : P.face;   // 近くの敵の方向を斬る
      const dirs = L >= 6 ? [aimB] : L >= 4 ? [aimB, aimB + Math.PI] : [aimB];
      for (const a0 of dirs){
        G.slashes.push({a:a0, span, r:rad, life:0.18});
        for (const e of G.enemies){
          if (e.dead) continue;
          const dx = e.x - P.x, dy = e.y - P.y, d = Math.hypot(dx, dy);
          if (d > rad + e.r) continue;
          let da = Math.atan2(dy, dx) - a0; da = Math.atan2(Math.sin(da), Math.cos(da));
          if (span < TAU && Math.abs(da) > span / 2) continue;
          hurt(e, dmg, dx / (d || 1) * 220, dy / (d || 1) * 220);
        }
      }
      sfx('swish');
    } else if (g === 'nuke'){
      // 全滅必殺技：画面に見えている敵すべてに大ダメージ
      G.timers[g] = Math.max(5, (17 - 2 * ((L >= 3) + (L >= 5) + (L >= 7)) - 0.3 * L) * S.cd);
      const dmg = (45 + 18 * L + 40 * ((L >= 2) + (L >= 4)) + 120 * (L >= 8)) * pw;
      const hw = VW / 2 + 20, hh = VH / 2 + 20;
      for (const e of G.enemies){
        if (!e.dead && Math.abs(e.x - P.x) < hw && Math.abs(e.y - P.y) < hh) hurt(e, dmg);
      }
      if (L >= 6) for (const gm of G.gems) gm.mag = true;
      G.flash = 0.45; G.shake = reduceMotion ? 0 : 8;
      sfx('nuke'); G.fx.push({k:'nuke', life:0.7, max:0.7});
    } else if (g === 'boomer'){
      // 行って戻るキャップ。行きと帰りでそれぞれ当たる
      G.timers[g] = Math.max(0.6, (1.7 - 0.08 * L) * S.cd);
      const n = [0,1,1,2,2,3,4,5,5][L] + S.amount, dmg = (10 + 4 * L + 8 * (L >= 6) + 18 * (L >= 8)) * pw;
      const sp = L >= 4 ? 460 : 380, out = L >= 4 ? 0.55 : 0.45;
      const tg = nearest(P, 400);
      const base = tg ? Math.atan2(tg.y - P.y, tg.x - P.x) : P.face;
      sfx('throwcap');
      for (let i = 0; i < n; i++){
        const a = base + (i - (n - 1) / 2) * 0.5;
        G.bullets.push({kind:'boom', x:P.x, y:P.y, vx:Math.cos(a) * sp, vy:Math.sin(a) * sp, sp, r:9, dmg, pierce:999, life:3, t:0, out, back:false, hit:new Set()});
      }
    } else if (g === 'fluid'){
      G.timers[g] = Math.max(1.1, (3.0 - (L >= 4 ? 0.8 : 0) - 0.1 * L) * S.cd);
      const rad = (42 + 8 * ((L >= 2) + (L >= 6) + (L >= 8)) + 3 * L) * S.area;
      const dps = (12 + 3 * L + 6 * ((L >= 3) + (L >= 6)) + 12 * (L >= 8)) * pw;
      const dur = 2.5 + (L >= 5 ? 1.2 : 0);
      const hit = new Set();
      for (let k = 0; k < (L >= 7 ? 2 : 1); k++){   // Lv7：2か所にまく
        const tg = nearest(P, 260, hit); if (tg) hit.add(tg);
        G.puddles.push({x:tg ? tg.x : P.x + rnd(-100, 100), y:tg ? tg.y : P.y + rnd(-100, 100), r:rad, dps, life:dur, max:dur, tick:0, hue:Math.random() < 0.5 ? 0 : 1, seed:(Math.random() * 1e6) | 0});
      }
    }
  }

  if (G.bladeEcho != null){
    G.bladeEcho -= dt;
    if (G.bladeEcho <= 0){
      G.bladeEcho = null;
      const L = G.lv_.blade, rad = (72 + 16 + 14 + 3 * L) * S.area, dmg = (12 + 4 * L + 10) * wp('blade');
      G.slashes.push({a:P.face + Math.PI / 2, span:TAU, r:rad, life:0.18});
      for (const e of G.enemies){ const dx = e.x - P.x, dy = e.y - P.y, d = Math.hypot(dx, dy); if (!e.dead && d < rad + e.r) hurt(e, dmg, dx / (d || 1) * 220, dy / (d || 1) * 220); }
      sfx('swish');
    }
  }
  const La = G.lv_.alu;
  if (La){
    const n = [0,2,2,3,3,4,5,6,6][La] + Math.ceil(S.amount / 2), rad = (62 + (La >= 4 ? 18 : 0) + (La >= 8 ? 20 : 0) + 3 * La) * S.area, dmg = (6 + 2 * La + 3 * (La >= 2) + 5 * (La >= 7) + 10 * (La >= 8)) * wp('alu');
    G.aeAng += (2.6 + (La >= 4 ? 0.8 : 0) + (La >= 8 ? 1 : 0)) * dt;
    G.aePlates = [];
    for (let k = 0; k < n; k++){
      const a = G.aeAng + k * TAU / n, px = P.x + Math.cos(a) * rad, py = P.y + Math.sin(a) * rad;
      G.aePlates.push({x:px, y:py, a});
      for (const e of G.enemies){
        if (e.dead || e.cdAe > 0) continue;
        const rr = e.r + 12;
        if ((e.x - px) ** 2 + (e.y - py) ** 2 < rr * rr){
          const dx = e.x - P.x, dy = e.y - P.y, d = Math.hypot(dx, dy) || 1;
          hurt(e, dmg, dx / d * 120, dy / d * 120); e.cdAe = 0.45;
        }
      }
    }
  } else G.aePlates = null;

  const Ls = G.lv_.thermo;
  if (Ls){
    G.sbRad = (48 + 10 * ((Ls >= 2) + (Ls >= 4) + (Ls >= 6)) + 3 * Ls) * S.area;
    G.sbT -= dt;
    if (G.sbT <= 0){
      G.sbT = 0.3;
      const dps = (9 + 2 * Ls + 6 * ((Ls >= 3) + (Ls >= 5) + (Ls >= 6)) + 16 * (Ls >= 8)) * wp('thermo');
      for (const e of G.enemies){ const rr = G.sbRad + e.r; if (!e.dead && d2(e, P) < rr * rr) hurt(e, dps * 0.3); }
    }
  } else G.sbRad = 0;
}

// ---------- 更新 ----------
function update(dt){
  const P = G.p;
  if (G.pre > 0){   // クライマックスの「3・2・1」
    const n0 = Math.ceil(G.pre); G.pre -= dt; const n1 = Math.ceil(G.pre);
    if (n1 !== n0) sfx(n1 > 0 ? 'count' : 'reach', n1);
    return;
  }
  G.t += dt;

  const iv = inputVec();
  if (iv.x || iv.y) P.face = Math.atan2(iv.y, iv.x);
  const sp = 155 * S.speed * (G.slow ? Math.min(1, (endless() ? 0.7 : 0.88) + 0.04 * lvOf('speed')) : 1);   // 移動速度のパーツで減速を受けにくく（1分・3分は軽く）
  P.x += iv.x * sp * dt; P.y += iv.y * sp * dt;
  // 引き寄せ：いくつ重なっても自機の速さの85%まで（全力で逃げれば少しずつ離れられる）
  const pm = Math.hypot(G.pullX, G.pullY), pcap = 155 * S.speed * 0.85;
  if (pm > 0){ const k = Math.min(1, pcap / pm) * pullRes(); P.x += G.pullX * k * dt; P.y += G.pullY * k * dt; }
  pushOut(P, P.r);   // 障害物と川
  P.moving = !!(iv.x || iv.y);
  if (P.moving){
    P.dist = (P.dist || 0) + sp * dt;
    // 走るときの砂ぼこり
    if (Math.random() < 0.45 && G.parts.length < 260){
      const bx = P.x - Math.cos(P.face) * 18, by = P.y - Math.sin(P.face) * 18;
      G.parts.push({x:bx + rnd(-6, 6), y:by + rnd(-6, 6), vx:-Math.cos(P.face) * 30 + rnd(-15, 15), vy:-Math.sin(P.face) * 30 + rnd(-15, 15), life:rnd(0.25, 0.45), col:'#D2EADB', r:rnd(2, 4.5), dust:true});
    }
  }
  if (P.inv > 0) P.inv -= dt;
  P.hp = Math.min(P.maxHp, P.hp + S.regen * dt);

  const D = diff();
  G.spawnAcc += dt * D.spawn(G.t);
  const cap = D.cap(G.t);
  while (G.spawnAcc >= 1){ G.spawnAcc--; if (G.enemies.length < cap) spawn(pickType()); }
  // エンドレス：10分到達の演出（続けて走れる）
  if (G.mode === 'endless' && !G.reached10 && G.t >= 600){
    G.reached10 = true; toast('10分到達！ 上位1%の走りです'); sfx('clear');
    G.fx.push({k:'lvup', life:1.4, max:1.4});
  }
  if (G.waves.length && G.t >= G.waves[0]){
    const wt = G.waves.shift(); if (endless()) G.waves.push(wt + 60);
    const n = endless() ? 20 + Math.floor(G.t / 8) : G.mode === 'rush' ? 40 : 12 + Math.floor(G.t / 12), dist = Math.hypot(VW, VH) / 2 + 20;   // 1分・3分は大群を少なめに
    const type = G.t > 100 ? 'heat' : 'spark';
    for (let i = 0; i < n; i++){ const a = i / n * TAU; spawn(type, {x:P.x + Math.cos(a) * dist, y:P.y + Math.sin(a) * dist}); }
    toast('静電気の大群が来た！'); sfx('wave');
  }
  // 天候イベント（濃霧・大雨・電圧ダウン）：見える範囲が狭くなる。始まると近くにライトが1つ落ちる
  if (!G.wx && G.t >= G.wxNext){
    const k = pickOne(['fog', 'rain'].concat(G.t >= 240 ? ['dark', 'dark'] : [])), dur = 18 + Math.random() * 7;
    G.wx = {k, t:0, dur};
    G.wxNext = endless() ? G.t + dur + 80 + Math.random() * 20 : 1e9;
    toast(WX[k].msg); sfx(k === 'dark' ? 'blackout' : 'wave');
  }
  if (G.wx){
    G.wx.t += dt;
    if (G.wx.t >= G.wx.dur){ G.wx = null; toast('視界が戻った'); }
  }
  // ボスの2.5秒前に警告の帯
  if (G.bossAt.length && G.bossAt[0] - G.t <= 2.5 && G.warned !== G.bossAt[0]){
    G.warned = G.bossAt[0]; G.warn = 2.5; sfx('warn');
  }
  if (G.warn > 0) G.warn -= dt;
  if (G.bossAt.length && G.t >= G.bossAt[0]){
    const bt = G.bossAt.shift(); G.bossN++; if (endless()) G.bossAt.push(bt + 90);
    G.boss = spawn('boss');
    const big = endless() ? G.bossN % 3 === 0 : G.mode === 'c3' && G.bossN === 3;
    G.boss.name = big ? '大放電・極' : '大放電';
    if (big){ G.boss.r = 54; }
    toast(G.boss.name + ' が現れた！');
  }

  fireWeapons(dt);

  for (const b of G.bullets){
    if (b.kind === 'boom'){
      b.t += dt;
      if (!b.back && b.t >= b.out){ b.back = true; b.hit = new Set(); }
      if (b.back){
        const dx = P.x - b.x, dy = P.y - b.y, d = Math.hypot(dx, dy) || 1;
        b.vx = dx / d * b.sp * 1.15; b.vy = dy / d * b.sp * 1.15;
        if (d < 18) b.life = 0;
      }
    }
    b.x += b.vx * dt; b.y += b.vy * dt; b.life -= dt;
    if (b.life <= 0) continue;
    for (const e of G.enemies){
      if (e.dead || b.hit.has(e)) continue;
      const rr = e.r + b.r;
      if ((e.x - b.x) ** 2 + (e.y - b.y) ** 2 < rr * rr){
        const s = Math.hypot(b.vx, b.vy) || 1;
        hurt(e, b.dmg, b.vx / s * 90, b.vy / s * 90); b.hit.add(e);
        if (--b.pierce <= 0){ b.life = 0; break; }
      }
    }
  }
  G.bullets = G.bullets.filter(b => b.life > 0);

  for (const r of G.rings){
    r.r += (r.max / 0.35) * dt;
    for (const e of G.enemies){
      if (e.dead || r.hit.has(e)) continue;
      const d = Math.sqrt(d2(e, P));
      if (Math.abs(d - r.r) < e.r + 10){ r.hit.add(e); const dd = d || 1; hurt(e, r.dmg, (e.x - P.x) / dd * 260, (e.y - P.y) / dd * 260); }
    }
  }
  G.rings = G.rings.filter(r => r.r < r.max);
  for (const l of G.lines) l.life -= dt;
  G.lines = G.lines.filter(l => l.life > 0);
  for (const p of G.puddles){
    p.life -= dt; p.tick -= dt;
    // しずくが落ちて（0.18秒）から広がる。着いた瞬間にしぶき
    if (!p.landed){
      if (p.max - p.life < PUD_DROP) continue;
      p.landed = true;
      for (let i = 0; i < 12; i++){ const a = rnd(0, TAU), v = rnd(110, 230); G.parts.push({x:p.x, y:p.y, vx:Math.cos(a) * v, vy:Math.sin(a) * v * 0.8, life:rnd(0.25, 0.45), col:PUD[p.hue].mid, r:rnd(2, 4.5)}); }
    }
    if (p.tick <= 0){
      p.tick = 0.3; let n = 0;
      for (const e of G.enemies){
        const rr = p.r + e.r * 0.5;
        if (e.dead || d2(e, p) >= rr * rr) continue;
        hurt(e, p.dps * 0.3);
        if (n++ < 4 && Math.random() < 0.6) G.parts.push({x:e.x + rnd(-6, 6), y:e.y - 4, vx:rnd(-12, 12), vy:-rnd(35, 70), life:rnd(0.3, 0.5), col:'rgba(255,255,255,.85)', r:rnd(2.5, 4.5), dust:true});   // 溶ける湯気
      }
    }
  }
  G.puddles = G.puddles.filter(p => p.life > 0);

  const far2 = (Math.hypot(VW, VH) * 0.85) ** 2;
  let pullX = 0, pullY = 0, slow = false;
  for (const e of G.enemies){
    if (e.dead) continue;
    const dx = P.x - e.x, dy = P.y - e.y, d = Math.hypot(dx, dy) || 1;
    e.wob += dt * 6;
    let sp = e.sp;
    if (e.type === 'heat') sp *= 1 + 0.25 * Math.sin(e.wob);
    // 突進：止まって赤い線で狙う（0.55秒）→ その向きへ一気に
    if (e.dasher){
      e.dcd -= dt;
      if (e.dashW > 0){ sp = 0; e.dashW -= dt; if (e.dashW <= 0){ e.dashGo = 0.42; sfx('swish'); } }
      else if (e.dashGo > 0){ sp = 0; e.dashGo -= dt; e.x += e.dashVX * dt; e.y += e.dashVY * dt; }
      else if (e.dcd <= 0 && d > 90 && d < 330){ e.dcd = rnd(4, 6); e.dashW = 0.7; e.dashVX = dx / d * 380; e.dashVY = dy / d * 380; }
    }
    // 引力：磁界コイルの近く
    if (e.type === 'coil'){
      e.pulling = d < COIL_R;
      if (e.pulling){ const f = 20 + 60 * (1 - d / COIL_R); pullX -= dx / d * f; pullY -= dy / d * f; }   // 近いほど強く、最大で自機の速さの半分ほど
    }
    // 減速：抵抗のまわり
    if (e.type === 'resist' && d < RESIST_R + P.r) slow = true;
    // ボスの引力：1.2秒の予告のあと2.5秒引き寄せる（13秒ごと）
    if (e.type === 'boss'){
      e.pcd = (e.pcd == null ? 8 : e.pcd) - (endless() ? dt : 0);   // ボスの引力はエンドレスだけ
      if (e.pcd <= 0 && !(e.pullOn > 0)){ e.pullOn = 3.7; e.pcd = 16; toast(e.name + 'が引き寄せてくる！'); sfx('warn'); }
      if (e.pullOn > 0){
        e.pullOn -= dt;
        if (e.pullOn < 2.5 && d < BOSS_PULL_R){ const f = 30 + 90 * (1 - d / BOSS_PULL_R); pullX -= dx / d * f; pullY -= dy / d * f; }
      }
    }
    if (e.type === 'shooter'){
      if (d < 220) sp = -sp * 0.6;              // 近すぎたら下がる
      else if (d < 280) sp = 0;
      e.tick -= dt;
      if (e.tick <= 0 && d < 520){
        e.tick = 2.6;
        const s2 = 170;
        G.ebullets.push({x:e.x, y:e.y, vx:dx / d * s2, vy:dy / d * s2, r:6, dmg:10 * diff().dmg(G.t), life:4});
      }
    }
    if (G.lv_.thermo >= 7 && G.sbRad && d < G.sbRad + e.r) sp *= 0.6;   // 熱のオーラ Lv7：遅くする
    e.x += (dx / d * sp + e.vx) * dt; e.y += (dy / d * sp + e.vy) * dt;
    // 地上の敵は障害物と川に沿って回り込む（ぶつかった面に沿って横へずれる）
    if (!FLIES[e.type]){
      const n = pushOut(e, e.r * 0.9);
      if (n && sp > 0){
        let tx = dx / d - (dx / d * n.x + dy / d * n.y) * n.x, ty = dy / d - (dx / d * n.x + dy / d * n.y) * n.y, tm = Math.hypot(tx, ty);
        if (tm < 0.35){ e.side = e.side || (Math.random() < 0.5 ? 1 : -1); tx = -n.y * e.side; ty = n.x * e.side; tm = 1; }
        e.x += tx / tm * sp * 0.8 * dt; e.y += ty / tm * sp * 0.8 * dt;
        if (e.dashGo > 0) e.dashGo = 0;   // 突進は障害物で止まる
      }
    }
    const dec = Math.exp(-8 * dt); e.vx *= dec; e.vy *= dec;
    if (e.flash > 0) e.flash -= dt;
    if (e.cdAe > 0) e.cdAe -= dt;
    e.age = (e.age || 0) + dt;
    if (e.type === 'boss'){
      e.tick -= dt;
      if (e.tick <= 0){ e.tick = 3.5; for (let i = 0; i < 8; i++){ const a = i / 8 * TAU; spawn('spark', {x:e.x + Math.cos(a) * 60, y:e.y + Math.sin(a) * 60}); } }
    } else if (d * d > far2){ const p = spawnPos(); e.x = p.x; e.y = p.y; }
    if (d < e.r + P.r - 2 && P.inv <= 0 && G.mode !== 'rush'){
      P.hp -= e.dmg * (e.dashGo > 0 ? Math.max(1, 1.4 - 0.08 * lvOf('armor')) : 1) * (1 - S.armor); P.inv = endless() ? 0.7 : 1.0;   // 1分・3分は無敵時間を長めに
      G.shake = reduceMotion ? 0 : 6; G.hurtFlash = 0.25;
      sfx('hurt');
    }
  }
  G.pullX = pullX; G.pullY = pullY; G.slow = slow;
  separate();
  G.enemies = G.enemies.filter(e => !e.dead);
  for (const b of G.ebullets){
    b.x += b.vx * dt; b.y += b.vy * dt; b.life -= dt;
    if (P.inv <= 0 && (b.x - P.x) ** 2 + (b.y - P.y) ** 2 < (b.r + P.r - 3) ** 2){
      b.life = 0; P.hp -= b.dmg * (1 - S.armor); P.inv = 0.5; G.hurtFlash = 0.2; sfx('hurt');
    }
  }
  G.ebullets = G.ebullets.filter(b => b.life > 0);

  const mag2 = S.magnet * S.magnet;
  for (const g of G.gems){
    const dd = d2(g, P);
    if (!g.mag && dd < mag2) g.mag = true;
    if (g.mag){ const d = Math.sqrt(dd) || 1, s = 440 * dt; g.x += (P.x - g.x) / d * Math.min(s, d); g.y += (P.y - g.y) / d * Math.min(s, d); }
    if (dd < (P.r + 6) ** 2){ g.got = true; gainXp(g.v); }
  }
  G.gems = G.gems.filter(g => !g.got);

  for (const it of G.items){
    if (d2(it, P) < (P.r + 14) ** 2){
      it.got = true;
      if (it.type === 'heal'){ P.hp = Math.min(P.maxHp, P.hp + 35); floatText(P, 'HP+35', '#1FA35C'); }
      else if (it.type === 'mag'){ for (const g of G.gems) g.mag = true; floatText(P, 'ポイント全回収！', '#8A5F00'); }
      else if (it.type === 'chest'){ G.pending++; G.chest++; G.lots = (G.lots || 0) + 1; floatText(P, '宝箱！', '#8A5F00'); }
      sfx(it.type === 'chest' ? 'chest' : 'item');
    }
  }
  G.items = G.items.filter(i => !i.got);

  for (const p of G.parts){ p.x += p.vx * dt; p.y += p.vy * dt; p.life -= dt; }
  G.parts = G.parts.filter(p => p.life > 0);
  for (const t of G.texts){ t.y -= 30 * dt; t.life -= dt; }
  G.texts = G.texts.filter(t => t.life > 0);
  if (G.shake > 0) G.shake = Math.max(0, G.shake - dt * 30);
  if (G.hurtFlash > 0) G.hurtFlash -= dt;
  if (G.flash > 0) G.flash -= dt;
  for (const sl of G.slashes) sl.life -= dt;
  G.slashes = G.slashes.filter(sl => sl.life > 0);
  for (const f of G.fx) f.life -= dt;
  G.fx = G.fx.filter(f => f.life > 0);

  if (P.hp <= 0 && G.revived < lvOf('revive')){
    // 復活：HP半分・2.5秒の無敵・周りの敵を吹き飛ばす
    G.revived++; P.hp = P.maxHp * 0.5; P.inv = 2.5;
    for (const e of G.enemies){ const dx = e.x - P.x, dy = e.y - P.y, d = Math.hypot(dx, dy) || 1; if (d < 260){ hurt(e, 60, dx / d * 600, dy / d * 600); } }
    G.ebullets = []; G.flash = 0.5; toast('復活！ のこり ' + (lvOf('revive') - G.revived) + ' 回'); sfx('levelup');
    G.fx.push({k:'ring', x:P.x, y:P.y, r0:20, r1:260, col:'#1FA35C', life:0.7, max:0.7});
  }
  if (P.hp <= 0){ P.hp = 0; endGame(false); return; }
  // 1分・3分の終わり（10/11 依頼者「時間がきた瞬間に切り替わるので唐突」）：残り30秒で合図、残り10秒から大きな数字、
  // 時間が来たら GAME CLEAR の演出（CLEAR_SEC 秒）を見せてから結果の画面へ
  if (MODES[G.mode].win){
    const left = MODES[G.mode].win - G.t;
    if (left <= 0){ startClear(); return; }
    if (left <= 30 && !G.cd30 && G.mode !== 'rush'){ G.cd30 = true; toast('ラストスパート！ クリアまであと30秒'); sfx('reach'); }
    if (left <= 10){ const n = Math.ceil(left); if (n !== G.cdLast){ G.cdLast = n; sfx('count', n); } }
  }
  // レベルアップは0.35秒だけ光の輪を見せてから選択画面へ
  if (G.pending > 0){
    if (G.lvDelay == null){
      G.lvDelay = G.chest > 0 ? 0.15 : 0.35;
      if (!G.chest){ sfx('levelup'); G.fx.push({k:'lvup', life:0.9, max:0.9}); }
    }
    G.lvDelay -= dt;
    if (G.lvDelay <= 0){ G.lvDelay = null; openLevelUp(); }
  }
}
function floatText(at, s, col){ G.texts.push({x:at.x, y:at.y - 26, v:s, life:1.1, col, big:true}); }
function gainXp(v){
  if (G.mode === 'rush'){ G.pts += v; return; }   // クライマックスはレベルアップの選びを出さない
  const gain = v * S.xp;
  G.pts += gain; G.xp += gain;
  // 続けて拾うと音が上がっていく（0.5秒あくと元に戻る）
  G.gemStep = (G.t - (G.gemAt || -9) < 0.5) ? Math.min(12, (G.gemStep || 0) + 1) : 0; G.gemAt = G.t;
  sfx('gem', G.gemStep);
  while (G.xp >= need(G.lv)){ G.xp -= need(G.lv); G.lv++; G.pending++; }
}
function separate(){
  const cell = 36, grid = new Map();
  for (const e of G.enemies){
    if (e.dead) continue;
    const k = ((e.x / cell) | 0) + ',' + ((e.y / cell) | 0);
    let a = grid.get(k); if (!a) grid.set(k, a = []); a.push(e);
  }
  for (const e of G.enemies){
    if (e.dead) continue;
    const cx = (e.x / cell) | 0, cy = (e.y / cell) | 0;
    for (let ox = -1; ox <= 1; ox++) for (let oy = -1; oy <= 1; oy++){
      const a = grid.get((cx + ox) + ',' + (cy + oy)); if (!a) continue;
      for (const o of a){
        if (o === e) continue;
        const dx = e.x - o.x, dy = e.y - o.y, min = (e.r + o.r) * 0.85, dd = dx * dx + dy * dy;
        if (dd < min * min && dd > 0.01){
          const d = Math.sqrt(dd), push = (min - d) * 0.25 * (e.type === 'boss' ? 0.1 : 1);
          e.x += dx / d * push; e.y += dy / d * push;
        }
      }
    }
  }
}

// ---------- 描画 ----------
// 32ビットの掛け算で（ふつうの掛け算だと桁があふれて 0〜0.5 しか出なかった）
function hash(x, y){ let h = (Math.imul(x | 0, 374761393) + Math.imul(y | 0, 668265263)) | 0; h = Math.imul(h ^ (h >>> 13), 1274126177); return ((h ^ (h >>> 16)) >>> 0) / 4294967296; }
function drawNut(x, y, r){
  ctx.beginPath();
  for (let i = 0; i < 6; i++){ const a = i / 6 * TAU + Math.PI / 6; ctx.lineTo(x + Math.cos(a) * r, y + Math.sin(a) * r); }
  ctx.closePath(); ctx.stroke();
  ctx.beginPath(); ctx.arc(x, y, r * 0.45, 0, TAU); ctx.stroke();
}
function mix(hex, t){
  const n = parseInt(hex.slice(1), 16), r = n >> 16, g = n >> 8 & 255, b = n & 255;
  const [tr, tg, tb] = t > 0 ? [255, 255, 255] : [30, 74, 53], k = Math.abs(t);
  return `rgb(${Math.round(r + (tr - r) * k)},${Math.round(g + (tg - g) * k)},${Math.round(b + (tb - b) * k)})`;
}
// 路面の細かな質感（一度だけ作って模様として敷く）
let PAVE = null;
function pavePattern(){
  if (PAVE) return PAVE;
  const c = document.createElement('canvas'); c.width = c.height = 192;
  const x = c.getContext('2d');
  x.fillStyle = C.ground; x.fillRect(0, 0, 192, 192);
  for (let i = 0; i < 900; i++){
    x.fillStyle = Math.random() < 0.55 ? 'rgba(255,255,255,.38)' : 'rgba(110,165,130,.16)';
    x.fillRect(Math.random() * 192, Math.random() * 192, 1 + Math.random() * 2, 1 + Math.random() * 2);
  }
  PAVE = ctx.createPattern(c, 'repeat');
  return PAVE;
}
/* ---------- 画像（依頼者が Gemini で作った絵を build_sprites.py で加工） ----------
   ストア版はテーマの assets（TERAISM_GAME.sprites に URL）、公開ページ版は同じ場所の sprites/ に置く。
   読み込めなかった絵は、これまでどおりプログラムで描く */
const SPR_NAMES = ['car', 'boss', 'enemy-spark', 'enemy-heat', 'enemy-rust', 'enemy-resist', 'item-point', 'item-heal', 'item-magnet', 'item-chest',
  // 第2弾（2026-10-07、依頼者が Gemini で作成。build_sprites2.py で切り出し）
  'enemy-noise', 'enemy-shooter', 'enemy-split', 'enemy-coil', 'boss-ex',
  'ob-garage', 'ob-car-1', 'ob-car-2', 'ob-car-3', 'ob-car-4', 'ob-container', 'ob-tree-1', 'ob-tree-2', 'ob-tree-3', 'ob-tires', 'ob-barrier',
  'fx-burst', 'fx-zap', 'lot-cardback',
  // 第3弾（2026-10-09〜）
  'w-ring', 'w-rod', 'w-plate',
  // 第4弾（2026-11-03、家庭用ゲームの質へ。build_v2.py）：やられた絵・ボスの差分・弾と効果
  'enemy-spark-hit', 'enemy-heat-hit', 'enemy-rust-hit', 'enemy-resist-hit', 'enemy-noise-hit', 'enemy-shooter-hit', 'enemy-split-hit', 'enemy-coil-hit',
  'boss-hit', 'boss-down', 'boss-ex-hit', 'boss-ex-down',
  'w-boom', 'w-spark', 'e-bullet', 'fx-smoke', 'fx-slash', 'fx-lvup'];
const SPR = {}, SPR_W = {};   // 絵と、当たった瞬間の白い版
const sprUrl = (n, ext) => (SHOPCFG && SHOPCFG.sprites && SHOPCFG.sprites[n]) || `sprites/${n}.${ext || 'png'}`;
for (const n of SPR_NAMES){
  const im = new Image();
  im.onload = () => {
    SPR[n] = im;
    const c = document.createElement('canvas'); c.width = im.width; c.height = im.height;
    const x = c.getContext('2d'); x.drawImage(im, 0, 0);
    x.globalCompositeOperation = 'source-atop'; x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height);
    SPR_W[n] = c;
    if (n.startsWith('ob-')) TILES.clear();   // 障害物は区画の絵に描き込んであるので作り直す
  };
  im.src = sprUrl(n);
}
let GROUND = null;
{ const im = new Image(); im.onload = () => { GROUND = ctx.createPattern(im, 'repeat'); TILES.clear(); }; im.src = sprUrl('ground', 'jpg'); }
// 地区ごとの地面のタイル（無ければ今までの色で塗る）
const ZT = {};
for (const k of ['park', 'parking', 'circuit', 'garage', 'river']){
  const im = new Image(); im.onload = () => { ZT[k] = ctx.createPattern(im, 'repeat'); TILES.clear(); }; im.src = sprUrl('tile-' + k, 'jpg');
}
// 障害物の絵：中心 cx、下の端 bottom、幅 w で描く（flip で左右反転）
function drawObSpr(n, cx, bottom, w, flip){
  const im = SPR[n], h = w * im.height / im.width;
  ctx.save(); ctx.translate(cx, bottom - h / 2); if (flip) ctx.scale(-1, 1);
  ctx.drawImage(im, -w / 2, -h / 2, w, h); ctx.restore();
}
// 絵を中心に置いて描く（w は幅。高さは絵の縦横比から）
function drawSpr(n, x, y, w, white){
  const im = (white && SPR_W[n]) || SPR[n];
  const h = w * im.height / im.width;
  ctx.drawImage(im, x - w / 2, y - h / 2, w, h);
}
function rr(x, y, w, h, r){ ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, w, h, r); else ctx.rect(x, y, w, h); }

// ---------- 背景の変化 ----------
// 道で区切られた1区画ごとに地区をくじで決める（同じ場所はいつも同じ地区）。色は明るめにして敵や弾を見やすく
const ZONE_KINDS = ['plain', 'park', 'parking', 'circuit', 'garage'];
const zoneOf = (bx, by) => ZONE_KINDS[Math.floor(hash(bx * 7 + 3, by * 5 - 11) * ZONE_KINDS.length) % ZONE_KINDS.length];
/* ---------- 通れない場所：障害物・川・橋 ----------
   障害物は区画の中（道から50以上内側）だけに置くので、当たり判定はその区画の分だけ調べればよい。
   川は横向きで、4区画ごとの道の位置を流れる。縦の道との交差点の一部に橋（3本に1本は必ず）。
   浮いている敵（静電気・ノイズ・ボス）は障害物も川も越える。弾は通り抜ける */
const RIVER_HW = 40, BRIDGE_HW = 42;
const isRiver = ry => (((ry % 4) + 4) % 4) === 2;
const bridgeAt = (cx, ry) => (((cx % 3) + 3) % 3) === 0 || hash(cx * 13 + 5, ry * 7 + 1) < 0.4;
const FLIES = {spark:true, noise:true, boss:true};
const OBS = new Map();
function blockObs(bx, by){
  const key = bx + ',' + by;
  let o = OBS.get(key);
  if (o) return o;
  const kind = zoneOf(bx, by), R = k => hash(bx * 131 + k * 7, by * 97 - k * 13);
  const X = bx * 576 + 50, Y = by * 576 + 50, S = 576 - 100;
  const at = (k, m) => [X + m + R(k) * (S - m * 2), Y + m + R(k + 500) * (S - m * 2)];
  o = {kind, X, Y, S, R, at, rects:[], circles:[], pond:null, trees:[], cars:[], tires:[], building:null, barriers:[], container:null};
  const free = (x, y, r) => !o.rects.some(c => x > c.x - r && x < c.x + c.w + r && y > c.y - r && y < c.y + c.h + r);
  if (kind === 'park'){
    if (R(1) < 0.4) o.pond = {x:X + S * (0.3 + R(2) * 0.4), y:Y + S * (0.3 + R(3) * 0.4), rx:60 + R(4) * 40, ry:40 + R(5) * 25};
    const n = 4 + Math.floor(R(6) * 5), p = o.pond;
    for (let i = 0; i < n; i++){
      const [tx, ty] = at(10 + i, 34), r = 18 + R(20 + i) * 12;
      if (p && Math.hypot((tx - p.x) / (p.rx + r), (ty - p.y) / (p.ry + r)) < 1) continue;
      o.trees.push({x:tx, y:ty, r}); o.circles.push({x:tx, y:ty, r:r * 0.85});   // 見た目とほぼ同じ大きさでぶつかる
    }
  } else if (kind === 'parking'){
    const sw = 50, sl = 84, cols = ['#F6B6A8', '#9FD3F0', '#FFE08A', '#C7B8F2', '#FFFFFF', '#B5E3C2'];
    for (const [row, cx0] of [[0, X + 34], [1, X + S - 34 - sl]]){
      let k = 0;
      for (let y = Y + 24; y + sw <= Y + S - 24; y += sw, k++){
        if (R(60 + row * 20 + k) < 0.45) continue;
        const c = {x:cx0 + 13, y:y + 9, w:58, h:32, col:cols[Math.floor(R(100 + row * 20 + k) * cols.length)], row, n:1 + Math.floor(R(140 + row * 20 + k) * 4)};
        o.cars.push(c); o.rects.push(c);
      }
    }
  } else if (kind === 'circuit'){
    // 紅白のタイヤバリア（2本。縦か横）
    for (let i = 0; i < 2; i++){
      const vert = false, len = 110 + R(250 + i) * 90, [bx0, by0] = at(260 + i, 80);   // 絵が横向きなので横置きだけ
      const c = vert ? {x:bx0 - 10, y:by0 - len / 2, w:20, h:len, vert} : {x:bx0 - len / 2, y:by0 - 10, w:len, h:20, vert};
      if (Math.abs(c.x + c.w / 2 - (X + S / 2)) < 90 && Math.abs(c.y + c.h / 2 - (Y + S / 2)) < 50) continue;   // まん中のチェッカーにかぶせない
      o.barriers.push(c); o.rects.push(c);
    }
  } else if (kind === 'garage'){
    const w = 150 + R(400) * 70, h = 100 + R(401) * 50;
    const b = {x:X + 30 + R(402) * (S - w - 60), y:Y + 30 + R(403) * (S - h - 60), w, h};
    o.building = b; o.rects.push(b);
    for (let i = 0; i < 3; i++){
      const [tx, ty] = at(340 + i, 40);
      if (!free(tx, ty, 22)) continue;
      o.tires.push({x:tx, y:ty}); o.circles.push({x:tx, y:ty - 5, r:16});
    }
  } else if (R(600) < 0.35){
    const vert = false, w = 120, h = 46;   // 絵が横向きなので横置きだけ
    const c = {x:X + 40 + R(602) * (S - w - 80), y:Y + 40 + R(603) * (S - h - 80), w, h, col:['#F2A38E', '#8FC6E8', '#F4C95D', '#9ED4A8'][Math.floor(R(604) * 4)], vert};
    o.container = c; o.rects.push(c);
  }
  OBS.set(key, o);
  if (OBS.size > 400) OBS.delete(OBS.keys().next().value);
  return o;
}
// 円（中心 o.x, o.y・半径 r）を障害物と川から押し出す。押し出した向き（n）を返す。当たらなければ null
function pushOut(o, r){
  let nx = 0, ny = 0, hit = false;
  const rect = c => {
    const qx = Math.max(c.x, Math.min(o.x, c.x + c.w)), qy = Math.max(c.y, Math.min(o.y, c.y + c.h));
    let dx = o.x - qx, dy = o.y - qy;
    const dd = dx * dx + dy * dy;
    if (dd >= r * r) return;
    if (dd < 1e-6){   // 中心が中に入っていたら一番近いふちへ
      const l = o.x - c.x, rt = c.x + c.w - o.x, t = o.y - c.y, b = c.y + c.h - o.y, m = Math.min(l, rt, t, b);
      if (m === l){ o.x = c.x - r; dx = -1; dy = 0; } else if (m === rt){ o.x = c.x + c.w + r; dx = 1; dy = 0; }
      else if (m === t){ o.y = c.y - r; dx = 0; dy = -1; } else { o.y = c.y + c.h + r; dx = 0; dy = 1; }
    } else { const d = Math.sqrt(dd); dx /= d; dy /= d; o.x += dx * (r - d); o.y += dy * (r - d); }
    nx += dx; ny += dy; hit = true;
  };
  const B = blockObs(Math.floor(o.x / 576), Math.floor(o.y / 576));
  for (const c of B.rects) rect(c);
  for (const c of B.circles){
    const dx = o.x - c.x, dy = o.y - c.y, d = Math.hypot(dx, dy), m = c.r + r;
    if (d < m && d > 1e-6){ o.x = c.x + dx / d * m; o.y = c.y + dy / d * m; nx += dx / d; ny += dy / d; hit = true; }
  }
  if (B.pond){
    const p = B.pond, ex = (o.x - p.x) / (p.rx + r), ey = (o.y - p.y) / (p.ry + r), q = Math.hypot(ex, ey);
    if (q < 1 && q > 1e-6){ o.x = p.x + ex / q * (p.rx + r); o.y = p.y + ey / q * (p.ry + r); nx += ex / q; ny += ey / q; hit = true; }
  }
  // 川：橋のない区間を長方形として扱う（橋の上はすき間）
  const ry = Math.round(o.y / 576);
  if (isRiver(ry) && Math.abs(o.y - ry * 576) < RIVER_HW + r){
    const c0 = Math.floor(o.x / 576);
    for (let cx = c0 - 1; cx <= c0 + 1; cx++){
      const l = cx * 576 + (bridgeAt(cx, ry) ? BRIDGE_HW : 0), rt = (cx + 1) * 576 - (bridgeAt(cx + 1, ry) ? BRIDGE_HW : 0);
      rect({x:l, y:ry * 576 - RIVER_HW, w:rt - l, h:RIVER_HW * 2});
    }
  }
  if (!hit) return null;
  const n = Math.hypot(nx, ny) || 1;
  return {x:nx / n, y:ny / n};
}
// 落とし物（ポイント・宝箱など）が障害物や川の上なら脇へ出す
const clearSpot = it => { for (let k = 0; k < 3; k++) if (!pushOut(it, 10)) break; return it; };

// ぶつかる物の描き方をそろえる：濃い影・下側の厚み・濃い緑の縁取りで、地面の模様と見分けがつくように
// ぶつかる物は高さを付けて描く：上面を持ち上げ、手前の壁は下ほど暗く、上面の左上に光、影は右下へ。
// 当たる範囲は足元（x, y, w, h）のまま
const OB_EDGE = 'rgba(34,74,58,.9)', OB_SHADOW = 'rgba(28,58,46,.28)';
function box(x, y, w, h, hgt, top, wall, rad = 6){
  ctx.fillStyle = OB_SHADOW; rr(x + hgt * 0.55 + 2, y + hgt * 0.3 + 3, w, h, rad); ctx.fill();
  // 壁（足元から上面までをまとめて塗り、下のほうを暗く）
  ctx.fillStyle = wall; rr(x, y - hgt, w, h + hgt, rad); ctx.fill();
  const g = ctx.createLinearGradient(0, y + h - hgt, 0, y + h);
  g.addColorStop(0, 'rgba(30,60,50,0)'); g.addColorStop(1, 'rgba(30,60,50,.38)');
  ctx.fillStyle = g; ctx.fillRect(x, y + h - hgt, w, hgt);
  ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 2.5; rr(x, y - hgt, w, h + hgt, rad); ctx.stroke();
  // 上面（左上を明るく）
  ctx.fillStyle = top; rr(x, y - hgt, w, h, rad); ctx.fill();
  const g2 = ctx.createLinearGradient(x, y - hgt, x + w * 0.7, y - hgt + h);
  g2.addColorStop(0, 'rgba(255,255,255,.4)'); g2.addColorStop(1, 'rgba(255,255,255,0)');
  ctx.fillStyle = g2; rr(x, y - hgt, w, h, rad); ctx.fill();
  ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 1.8; rr(x, y - hgt, w, h, rad); ctx.stroke();
  ctx.strokeStyle = 'rgba(255,255,255,.75)'; ctx.lineWidth = 1.5; ctx.beginPath();
  ctx.moveTo(x + rad + 1, y - hgt + 2); ctx.lineTo(x + w - rad - 1, y - hgt + 2); ctx.moveTo(x + 2, y - hgt + rad + 1); ctx.lineTo(x + 2, y - hgt + h - rad - 1); ctx.stroke();
  return y - hgt;   // 上面の上端
}
function cylinder(x, y, r, hgt, top, wall){
  ctx.fillStyle = OB_SHADOW; ctx.beginPath(); ctx.ellipse(x + hgt * 0.55 + 2, y + hgt * 0.3 + 3, r, r * 0.9, 0, 0, TAU); ctx.fill();
  ctx.fillStyle = wall; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI); ctx.lineTo(x - r, y - hgt); ctx.arc(x, y - hgt, r, Math.PI, 0); ctx.closePath(); ctx.fill();
  ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 2.5; ctx.stroke();
  const g = ctx.createRadialGradient(x - r * 0.35, y - hgt - r * 0.35, r * 0.1, x, y - hgt, r);
  g.addColorStop(0, 'rgba(255,255,255,.45)'); g.addColorStop(1, 'rgba(255,255,255,0)');
  ctx.fillStyle = top; ctx.beginPath(); ctx.arc(x, y - hgt, r, 0, TAU); ctx.fill();
  ctx.fillStyle = g; ctx.fill(); ctx.lineWidth = 1.8; ctx.stroke();
  return y - hgt;
}
function tree(x, y, r){
  ctx.fillStyle = OB_SHADOW; ctx.beginPath(); ctx.ellipse(x + 12, y + 6, r * 0.95, r * 0.6, 0, 0, TAU); ctx.fill();
  ctx.fillStyle = '#A9825A'; ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 2; rr(x - 4.5, y - 16, 9, 18, 3); ctx.fill(); ctx.stroke();
  const cy = y - 20, g = ctx.createRadialGradient(x - r * 0.35, cy - r * 0.4, r * 0.1, x, cy, r);
  g.addColorStop(0, '#B4E6A6'); g.addColorStop(0.55, '#6CC170'); g.addColorStop(1, '#3F8F55');
  ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, cy, r, 0, TAU); ctx.fill();
  ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 2.5; ctx.stroke();
  ctx.fillStyle = 'rgba(255,255,255,.25)'; ctx.beginPath(); ctx.arc(x - r * 0.3, cy - r * 0.35, r * 0.3, 0, TAU); ctx.fill();
}
// 地区の地面：タイルの絵があれば絵で、無ければ色で
function zoneFill(k, col, X, Y, S, rad, alpha){
  rr(X, Y, S, S, rad);
  if (ZT[k]){ ctx.save(); ctx.globalAlpha = alpha; ctx.fillStyle = ZT[k]; ctx.fill(); ctx.restore(); }
  else { ctx.fillStyle = col; ctx.fill(); }
}
function drawBlock(bx, by, rs){
  const B = blockObs(bx, by), kind = B.kind, R = B.R, at = B.at, X = B.X, Y = B.Y, S = B.S;
  ctx.save();
  if (kind === 'plain'){
    const c = B.container;
    if (c){
      if (SPR['ob-container']){
        ctx.fillStyle = OB_SHADOW; ctx.fillRect(c.x + 8, c.y + 8, c.w, c.h);
        drawObSpr('ob-container', c.x + c.w / 2, c.y + c.h + 10, c.w * 1.3);
      } else {
      const H = 22, ty = box(c.x, c.y, c.w, c.h, H, c.col, c.col, 3);
      ctx.strokeStyle = 'rgba(255,255,255,.5)'; ctx.lineWidth = 2; ctx.beginPath();
      if (c.vert) for (let y = ty + 10; y < ty + c.h; y += 10){ ctx.moveTo(c.x + 4, y); ctx.lineTo(c.x + c.w - 4, y); }
      else for (let x = c.x + 10; x < c.x + c.w; x += 10){ ctx.moveTo(x, ty + 4); ctx.lineTo(x, ty + c.h - 4); }
      for (let x = c.x + 8; x < c.x + c.w; x += 8){ ctx.moveTo(x, c.y + c.h - H + 3); ctx.lineTo(x, c.y + c.h - 3); }   // 手前の壁の波板
      ctx.stroke();
      }
    }
  } else if (kind === 'park'){
    zoneFill('park', 'rgba(150,215,130,.35)', X, Y, S, 26, 0.5);
    const pond = B.pond;
    if (pond){
      ctx.fillStyle = '#B5E2F2'; ctx.strokeStyle = '#4E9FBF'; ctx.lineWidth = 5;
      ctx.beginPath(); ctx.ellipse(pond.x, pond.y, pond.rx, pond.ry, 0, 0, TAU); ctx.fill(); ctx.stroke();
      ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 2; ctx.beginPath(); ctx.ellipse(pond.x, pond.y, pond.rx + 3, pond.ry + 3, 0, 0, TAU); ctx.stroke();
      ctx.strokeStyle = 'rgba(255,255,255,.8)'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.ellipse(pond.x - pond.rx * 0.3, pond.y - pond.ry * 0.3, pond.rx * 0.35, pond.ry * 0.2, 0, Math.PI, TAU); ctx.stroke();
    }
    const cols = ['#F7A6B8', '#FFD66E', '#FFFFFF', '#C7B8F2'];
    ctx.globalAlpha = 0.6;
    for (let i = 0; i < 26; i++){ const [fx, fy] = at(40 + i, 16); ctx.fillStyle = cols[i % 4]; ctx.beginPath(); ctx.arc(fx, fy, 2.6, 0, TAU); ctx.fill(); }
    ctx.globalAlpha = 1;
    for (const t of [...B.trees].sort((a, b) => a.y - b.y)){   // 奥（上）から順に描く
      const tn = 'ob-tree-' + (1 + Math.floor(hash(t.x | 0, t.y | 0) * 3));
      if (SPR[tn]){
        ctx.fillStyle = OB_SHADOW; ctx.beginPath(); ctx.ellipse(t.x + 10, t.y + t.r * 0.45, t.r * 0.95, t.r * 0.45, 0, 0, TAU); ctx.fill();
        drawObSpr(tn, t.x, t.y + t.r * 0.55, t.r * 2.4);
      } else tree(t.x, t.y, t.r);
    }
  } else if (kind === 'parking'){
    zoneFill('parking', 'rgba(205,214,218,.5)', X, Y, S, 14, 0.75);
    const sw = 50, sl = 84;
    for (const cx0 of [X + 34, X + S - 34 - sl]){
      ctx.strokeStyle = 'rgba(255,255,255,.7)'; ctx.lineWidth = 2.5; ctx.beginPath();
      for (let y = Y + 24; y <= Y + S - 24; y += sw){ ctx.moveTo(cx0, y); ctx.lineTo(cx0 + sl, y); }
      ctx.stroke();
    }
    for (const c of B.cars){
      if (SPR['ob-car-' + c.n]){   // 絵があれば絵で（左の列は右向きに反転して、通路の方を向かせる）
        ctx.fillStyle = OB_SHADOW; ctx.beginPath(); ctx.ellipse(c.x + c.w / 2 + 6, c.y + c.h + 1, c.w * 0.55, 9, 0, 0, TAU); ctx.fill();
        drawObSpr('ob-car-' + c.n, c.x + c.w / 2, c.y + c.h + 5, 64, c.row === 0);
        continue;
      }
      const ty = box(c.x, c.y, c.w, c.h, 12, c.col, c.col, 9);
      ctx.fillStyle = 'rgba(255,255,255,.35)'; rr(c.x + 14, ty + 4, c.w - 28, c.h - 8, 6); ctx.fill();   // 屋根
      ctx.strokeStyle = 'rgba(34,74,58,.35)'; ctx.lineWidth = 1.2; ctx.stroke();
      ctx.fillStyle = '#D6ECF6'; rr(c.x + (c.row ? 5 : c.w - 16), ty + 5, 11, 22, 3); ctx.fill();          // 窓
    }
    ctx.globalAlpha = 0.55; ctx.fillStyle = '#5E9FE0'; ctx.beginPath(); ctx.arc(X + S / 2, Y + S / 2, 22, 0, TAU); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.font = '900 26px "Zen Maru Gothic",sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText('P', X + S / 2, Y + S / 2 + 1); ctx.globalAlpha = 1;
  } else if (kind === 'circuit'){
    zoneFill('circuit', 'rgba(250,236,220,.45)', X, Y, S, 0, 0.45);
    const seg = 24, w = 12;
    for (let i = 0; i * seg < S; i++){
      ctx.fillStyle = i % 2 ? '#FFFFFF' : '#F28B76';
      const l = Math.min(seg, S - i * seg);
      ctx.fillRect(X + i * seg, Y, l, w); ctx.fillRect(X + i * seg, Y + S - w, l, w);
      ctx.fillRect(X, Y + i * seg, w, l); ctx.fillRect(X + S - w, Y + i * seg, w, l);
    }
    ctx.strokeStyle = 'rgba(110,120,115,.2)'; ctx.lineWidth = 6; ctx.lineCap = 'round';
    if (!ZT.circuit) for (let i = 0; i < 3; i++){
      const [ax, ay] = at(200 + i, 120), r = 70 + R(210 + i) * 60, a0 = R(220 + i) * TAU;
      ctx.beginPath(); ctx.arc(ax, ay, r, a0, a0 + 1.6); ctx.stroke();
      ctx.beginPath(); ctx.arc(ax + 10, ay + 6, r, a0, a0 + 1.6); ctx.stroke();
    }
    const q = 16, cx = X + S / 2 - q * 4, cy = Y + S / 2 - q * 1.5;
    ctx.globalAlpha = 0.6;
    for (let i = 0; i < 8; i++) for (let j = 0; j < 3; j++){ ctx.fillStyle = (i + j) % 2 ? '#FFFFFF' : '#A7B4AD'; ctx.fillRect(cx + i * q, cy + j * q, q, q); }
    ctx.strokeStyle = 'rgba(255,255,255,.95)'; ctx.lineWidth = 3; ctx.strokeRect(cx, cy, q * 8, q * 3); ctx.globalAlpha = 1;
    // タイヤバリア：紅白に塗ったタイヤを並べる
    for (const c of B.barriers){
      if (SPR['ob-barrier']){
        ctx.fillStyle = OB_SHADOW; rr(c.x + 6, c.y + 6, c.w, c.h, 10); ctx.fill();
        drawObSpr('ob-barrier', c.x + c.w / 2, c.y + c.h + 4, c.w + 12);
        continue;
      }
      const top = box(c.x, c.y, c.w, c.h, 12, '#9AA6A0', '#7E8B85', 10);
      const n = Math.max(2, Math.round((c.vert ? c.h : c.w) / 20));
      for (let k = 0; k < n; k++){
        const tx = c.vert ? c.x + 10 : c.x + 10 + k * (c.w - 20) / (n - 1), ty = c.vert ? top + 10 + k * (c.h - 20) / (n - 1) : top + 10;
        ctx.fillStyle = '#7E8B85'; ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.arc(tx, ty, 10, 0, TAU); ctx.fill(); ctx.stroke();
        ctx.fillStyle = k % 2 ? '#FFFFFF' : '#F28B76'; ctx.beginPath(); ctx.arc(tx, ty, 6.5, 0, TAU); ctx.fill();
      }
    }
  } else if (kind === 'garage'){
    zoneFill('garage', 'rgba(224,216,198,.5)', X, Y, S, 0, 0.8);
    ctx.strokeStyle = ZT.garage ? 'rgba(255,255,255,0)' : 'rgba(255,255,255,.55)'; ctx.lineWidth = 2; ctx.beginPath();
    for (let g = 68; g < S; g += 68){ ctx.moveTo(X + g, Y); ctx.lineTo(X + g, Y + S); ctx.moveTo(X, Y + g); ctx.lineTo(X + S, Y + g); }
    ctx.stroke();
    for (let i = 0; i < 4; i++){ const [ox, oy] = at(300 + i, 50); ctx.fillStyle = 'rgba(140,115,80,.16)'; ctx.beginPath(); ctx.ellipse(ox, oy, 26 + R(310 + i) * 22, 14 + R(320 + i) * 12, R(330 + i) * 3, 0, TAU); ctx.fill(); }
    // 整備工場の建物：影・屋根・シャッター
    const b = B.building;
    if (SPR['ob-garage']){
      ctx.fillStyle = OB_SHADOW; ctx.fillRect(b.x + 12, b.y + 12, b.w, b.h);
      const gw = b.w * 1.18, gh = gw * SPR['ob-garage'].height / SPR['ob-garage'].width, gx = b.x + b.w / 2 - gw / 2, gy = b.y + b.h + 10 - gh;
      drawObSpr('ob-garage', b.x + b.w / 2, b.y + b.h + 10, gw);
      // 屋根の白い看板に文字を重ねる（看板は絵の右上、少し右上がり）
      ctx.save(); ctx.translate(gx + gw * 0.645, gy + gh * 0.2); ctx.rotate(-0.2);
      ctx.fillStyle = '#1FA35C'; ctx.font = `900 ${Math.max(10, gw * 0.065) | 0}px "Zen Maru Gothic",sans-serif`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('TERAISM PIT', 0, 0); ctx.restore();
    } else {
    const BH = 34, rt = box(b.x, b.y, b.w, b.h, BH, '#D3DEE3', '#A9BCC4', 4);
    ctx.strokeStyle = 'rgba(255,255,255,.6)'; ctx.lineWidth = 2; ctx.beginPath();       // 屋根の波板
    for (let x = b.x + 12; x < b.x + b.w; x += 12){ ctx.moveTo(x, rt + 4); ctx.lineTo(x, rt + b.h - 4); }
    ctx.stroke();
    const dw = Math.min(70, b.w * 0.4), dx0 = b.x + (b.w - dw) / 2;                      // 手前の壁にシャッター
    ctx.fillStyle = '#E3EAED'; ctx.fillRect(dx0, b.y + b.h - BH + 6, dw, BH - 6);
    ctx.strokeStyle = 'rgba(120,140,150,.7)'; ctx.lineWidth = 1.5; ctx.beginPath();
    for (let y = b.y + b.h - BH + 10; y < b.y + b.h; y += 5){ ctx.moveTo(dx0 + 2, y); ctx.lineTo(dx0 + dw - 2, y); }
    ctx.stroke(); ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 1.5; ctx.strokeRect(dx0, b.y + b.h - BH + 6, dw, BH - 6);
    ctx.fillStyle = '#fff'; rr(b.x + b.w / 2 - 46, rt + b.h / 2 - 11, 92, 22, 5); ctx.fill();   // 屋上の看板
    ctx.strokeStyle = '#1FA35C'; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = '#1FA35C'; ctx.font = '900 13px "Zen Maru Gothic",sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText('TERAISM PIT', b.x + b.w / 2, rt + b.h / 2 + 1);
    }
    for (const t of B.tires){
      if (SPR['ob-tires']){
        ctx.fillStyle = OB_SHADOW; ctx.beginPath(); ctx.ellipse(t.x + 6, t.y + 6, 22, 10, 0, 0, TAU); ctx.fill();
        drawObSpr('ob-tires', t.x, t.y + 12, 52);
        continue;
      }
      const top = cylinder(t.x, t.y, 15, 18, '#8E9A94', '#6F7D76');
      ctx.strokeStyle = 'rgba(200,210,205,.6)'; ctx.lineWidth = 1.5; ctx.beginPath();     // タイヤの重なりの線
      for (const k of [6, 12]){ ctx.moveTo(t.x - 15, t.y - k); ctx.arc(t.x, t.y - k, 15, Math.PI, 0, true); }
      ctx.stroke();
      ctx.fillStyle = '#C9D2CD'; ctx.beginPath(); ctx.arc(t.x, top, 7, 0, TAU); ctx.fill();
      ctx.strokeStyle = OB_EDGE; ctx.lineWidth = 1.5; ctx.stroke();
    }
    for (let i = 0; i < 5; i++){
      const [kx, ky] = at(360 + i, 30);
      const c = b; if (kx > c.x - 12 && kx < c.x + c.w + 12 && ky > c.y - 16 && ky < c.y + c.h + 12) continue;
      ctx.globalAlpha = 0.5;
      ctx.fillStyle = '#F59A4B'; ctx.beginPath(); ctx.moveTo(kx, ky - 14); ctx.lineTo(kx + 9, ky + 8); ctx.lineTo(kx - 9, ky + 8); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#fff'; ctx.fillRect(kx - 4.5, ky - 3, 9, 4); ctx.globalAlpha = 1;
    }
  }
  ctx.restore();
}
// 川と橋（区画の絵の上の辺・下の辺が川のときに描く）
function drawRiverEdge(X, x1, yc){
  const ry = Math.round(yc / 576);
  ctx.save();
  const g = ctx.createLinearGradient(0, yc - RIVER_HW, 0, yc + RIVER_HW);
  g.addColorStop(0, '#8FD0EA'); g.addColorStop(0.5, '#B7E4F5'); g.addColorStop(1, '#8FD0EA');
  ctx.fillStyle = '#D9CBA8'; ctx.fillRect(X, yc - RIVER_HW - 6, x1 - X, RIVER_HW * 2 + 12);   // 土手
  ctx.fillStyle = ZT.river || g; ctx.fillRect(X, yc - RIVER_HW, x1 - X, RIVER_HW * 2);
  ctx.strokeStyle = ZT.river ? 'rgba(255,255,255,0)' : 'rgba(255,255,255,.65)'; ctx.lineWidth = 2; ctx.beginPath();
  for (let x = X; x < x1; x += 46){
    for (const dy of [-18, 4, 22]){ const ox = (hash(x | 0, dy) * 20) | 0; ctx.moveTo(x + ox, yc + dy); ctx.quadraticCurveTo(x + ox + 7, yc + dy - 4, x + ox + 14, yc + dy); }
  }
  ctx.stroke();
  for (const cx of [Math.round(X / 576), Math.round(x1 / 576)]){
    if (!bridgeAt(cx, ry)) continue;
    const bx = cx * 576;
    ctx.fillStyle = 'rgba(40,70,60,.18)'; ctx.fillRect(bx - BRIDGE_HW + 6, yc - RIVER_HW - 10, BRIDGE_HW * 2, RIVER_HW * 2 + 26);
    ctx.fillStyle = '#E6D3B0'; ctx.fillRect(bx - BRIDGE_HW, yc - RIVER_HW - 14, BRIDGE_HW * 2, RIVER_HW * 2 + 28);
    ctx.strokeStyle = 'rgba(160,130,90,.45)'; ctx.lineWidth = 2; ctx.beginPath();
    for (let y = yc - RIVER_HW - 10; y < yc + RIVER_HW + 14; y += 9){ ctx.moveTo(bx - BRIDGE_HW + 4, y); ctx.lineTo(bx + BRIDGE_HW - 4, y); }
    ctx.stroke();
    ctx.fillStyle = '#F28B76'; ctx.fillRect(bx - BRIDGE_HW - 3, yc - RIVER_HW - 14, 6, RIVER_HW * 2 + 28); ctx.fillRect(bx + BRIDGE_HW - 3, yc - RIVER_HW - 14, 6, RIVER_HW * 2 + 28);
  }
  ctx.restore();
}
// 雲の影：大きな薄い影がゆっくり流れる
function drawClouds(x0, y0, x1, y1, t){
  const cs = 760, dx = t * 16, dy = t * 7;
  ctx.fillStyle = 'rgba(50,100,80,.06)';
  for (let cx = Math.floor((x0 - dx) / cs) - 1; cx * cs + dx < x1 + cs; cx++) for (let cy = Math.floor((y0 - dy) / cs) - 1; cy * cs + dy < y1 + cs; cy++){
    const h = hash(cx * 3 + 1, cy * 11 + 5);
    if (h < 0.45) continue;
    const ox = cx * cs + dx + h * 400, oy = cy * cs + dy + hash(cy, cx * 3) * 400, r = 90 + h * 90;
    ctx.beginPath(); ctx.ellipse(ox, oy, r, r * 0.55, 0, 0, TAU); ctx.fill();
    ctx.beginPath(); ctx.ellipse(ox + r * 0.6, oy - r * 0.2, r * 0.6, r * 0.4, 0, 0, TAU); ctx.fill();
    ctx.beginPath(); ctx.ellipse(ox - r * 0.55, oy + r * 0.1, r * 0.5, r * 0.35, 0, 0, TAU); ctx.fill();
  }
}
/* 空の色：明け方の朝焼け→昼→夕焼け→薄紫の黄昏（BGM「Chasing the Sunrise」に合わせて）。
   1分・3分チャレンジは制限時間で一巡、エンドレスは10分で黄昏（終盤が急に厳しくなる頃）。黒は使わない */
const SKY = [[0, [255, 186, 150, 0.24]], [0.15, [255, 226, 186, 0.1]], [0.3, [255, 255, 255, 0]], [0.58, [255, 255, 255, 0]],
             [0.74, [255, 176, 96, 0.18]], [0.88, [242, 132, 122, 0.2]], [1, [176, 146, 226, 0.24]]];
function skyColor(){
  if (!G) return null;
  const p = Math.min(1, G.t / (MODES[G.mode].win || 600));
  let i = 0; while (i < SKY.length - 2 && SKY[i + 1][0] <= p) i++;
  const [pa, a] = SKY[i], [pb, b] = SKY[i + 1], k = Math.min(1, Math.max(0, (p - pa) / (pb - pa)));
  const c = a.map((v, j) => v + (b[j] - v) * k);
  return c[3] < 0.005 ? null : c;
}
const rgba = (c, a) => `rgba(${c[0] | 0},${c[1] | 0},${c[2] | 0},${a.toFixed(3)})`;

// ---------- 天候イベント：ヘッドライトの届く範囲だけが見える ----------
// near＝車のまわりの小さな円、len＝ヘッドライト（進む向きの扇形）の長さ
const WX = {
  fog:{name:'濃霧', msg:'濃霧が発生！ 視界が狭くなる', near:120, len:300, col:[238, 245, 242], a:0.94},
  rain:{name:'大雨', msg:'大雨！ 視界が悪くなる', near:150, len:380, col:[62, 88, 110], a:0.66},
  dark:{name:'電圧ダウン', msg:'電圧ダウン！ ヘッドライトの先しか見えない', near:90, len:320, col:[14, 26, 42], a:0.9},
};
// 既存の商品の効果：電装（EC-17 火花ショット・EC-13SP 連射）でライトが遠く広く、AE-07SP（吸い寄せ）で見えない敵をセンサーで表示
const lightMul = () => Math.min(1.6, 1 + 0.06 * (lvOf('spark') + lvOf('cd')));
const sensorRange = () => lvOf('magnet') ? 260 + 70 * lvOf('magnet') : 0;
const WX_NOTE = {spark:'天候イベント中：ヘッドライトが遠く広く届く', cd:'天候イベント中：ヘッドライトが遠く広く届く', magnet:'天候イベント中：見えない敵をセンサーで表示',
  armor:'引き寄せに踏ん張る・突進のダメージを抑える', speed:'抵抗のまわりでも鈍りにくい'};
let WXC = null;
function drawWeather(P, shx, shy){
  const e = G.wx;
  if (!e || W < 1 || H < 1) return;   // 画面が隠れて幅0のときは描かない（描くと止まる）
  const w = WX[e.k];
  let f = Math.max(0, Math.min(1, e.t / 1.5, (e.dur - e.t) / 1.5));   // 始まりと終わりはゆっくり
  if (e.k === 'dark' && e.t < 1.2) f = Math.sin(e.t * 38) > 0.1 ? 1 : 0.12;   // 照明がチカチカしてから落ちる
  const cx = W / 2 + shx, cy = H / 2 + shy, L = lightMul(), a = P.face;
  if (!WXC) WXC = document.createElement('canvas');
  // 覆いはぼかした絵なので、半分の細かさで作って引き伸ばす（軽くするため）
  if (WXC.width !== Math.ceil(W / 2) || WXC.height !== Math.ceil(H / 2)){ WXC.width = Math.ceil(W / 2); WXC.height = Math.ceil(H / 2); }
  const x = WXC.getContext('2d');
  x.setTransform(0.5, 0, 0, 0.5, 0, 0);
  x.globalCompositeOperation = 'source-over'; x.clearRect(0, 0, W, H);
  x.fillStyle = rgba(w.col, w.a * f); x.fillRect(0, 0, W, H);
  // 覆いをくり抜く：車のまわり＋ヘッドライトの扇形（ふちはぼかす）
  x.globalCompositeOperation = 'destination-out';
  const near = w.near * ZOOM * (0.9 + 0.1 * L);
  const g1 = x.createRadialGradient(cx, cy, near * 0.35, cx, cy, near);
  g1.addColorStop(0, 'rgba(0,0,0,1)'); g1.addColorStop(1, 'rgba(0,0,0,0)');
  x.fillStyle = g1; x.fillRect(cx - near, cy - near, near * 2, near * 2);
  const len = w.len * L * ZOOM;
  for (const [half, al] of [[0.62 * (0.8 + 0.2 * L), 0.45], [0.38 * (0.8 + 0.2 * L), 1]]){
    const g2 = x.createRadialGradient(cx, cy, 0, cx, cy, len);
    g2.addColorStop(0, `rgba(0,0,0,${al})`); g2.addColorStop(0.7, `rgba(0,0,0,${al * 0.85})`); g2.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g2; x.beginPath(); x.moveTo(cx, cy); x.arc(cx, cy, len, a - half, a + half); x.closePath(); x.fill();
  }
  // ショット系の残光：飛んでいる弾のまわりと、通ってきた後ろを尾を引くように少しだけ照らす
  let nb = 0;
  for (const b of G.bullets){
    const sx = cx + (b.x - P.x) * ZOOM, sy = cy + (b.y - P.y) * ZOOM;
    if (sx < -80 || sy < -80 || sx > W + 80 || sy > H + 80) continue;
    if (++nb > 60) break;
    const sp = Math.hypot(b.vx, b.vy) || 1, ux = b.vx / sp, uy = b.vy / sp;
    for (let k = 0; k < 4; k++){
      const px = sx - ux * k * 22 * ZOOM, py = sy - uy * k * 22 * ZOOM, r = (46 - k * 9) * ZOOM;
      const gb = x.createRadialGradient(px, py, 0, px, py, r);
      gb.addColorStop(0, `rgba(0,0,0,${(0.75 - k * 0.16).toFixed(2)})`); gb.addColorStop(1, 'rgba(0,0,0,0)');
      x.fillStyle = gb; x.fillRect(px - r, py - r, r * 2, r * 2);
    }
  }
  ctx.drawImage(WXC, 0, 0, W, H);
  // 暗いときはライトの光を地面にうっすら
  if (e.k === 'dark'){
    const g3 = ctx.createRadialGradient(cx, cy, 0, cx, cy, len);
    g3.addColorStop(0, `rgba(255,240,180,${(0.16 * f).toFixed(3)})`); g3.addColorStop(1, 'rgba(255,240,180,0)');
    ctx.fillStyle = g3; ctx.beginPath(); ctx.moveTo(cx, cy); ctx.arc(cx, cy, len, a - 0.38, a + 0.38); ctx.closePath(); ctx.fill();
  }
  const now = performance.now() / 1000;
  if (e.k === 'rain'){
    ctx.globalAlpha = f; ctx.strokeStyle = 'rgba(214,232,246,.6)'; ctx.lineWidth = 1.5; ctx.beginPath();
    for (let i = 0; i < 110; i++){
      const sp = 700 + hash(i, 5) * 500, rx = ((hash(i, 7) * (W + 200) - now * sp * 0.3) % (W + 200) + W + 200) % (W + 200) - 100, ry = (hash(i, 3) * (H + 40) + now * sp) % (H + 40) - 20;
      ctx.moveTo(rx, ry); ctx.lineTo(rx - 6, ry + 20);
    }
    ctx.stroke(); ctx.globalAlpha = 1;
  } else if (e.k === 'fog'){
    for (let i = 0; i < 6; i++){
      const fx = ((hash(i, 11) * W + now * (18 + i * 6)) % (W + 400)) - 200, fy = hash(i, 13) * H, fr = 160 + hash(i, 17) * 140;
      const fg = ctx.createRadialGradient(fx, fy, 0, fx, fy, fr);
      fg.addColorStop(0, `rgba(250,252,251,${(0.35 * f).toFixed(3)})`); fg.addColorStop(1, 'rgba(250,252,251,0)');
      ctx.fillStyle = fg; ctx.fillRect(fx - fr, fy - fr, fr * 2, fr * 2);
    }
  }
  // センサー：範囲内の敵を光る点で（ボスは大きな紫の印）
  const sr = sensorRange();
  if (sr){
    const pulse = 0.7 + Math.sin(now * 6) * 0.3;
    ctx.fillStyle = `rgba(255,128,96,${(0.85 * f).toFixed(3)})`;
    let n = 0;
    for (const en of G.enemies){
      if (en === G.boss || d2(en, P) > sr * sr) continue;
      if (++n > 160) break;
      ctx.beginPath(); ctx.arc(cx + (en.x - P.x) * ZOOM, cy + (en.y - P.y) * ZOOM, 4.5 * pulse + 2.5, 0, TAU); ctx.fill();
    }
    if (G.boss){
      const bx = cx + (G.boss.x - P.x) * ZOOM, by = cy + (G.boss.y - P.y) * ZOOM;
      ctx.strokeStyle = `rgba(150,120,240,${f.toFixed(3)})`; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.arc(bx, by, 16 + pulse * 6, 0, TAU); ctx.stroke();
    }
    ctx.strokeStyle = `rgba(255,128,96,${(0.25 * f).toFixed(3)})`; ctx.lineWidth = 1.5; ctx.setLineDash([4, 8]);
    ctx.beginPath(); ctx.arc(cx, cy, sr * ZOOM, 0, TAU); ctx.stroke(); ctx.setLineDash([]);
  }
  // 名前と残り時間。最初の数秒は効く商品のヒント
  const buff = (L > 1 ? '　ライト強化中' : '') + (sr ? '　センサー作動中' : '');
  const label = `${w.name}　のこり ${Math.max(0, Math.ceil(e.dur - e.t))} 秒` + buff;
  ctx.font = '900 15px "Zen Maru Gothic",sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.lineWidth = 4; ctx.strokeStyle = '#fff'; ctx.strokeText(label, W / 2, 104);
  ctx.fillStyle = e.k === 'dark' ? '#3E5C8A' : C.ink; ctx.fillText(label, W / 2, 104);
  if (e.t < 7 && !(L > 1 && sr)){
    const hint = 'ヒント：EC-17・EC-13SP でライト強化／AE-07SP でセンサー';
    ctx.font = '700 12px "Zen Maru Gothic",sans-serif';
    ctx.lineWidth = 3; ctx.strokeText(hint, W / 2, 126); ctx.fillStyle = C.ink; ctx.fillText(hint, W / 2, 126);
  }
}

// ---------- ダメージ床（FR・EO 系のケミカル／オイル）：しずくが落ちて広がる、うねる水たまり ----------
const PUD_DROP = 0.18;
const PUD = [
  {hi:'#D4F7DE', mid:'#5CC98A', edge:'#1FA35C', rim:'#157A44'},   // ケミカル（緑）
  {hi:'#FFF3C2', mid:'#F2C94C', edge:'#D9A21B', rim:'#A87A0C'},   // オイル（金）
];
function drawPuddle(p, now){
  const age = p.max - p.life, c = PUD[p.hue];
  if (age < PUD_DROP){   // 落ちてくるしずくと影
    const k = age / PUD_DROP, h = (1 - k) * 90, dx = p.x, dy = p.y - h;
    ctx.fillStyle = 'rgba(40,90,60,.16)'; ctx.beginPath(); ctx.ellipse(p.x, p.y, 5 + 7 * k, 2.5 + 3.5 * k, 0, 0, TAU); ctx.fill();
    ctx.fillStyle = c.mid; ctx.strokeStyle = c.rim; ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.moveTo(dx, dy - 11); ctx.quadraticCurveTo(dx + 8, dy + 2, dx, dy + 7); ctx.quadraticCurveTo(dx - 8, dy + 2, dx, dy - 11); ctx.fill(); ctx.stroke();
    ctx.fillStyle = 'rgba(255,255,255,.8)'; ctx.beginPath(); ctx.arc(dx - 2, dy - 1, 1.8, 0, TAU); ctx.fill();
    return;
  }
  const t = age - PUD_DROP;
  const grow = t < 0.22 ? 1 - Math.pow(1 - t / 0.22, 3) : 1;                   // ビシャッと広がる
  const pop = t < 0.4 ? 1 + Math.sin(Math.min(1, t / 0.4) * Math.PI) * 0.1 : 1;  // 少し行き過ぎて戻る
  const fade = Math.max(0, Math.min(1, p.life / 0.6));                          // 消えるときは縮みながら薄く
  const R = p.r * grow * pop * (0.8 + 0.2 * fade);
  if (R < 1) return;
  // ふちがゆっくりうねる不定形
  const N = 12, pts = [];
  for (let i = 0; i < N; i++){
    const a = i / N * TAU, w = 0.86 + hash(p.seed, i) * 0.22 + Math.sin(now * 2.2 + i * 1.7 + p.seed) * 0.035;
    pts.push([p.x + Math.cos(a) * R * w, p.y + Math.sin(a) * R * w * 0.84]);
  }
  const path = () => {
    ctx.beginPath();
    const [lx, ly] = pts[N - 1], [fx, fy] = pts[0];
    ctx.moveTo((lx + fx) / 2, (ly + fy) / 2);
    for (let i = 0; i < N; i++){ const [x1, y1] = pts[i], [x2, y2] = pts[(i + 1) % N]; ctx.quadraticCurveTo(x1, y1, (x1 + x2) / 2, (y1 + y2) / 2); }
    ctx.closePath();
  };
  ctx.save();
  // しみ（外側の薄い輪）
  ctx.globalAlpha = 0.22 * fade; ctx.fillStyle = c.edge;
  ctx.translate(p.x, p.y); ctx.scale(1.1, 1.1); ctx.translate(-p.x, -p.y); path(); ctx.fill();
  ctx.restore(); ctx.save();
  // 液体の濃淡
  const g = ctx.createRadialGradient(p.x - R * 0.25, p.y - R * 0.3, R * 0.1, p.x, p.y, R);
  g.addColorStop(0, c.hi); g.addColorStop(0.55, c.mid); g.addColorStop(1, c.edge);
  ctx.globalAlpha = 0.74 * fade; ctx.fillStyle = g; path(); ctx.fill();
  ctx.globalAlpha = 0.9 * fade; ctx.strokeStyle = c.rim; ctx.lineWidth = 2.5; ctx.stroke();
  // 中だけに描く：油膜の虹色の筋と、ぷくっと膨らんではじける泡
  path(); ctx.clip();
  ctx.lineWidth = 3;
  const sheen = ['rgba(255,140,200,.38)', 'rgba(120,220,255,.38)', 'rgba(255,240,120,.38)'];
  for (let i = 0; i < 3; i++){
    const a0 = now * 0.6 + p.seed % 7 + i * 0.6;
    ctx.globalAlpha = fade; ctx.strokeStyle = sheen[i];
    ctx.beginPath(); ctx.arc(p.x + R * 0.15, p.y + R * 0.1, R * (0.32 + i * 0.13), a0, a0 + 1.8); ctx.stroke();
  }
  for (let i = 0; i < 5; i++){
    const ph = (now * (0.7 + hash(p.seed, i + 20) * 0.6) + hash(p.seed, i + 40)) % 1;
    const bx = p.x + (hash(p.seed, i + 60) - 0.5) * R * 1.2, by = p.y + (hash(p.seed, i + 80) - 0.5) * R * 0.9;
    const br = 1.5 + ph * (3 + hash(p.seed, i + 90) * 3);
    ctx.globalAlpha = (ph < 0.85 ? 0.85 : (1 - ph) / 0.15 * 0.85) * fade;
    ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.arc(bx, by, br, 0, TAU); ctx.stroke();
    ctx.fillStyle = 'rgba(255,255,255,.6)'; ctx.beginPath(); ctx.arc(bx - br * 0.35, by - br * 0.35, br * 0.3, 0, TAU); ctx.fill();
  }
  ctx.restore();
  // ツヤの照り返し
  ctx.globalAlpha = 0.6 * fade; ctx.fillStyle = '#fff';
  ctx.beginPath(); ctx.ellipse(p.x - R * 0.36, p.y - R * 0.32, R * 0.22, R * 0.08, -0.5, 0, TAU); ctx.fill();
  // 着いた瞬間の波紋
  if (t < 0.32){
    const k = t / 0.32;
    ctx.globalAlpha = (1 - k) * 0.85; ctx.strokeStyle = c.hi; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.ellipse(p.x, p.y, R * (1 + k * 0.6), R * 0.84 * (1 + k * 0.6), 0, 0, TAU); ctx.stroke();
  }
  ctx.globalAlpha = 1;
}

// ---------- 背景の区画の絵（576四方。道の真ん中が区画の境目） ----------
const TILE = 576, TILES = new Map();
let tileScale = 0;
function bgTile(bx, by){
  const sc = Math.min(1.5, DPR * ZOOM);   // 細かすぎると覚えておく量が増えるので1.5倍まで
  if (sc !== tileScale){ TILES.clear(); tileScale = sc; }
  const key = bx + ',' + by;
  let c = TILES.get(key);
  if (c){ TILES.delete(key); TILES.set(key, c); return c; }   // 最近使った順に並べ直す
  c = document.createElement('canvas'); c.width = c.height = Math.ceil(TILE * sc);
  const main = ctx; ctx = c.getContext('2d');
  try {
    const X = bx * TILE, Y = by * TILE, x0 = X, y0 = Y, x1 = X + TILE, y1 = Y + TILE;
    ctx.setTransform(sc, 0, 0, sc, -X * sc, -Y * sc);
    ctx.fillStyle = C.ground; ctx.fillRect(X, Y, TILE, TILE);
    ctx.fillStyle = pavePattern(); ctx.fillRect(X, Y, TILE, TILE);
    if (GROUND){ ctx.globalAlpha = 0.4; ctx.fillStyle = GROUND; ctx.fillRect(X, Y, TILE, TILE); ctx.globalAlpha = 1; }
    ctx.strokeStyle = C.line; ctx.lineWidth = 2;
    const gs = 96;
    ctx.beginPath();
    for (let x = X; x <= x1; x += gs){ ctx.moveTo(x, y0); ctx.lineTo(x, y1); }
    for (let y = Y; y <= y1; y += gs){ ctx.moveTo(x0, y); ctx.lineTo(x1, y); }
    ctx.stroke();
    const rs = TILE;
    drawBlock(bx, by, rs);
    ctx.fillStyle = 'rgba(203,229,210,.55)';
    for (const x of [X, x1]) ctx.fillRect(x - 46, y0, 92, TILE);
    for (const y of [Y, y1]) ctx.fillRect(x0, y - 46, TILE, 92);
    // 白い破線（区画の境目でつながるように、線の始まりの位置をそろえる）
    ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.lineWidth = 5; ctx.setLineDash([30, 26]);
    ctx.lineDashOffset = ((Y % 56) + 56) % 56;
    ctx.beginPath(); for (const x of [X, x1]){ ctx.moveTo(x, y0); ctx.lineTo(x, y1); } ctx.stroke();
    ctx.lineDashOffset = ((X % 56) + 56) % 56;
    ctx.beginPath(); for (const y of [Y, y1]){ ctx.moveTo(x0, y); ctx.lineTo(x1, y); } ctx.stroke();
    ctx.setLineDash([]); ctx.lineDashOffset = 0;
    if (isRiver(by)) drawRiverEdge(X, x1, Y);
    if (isRiver(by + 1)) drawRiverEdge(X, x1, y1);
    if (!GROUND){
      ctx.lineWidth = 2.5; ctx.strokeStyle = '#BFDDC8';
      const gc = 288;
      for (let cx = Math.floor(x0 / gc); cx * gc < x1; cx++) for (let cy = Math.floor(y0 / gc); cy * gc < y1; cy++){
        const h = hash(cx, cy);
        if (h < 0.55) drawNut(cx * gc + h * 200 + 40, cy * gc + hash(cy, cx) * 200 + 40, 9 + h * 6);
      }
    }
  } finally { ctx = main; }
  TILES.set(key, c);
  while (TILES.size > 28) TILES.delete(TILES.keys().next().value);   // 古いものから捨てる
  return c;
}
// 画面のふちの淡い影は、画面の大きさが変わったときだけ作り直す
let VIGNETTE = null;
function vignette(){
  if (VIGNETTE && VIGNETTE.width === Math.ceil(W) && VIGNETTE.height === Math.ceil(H)) return VIGNETTE;
  VIGNETTE = document.createElement('canvas'); VIGNETTE.width = Math.ceil(W); VIGNETTE.height = Math.ceil(H);
  const x = VIGNETTE.getContext('2d');
  const vg = x.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.45, W / 2, H / 2, Math.max(W, H) * 0.75);
  vg.addColorStop(0, 'rgba(21,122,68,0)'); vg.addColorStop(1, 'rgba(21,122,68,.13)');
  x.fillStyle = vg; x.fillRect(0, 0, W, H);
  return VIGNETTE;
}

function render(){
  const P = G ? G.p : {x:performance.now() / 30, y:performance.now() / 50};
  const sh = G && G.shake ? G.shake : 0, shx = sh ? rnd(-sh, sh) : 0, shy = sh ? rnd(-sh, sh) : 0;
  ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  ctx.fillStyle = C.ground; ctx.fillRect(0, 0, W, H);
  ctx.setTransform(DPR * ZOOM, 0, 0, DPR * ZOOM, DPR * (W / 2 - P.x * ZOOM + shx), DPR * (H / 2 - P.y * ZOOM + shy));

  const x0 = P.x - VW / 2 - 80, x1 = P.x + VW / 2 + 80, y0 = P.y - VH / 2 - 80, y1 = P.y + VH / 2 + 80;
  // 動かない背景（路面・地面の絵・格子・地区・道）は区画ごとに一度だけ絵にして貼る（毎コマ全部を塗り直すと重い）
  for (let bx = Math.floor(x0 / TILE); bx * TILE < x1; bx++) for (let by = Math.floor(y0 / TILE); by * TILE < y1; by++) ctx.drawImage(bgTile(bx, by), bx * TILE, by * TILE, TILE + 0.75, TILE + 0.75);   // 継ぎ目に隙間が出ないよう少し重ねる
  if (!G) return;
  drawClouds(x0, y0, x1, y1, G.t);
  const sky = skyColor();
  if (sky){ ctx.fillStyle = rgba(sky, sky[3]); ctx.fillRect(x0, y0, x1 - x0, y1 - y0); }

  const nowS = performance.now() / 1000;
  for (const p of G.puddles) drawPuddle(p, nowS);
  if (G.sbRad){
    const gr = ctx.createRadialGradient(P.x, P.y, G.sbRad * 0.3, P.x, P.y, G.sbRad);
    gr.addColorStop(0, 'rgba(245,154,91,0)'); gr.addColorStop(1, 'rgba(245,154,91,0.28)');
    ctx.fillStyle = gr; ctx.beginPath(); ctx.arc(P.x, P.y, G.sbRad, 0, TAU); ctx.fill();
    ctx.setLineDash([6, 8]); ctx.lineDashOffset = -G.t * 30; ctx.strokeStyle = 'rgba(224,116,56,.55)'; ctx.lineWidth = 2; ctx.stroke(); ctx.setLineDash([]);
  }
  for (const gm of G.gems){
    const col = gm.v < 3 ? C.spark : gm.v < 10 ? C.leaf : '#3E8EDE', r = gm.v < 3 ? 5.5 : gm.v < 10 ? 7 : 8.5;
    const bob = Math.sin(G.t * 4 + gm.x * 0.05) * 1.5;
    if (SPR['item-point'] && gm.v < 10){ drawSpr('item-point', gm.x, gm.y + bob, r * 2.6); continue; }
    ctx.save(); ctx.translate(gm.x, gm.y + bob); ctx.rotate(Math.PI / 4);
    ctx.fillStyle = col; rr(-r * 0.8, -r * 0.8, r * 1.6, r * 1.6, 2); ctx.fill();
    ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5; ctx.stroke();
    ctx.fillStyle = 'rgba(255,255,255,.75)'; ctx.fillRect(-r * 0.55, -r * 0.55, r * 0.5, r * 0.5);
    ctx.restore();
    // ときどききらっと光る
    if ((Math.floor(G.t * 3 + gm.x) % 9) === 0){
      ctx.strokeStyle = 'rgba(255,255,255,.95)'; ctx.lineWidth = 1.5; ctx.beginPath();
      ctx.moveTo(gm.x + r, gm.y - r - 4); ctx.lineTo(gm.x + r, gm.y - r + 4); ctx.moveTo(gm.x + r - 4, gm.y - r); ctx.lineTo(gm.x + r + 4, gm.y - r); ctx.stroke();
    }
  }
  for (const it of G.items) drawItem(it);
  for (const r of G.rings){
    if (r.r <= 0) continue;   // 2重のリングの2本目は、少し遅れて広がる（それまでは描かない）
    if (SPR['w-ring']){   // 衝撃リングの絵（丸い版）：輪の太い部分のまん中が当たりの円に重なる大きさ（絵の幅の約0.43倍が半径）
      ctx.globalAlpha = 0.95 * (1 - r.r / r.max) + 0.15; drawSpr('w-ring', P.x, P.y, r.r * 2.3); ctx.globalAlpha = 1;
      continue;
    }
    ctx.strokeStyle = 'rgba(21,122,68,' + (0.9 * (1 - r.r / r.max) + 0.1) + ')';
    ctx.lineWidth = 7; ctx.beginPath(); ctx.arc(P.x, P.y, r.r, 0, TAU); ctx.stroke();
    ctx.strokeStyle = 'rgba(255,255,255,.7)'; ctx.lineWidth = 2; ctx.stroke();
  }
  for (const e of G.enemies) drawEnemy(e, P);
  for (const b of G.ebullets){
    if (SPR['e-bullet']){ drawSpr('e-bullet', b.x, b.y, b.r * 4); continue; }
    ctx.save(); ctx.globalCompositeOperation = 'lighter';
    const gl = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.r * 2.6);
    gl.addColorStop(0, 'rgba(255,170,90,.8)'); gl.addColorStop(1, 'rgba(255,120,60,0)');
    ctx.fillStyle = gl; ctx.beginPath(); ctx.arc(b.x, b.y, b.r * 2.6, 0, TAU); ctx.fill(); ctx.restore();
    ctx.fillStyle = '#F07F6B'; ctx.beginPath(); ctx.arc(b.x, b.y, b.r, 0, TAU); ctx.fill();
    ctx.fillStyle = '#FFF4C2'; ctx.beginPath(); ctx.arc(b.x, b.y, b.r * 0.45, 0, TAU); ctx.fill();
  }
  drawCar(P);
  for (const sl of G.slashes){
    const a = Math.min(1, sl.life / 0.12);
    if (SPR['fx-slash'] && sl.span < TAU){   // 刃の風の絵（一周の刃はこれまでの線で）
      const im = SPR['fx-slash'], w = sl.r * 2, h = w * im.height / im.width;
      ctx.save(); ctx.translate(P.x, P.y); ctx.rotate(sl.a + Math.PI / 2); ctx.globalAlpha = a; ctx.drawImage(im, -w / 2, -sl.r, w, h); ctx.restore();
      continue;
    }
    ctx.fillStyle = 'rgba(143,168,216,' + (0.28 * a) + ')';
    ctx.strokeStyle = 'rgba(255,255,255,' + (0.9 * a) + ')'; ctx.lineWidth = 4;
    ctx.beginPath();
    if (sl.span >= TAU){ ctx.arc(P.x, P.y, sl.r, 0, TAU); }
    else { ctx.moveTo(P.x, P.y); ctx.arc(P.x, P.y, sl.r, sl.a - sl.span / 2, sl.a + sl.span / 2); ctx.closePath(); }
    ctx.fill();
    ctx.beginPath(); ctx.arc(P.x, P.y, sl.r, sl.a - Math.min(sl.span, TAU) / 2, sl.a + Math.min(sl.span, TAU) / 2); ctx.stroke();
  }
  for (const b of G.bullets){
    if (b.kind === 'boom'){
      ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(G.t * 18);
      if (SPR['w-boom']){ drawSpr('w-boom', 0, 0, 26); ctx.restore(); continue; }
      ctx.fillStyle = '#6E7D86'; ctx.beginPath();
      for (let i = 0; i < 6; i++){ const a = i / 6 * TAU; ctx.lineTo(Math.cos(a) * 9, Math.sin(a) * 9); }
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#C9D3DA'; ctx.beginPath(); ctx.arc(0, 0, 4, 0, TAU); ctx.fill();
      ctx.restore();
      continue;
    }
    if (b.kind === 'spark'){
      if (SPR['w-spark']){ drawSpr('w-spark', b.x, b.y, b.r * 5); continue; }
      ctx.save(); ctx.globalCompositeOperation = 'lighter';
      const gl = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.r * 3.2);
      gl.addColorStop(0, 'rgba(255,230,120,.75)'); gl.addColorStop(1, 'rgba(255,200,40,0)');
      ctx.fillStyle = gl; ctx.beginPath(); ctx.arc(b.x, b.y, b.r * 3.2, 0, TAU); ctx.fill();
      ctx.restore();
      ctx.strokeStyle = 'rgba(244,180,0,.55)'; ctx.lineWidth = 4; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(b.x, b.y); ctx.lineTo(b.x - b.vx * 0.04, b.y - b.vy * 0.04); ctx.stroke();
      ctx.fillStyle = '#FFF6D0'; ctx.beginPath(); ctx.arc(b.x, b.y, b.r * 0.75, 0, TAU); ctx.fill();
    } else if (SPR['w-rod']){   // 貫通ロッド：光る棒の絵を進む向きに
      ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(Math.atan2(b.vy, b.vx));
      const im = SPR['w-rod'], w = 46, h = w * im.height / im.width;
      ctx.drawImage(im, -w / 2, -h / 2, w, h); ctx.restore();
    } else {
      ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(Math.atan2(b.vy, b.vx));
      const gr = ctx.createLinearGradient(-16, 0, 16, 0);
      gr.addColorStop(0, '#C9B4F0'); gr.addColorStop(0.5, '#8FA8D8'); gr.addColorStop(1, '#9BD8D0');
      ctx.fillStyle = gr; rr(-16, -3.5, 32, 7, 3.5); ctx.fill();
      ctx.restore();
    }
  }
  if (G.aePlates) for (const pl of G.aePlates){
    ctx.save(); ctx.translate(pl.x, pl.y); ctx.rotate(pl.a + G.t * 4);
    if (SPR['w-plate']){ drawSpr('w-plate', 0, 0, 32); ctx.restore(); continue; }   // 周回プレート：光る板の絵
    ctx.fillStyle = '#DCE6EE'; rr(-10, -7, 20, 14, 3); ctx.fill();
    ctx.strokeStyle = '#8FA3B5'; ctx.lineWidth = 2; ctx.stroke();
    ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.moveTo(-6, -3); ctx.lineTo(4, -3); ctx.stroke();
    ctx.restore();
  }
  for (const l of G.lines){
    const la = Math.min(1, l.life / 0.1);
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.strokeStyle = 'rgba(255,200,140,' + 0.35 * la + ')'; ctx.lineWidth = 12; ctx.lineJoin = 'round';
    ctx.beginPath(); ctx.moveTo(l.pts[0].x, l.pts[0].y); for (let i = 1; i < l.pts.length; i++) ctx.lineTo(l.pts[i].x, l.pts[i].y); ctx.stroke(); ctx.restore();
    ctx.strokeStyle = 'rgba(217,138,78,' + la + ')'; ctx.lineWidth = 3.5;
    ctx.beginPath(); ctx.moveTo(l.pts[0].x, l.pts[0].y);
    for (let i = 1; i < l.pts.length; i++){
      const a = l.pts[i - 1], b = l.pts[i];
      ctx.lineTo((a.x + b.x) / 2 + rnd(-10, 10), (a.y + b.y) / 2 + rnd(-10, 10)); ctx.lineTo(b.x, b.y);
    }
    ctx.stroke(); ctx.strokeStyle = 'rgba(255,240,220,.9)'; ctx.lineWidth = 1.2; ctx.stroke();
    if (SPR['fx-zap']){   // 稲妻の絵を、つないだ線に沿って重ねる
      ctx.save(); ctx.globalAlpha = la;
      for (let i = 1; i < l.pts.length; i++){
        const a = l.pts[i - 1], b = l.pts[i], len = Math.hypot(b.x - a.x, b.y - a.y);
        ctx.save(); ctx.translate(a.x, a.y); ctx.rotate(Math.atan2(b.y - a.y, b.x - a.x) - Math.PI / 2);
        ctx.drawImage(SPR['fx-zap'], -10, 0, 20, len); ctx.restore();
      }
      ctx.restore();
    }
  }
  for (const p of G.parts){ ctx.globalAlpha = Math.min(1, p.life * 3) * (p.dust ? 0.8 : 1); ctx.fillStyle = p.col; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * (p.dust ? 1 + (0.45 - p.life) * 2 : 1), 0, TAU); ctx.fill(); }
  ctx.globalAlpha = 1;
  for (const f of G.fx){
    const k = 1 - f.life / f.max;
    if (f.k === 'burst'){
      if (SPR['fx-burst']){ ctx.globalAlpha = 1 - k * k; drawSpr('fx-burst', f.x, f.y, f.s * (0.6 + k * 0.8)); }
    } else if (f.k === 'gone'){
      ctx.globalAlpha = 1 - k * k * k; drawSpr(f.n, f.x, f.y, f.w * (1 - k * 0.12));
    } else if (f.k === 'smoke'){
      ctx.globalAlpha = 0.85 * (1 - k); drawSpr('fx-smoke', f.x, f.y - k * 14, f.s * (0.6 + k * 0.7));
    } else if (f.k === 'ring'){
      ctx.globalAlpha = 1 - k; ctx.strokeStyle = f.col; ctx.lineWidth = 4 * (1 - k) + 1;
      ctx.beginPath(); ctx.arc(f.x, f.y, f.r0 + (f.r1 - f.r0) * k, 0, TAU); ctx.stroke();
    } else if (f.k === 'lvup'){
      ctx.globalAlpha = 1 - k;
      if (SPR['fx-lvup']){ const im = SPR['fx-lvup'], h = 150 + 50 * k, w = h * im.width / im.height; ctx.drawImage(im, P.x - w / 2, P.y + 16 - h, w, h); }   // 車から上へのびる光の柱（縦長の絵なので高さで合わせる）
      ctx.strokeStyle = '#F4B400'; ctx.lineWidth = 6; ctx.beginPath(); ctx.arc(P.x, P.y, 20 + 140 * k, 0, TAU); ctx.stroke();
      ctx.strokeStyle = '#fff'; ctx.lineWidth = 2; ctx.stroke();
      ctx.font = '400 26px "Dela Gothic One",sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.lineWidth = 6; ctx.strokeStyle = '#fff'; ctx.strokeText('LEVEL UP!', P.x, P.y - 46 - 20 * k);
      ctx.fillStyle = C.deep; ctx.fillText('LEVEL UP!', P.x, P.y - 46 - 20 * k);
    }
  }
  ctx.globalAlpha = 1;
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  for (const t of G.texts){
    ctx.globalAlpha = Math.min(1, t.life * 3);
    const hard = !t.big && (t.crit || parseInt(t.v, 10) >= 50);
    const pop = t.big ? 1 : 1 + Math.max(0, t.life - 0.42) * 3;   // 出た瞬間に少し大きく
    ctx.font = (t.big ? '900 17px ' : hard ? `900 ${Math.round(15 * pop)}px ` : `700 ${Math.round(12 * pop)}px `) + '"Zen Maru Gothic",sans-serif';
    ctx.lineWidth = 3; ctx.strokeStyle = '#fff'; ctx.strokeText(t.v, t.x, t.y);
    ctx.fillStyle = t.col || (hard ? '#E07B2E' : C.ink); ctx.fillText(t.v, t.x, t.y);
  }
  ctx.globalAlpha = 1;

  ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  drawWeather(P, shx, shy);
  if (joy.on && state === 'play'){
    ctx.fillStyle = 'rgba(31,163,92,.12)'; ctx.strokeStyle = 'rgba(21,122,68,.5)'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.arc(joy.ox, joy.oy, 45, 0, TAU); ctx.fill(); ctx.stroke();
    const dx = joy.x - joy.ox, dy = joy.y - joy.oy, d = Math.hypot(dx, dy), m = Math.min(d, 45) / (d || 1);
    ctx.fillStyle = 'rgba(31,163,92,.55)'; ctx.beginPath(); ctx.arc(joy.ox + dx * m, joy.oy + dy * m, 20, 0, TAU); ctx.fill();
  }
  if (G.flash > 0){
    ctx.fillStyle = 'rgba(255,246,200,' + Math.min(0.75, G.flash * 1.8) + ')'; ctx.fillRect(0, 0, W, H);
  }
  for (const f of G.fx){
    if (f.k !== 'nuke') continue;
    const k = 1 - f.life / f.max;
    ctx.strokeStyle = 'rgba(255,255,255,' + (1 - k) + ')'; ctx.lineWidth = 18 * (1 - k) + 2;
    ctx.beginPath(); ctx.arc(W / 2, H / 2, Math.hypot(W, H) * 0.6 * k, 0, TAU); ctx.stroke();
  }
  if (sky){   // 画面の上側にも空の色を薄く
    const sg = ctx.createLinearGradient(0, 0, 0, H * 0.45);
    sg.addColorStop(0, rgba(sky, Math.min(0.4, sky[3] * 1.4))); sg.addColorStop(1, rgba(sky, 0));
    ctx.fillStyle = sg; ctx.fillRect(0, 0, W, H * 0.45);
  }
  // 画面のふちを淡い緑で囲む（奥行き）
  if (W >= 1 && H >= 1) ctx.drawImage(vignette(), 0, 0, W, H);
  // ボス接近の警告の帯
  if (G.warn > 0){
    const a = Math.min(1, G.warn * 3, (2.5 - G.warn) * 6), y = H * 0.3;
    ctx.globalAlpha = a;
    ctx.fillStyle = 'rgba(255,240,234,.93)'; ctx.fillRect(0, y - 34, W, 68);
    ctx.fillStyle = '#F07F6B';
    const off = (G.t * 90) % 40;
    for (let x = -40 + off; x < W + 40; x += 40){
      ctx.beginPath(); ctx.moveTo(x, y - 34); ctx.lineTo(x + 20, y - 34); ctx.lineTo(x + 12, y - 26); ctx.lineTo(x - 8, y - 26); ctx.fill();
      ctx.beginPath(); ctx.moveTo(x, y + 26); ctx.lineTo(x + 20, y + 26); ctx.lineTo(x + 12, y + 34); ctx.lineTo(x - 8, y + 34); ctx.fill();
    }
    ctx.font = `400 ${Math.min(28, W / 16)}px "Dela Gothic One",sans-serif`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillStyle = '#D9503B'; ctx.fillText('WARNING　大放電 接近中', W / 2 + Math.sin(G.t * 40) * (G.warn > 2 ? 2 : 0), y);
    ctx.globalAlpha = 1;
  }
  const low = G.p.hp / G.p.maxHp < 0.3;
  if (low || G.hurtFlash > 0){
    const a = G.hurtFlash > 0 ? 0.35 : 0.22 + 0.1 * Math.sin(G.t * 6);
    const gr = ctx.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.35, W / 2, H / 2, Math.max(W, H) * 0.7);
    gr.addColorStop(0, 'rgba(224,96,74,0)'); gr.addColorStop(1, 'rgba(224,96,74,' + a + ')');
    ctx.fillStyle = gr; ctx.fillRect(0, 0, W, H);
  }
  drawFinale();
  drawRush();
}
function eyes(e, P, s){
  const a = Math.atan2(P.y - e.y, P.x - e.x), ox = Math.cos(a) * s * 0.25, oy = Math.sin(a) * s * 0.25;
  for (const sx of [-1, 1]){
    ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(e.x + sx * s * 0.38, e.y - s * 0.1, s * 0.28, 0, TAU); ctx.fill();
    ctx.fillStyle = C.ink; ctx.beginPath(); ctx.arc(e.x + sx * s * 0.38 + ox, e.y - s * 0.1 + oy, s * 0.14, 0, TAU); ctx.fill();
  }
}
function drawEnemy(e, P){
  const col = e.flash > 0 ? '#FFFFFF' : e.col, r = e.r;
  ctx.fillStyle = 'rgba(30,74,53,.13)'; ctx.beginPath(); ctx.ellipse(e.x, e.y + r * 0.95, r * 0.85, r * 0.32, 0, 0, TAU); ctx.fill();
  const pop = (e.age || 0) < 0.25 ? 0.4 + 0.6 * (e.age / 0.25) + Math.sin(e.age / 0.25 * Math.PI) * 0.2 : 1;
  ctx.save();
  if (pop !== 1){ ctx.translate(e.x, e.y); ctx.scale(pop, pop); ctx.translate(-e.x, -e.y); }
  drawEnemyBody(e, P, col, r);
  // 立体感のハイライト
  if (e.flash <= 0 && !SPR[e.type === 'boss' ? 'boss' : 'enemy-' + e.type]){
    ctx.fillStyle = 'rgba(255,255,255,.3)'; ctx.beginPath(); ctx.ellipse(e.x - r * 0.32, e.y - r * 0.42, r * 0.42, r * 0.24, -0.5, 0, TAU); ctx.fill();
  }
  // 静電気はときどきパチッと光る
  if (e.type === 'spark' && Math.random() < 0.12){
    ctx.strokeStyle = 'rgba(255,230,120,.95)'; ctx.lineWidth = 1.6; ctx.beginPath();
    const a = rnd(0, TAU); let x = e.x + Math.cos(a) * r, y = e.y + Math.sin(a) * r; ctx.moveTo(x, y);
    for (let i = 0; i < 3; i++){ x += Math.cos(a) * 5 + rnd(-4, 4); y += Math.sin(a) * 5 + rnd(-4, 4); ctx.lineTo(x, y); }
    ctx.stroke();
  }
  ctx.restore();
}
const bossSpr = e => e.name === '大放電・極' && SPR['boss-ex'] ? 'boss-ex' : 'boss';
const enemySpr = e => e.type === 'split' ? (SPR['enemy-split'] ? 'enemy-split' : 'enemy-rust') : 'enemy-' + e.type;
function drawEnemyBody(e, P, col, r){
  let sn = e.type === 'boss' ? bossSpr(e) : enemySpr(e);
  if (e.hitAt !== undefined && G.t - e.hitAt < 0.16 && SPR[sn + '-hit']) sn += '-hit';   // 当たった直後は痛がる顔
  if (e.elite){
    ctx.strokeStyle = 'rgba(244,180,0,.9)'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.arc(e.x, e.y, r * 1.35 + Math.sin(e.wob) * 2, 0, TAU); ctx.stroke();
  }
  const now = performance.now() / 1000;
  // 減速の輪（抵抗）
  if (e.type === 'resist'){
    ctx.save(); ctx.fillStyle = 'rgba(127,156,181,.1)'; ctx.strokeStyle = 'rgba(110,140,170,.5)'; ctx.lineWidth = 2;
    ctx.setLineDash([6, 6]); ctx.lineDashOffset = -e.wob * 4;
    ctx.beginPath(); ctx.arc(e.x, e.y, RESIST_R, 0, TAU); ctx.fill(); ctx.stroke(); ctx.restore();
  }
  // 突進の予告：赤い線
  if (e.dashW > 0 && Math.sin(now * 40) > -0.3){
    const sp = Math.hypot(e.dashVX, e.dashVY) || 1;
    ctx.save(); ctx.strokeStyle = 'rgba(224,96,74,.75)'; ctx.lineWidth = 4; ctx.setLineDash([10, 8]);
    ctx.beginPath(); ctx.moveTo(e.x, e.y); ctx.lineTo(e.x + e.dashVX / sp * 170, e.y + e.dashVY / sp * 170); ctx.stroke(); ctx.restore();
  }
  // 突進中は残像
  if (e.dashGo > 0){ ctx.fillStyle = 'rgba(242,123,95,.25)'; ctx.beginPath(); ctx.arc(e.x - e.dashVX * 0.05, e.y - e.dashVY * 0.05, r, 0, TAU); ctx.fill(); }
  // ボスの引力：予告は紫の輪の点滅、引き寄せ中は縮んでいく輪
  if (e.type === 'boss' && e.pullOn > 0){
    ctx.save(); ctx.lineWidth = 3;
    if (e.pullOn >= 2.5){ ctx.strokeStyle = `rgba(108,92,231,${(0.35 + 0.3 * Math.sin(now * 18)).toFixed(3)})`; ctx.beginPath(); ctx.arc(e.x, e.y, BOSS_PULL_R, 0, TAU); ctx.stroke(); }
    else for (let i = 0; i < 4; i++){ const k = ((now * 1.2) + i / 4) % 1; ctx.strokeStyle = `rgba(108,92,231,${(0.4 * k).toFixed(3)})`; ctx.beginPath(); ctx.arc(e.x, e.y, BOSS_PULL_R * (1 - k), 0, TAU); ctx.stroke(); }
    ctx.restore();
  }
  // 磁界コイル：縮んでいく磁界の輪＋銅線を巻いた本体
  if (e.type === 'coil'){
    ctx.save(); ctx.lineWidth = 2;
    for (let i = 0; i < 3; i++){ const k = ((now * 0.8) + i / 3) % 1; ctx.strokeStyle = `rgba(94,139,214,${(0.3 * k).toFixed(3)})`; ctx.beginPath(); ctx.arc(e.x, e.y, COIL_R * (1 - k), 0, TAU); ctx.stroke(); }
    if (e.pulling){ ctx.strokeStyle = 'rgba(94,139,214,.55)'; ctx.setLineDash([4, 6]); ctx.lineDashOffset = now * 30; ctx.beginPath(); ctx.moveTo(e.x, e.y); ctx.lineTo(P.x, P.y); ctx.stroke(); }
    ctx.restore();
    if (SPR['enemy-coil']){ drawSpr(sn, e.x, e.y, r * 2.8, e.flash > 0); return; }
    ctx.fillStyle = col; rr(e.x - r * 0.9, e.y - r * 0.7, r * 1.8, r * 1.4, r * 0.35); ctx.fill();
    ctx.strokeStyle = '#4A72B8'; ctx.lineWidth = 2; ctx.stroke();
    ctx.strokeStyle = e.flash > 0 ? '#fff' : '#D98E4A'; ctx.lineWidth = 3; ctx.beginPath();
    for (let i = -2; i <= 2; i++){ ctx.moveTo(e.x + i * r * 0.32 - r * 0.06, e.y - r * 0.68); ctx.lineTo(e.x + i * r * 0.32 + r * 0.06, e.y + r * 0.68); }
    ctx.stroke();
    eyes(e, P, r * 0.75);
    return;
  }
  if (e.type === 'noise' && !SPR['enemy-noise']){
    // ノイズ：水色のギザギザの小さな電気
    ctx.fillStyle = col; ctx.beginPath();
    for (let i = 0; i < 10; i++){ const a = i / 10 * TAU + e.wob, rad = i % 2 ? r * 0.55 : r * 1.25; ctx.lineTo(e.x + Math.cos(a) * rad, e.y + Math.sin(a) * rad); }
    ctx.closePath(); ctx.fill(); ctx.strokeStyle = '#3BA9CC'; ctx.lineWidth = 1.5; ctx.stroke();
    eyes(e, P, r * 0.9);
    return;
  }
  if (e.type === 'shooter' && !SPR['enemy-shooter']){
    // 電圧スパイク：黄色いコンデンサの形。撃つ前に光る
    const glow = e.tick < 0.5;
    ctx.fillStyle = e.flash > 0 ? '#fff' : glow ? '#FFE27A' : col; rr(e.x - r * 0.8, e.y - r, r * 1.6, r * 2, r * 0.5); ctx.fill();
    ctx.strokeStyle = '#B98A12'; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = '#E0604A'; ctx.fillRect(e.x - r * 0.8, e.y - r * 0.15, r * 1.6, r * 0.3);
    ctx.strokeStyle = '#8FA3B5'; ctx.lineWidth = 2.5; ctx.beginPath(); ctx.moveTo(e.x - r * 0.3, e.y + r); ctx.lineTo(e.x - r * 0.3, e.y + r * 1.5); ctx.moveTo(e.x + r * 0.3, e.y + r); ctx.lineTo(e.x + r * 0.3, e.y + r * 1.5); ctx.stroke();
    eyes(e, P, r * 0.8);
    return;
  }
  if (SPR[sn]){
    // 絵で描く。少し伸び縮みさせて生きている感じに
    const sq = 1 + Math.sin(e.wob) * 0.05;
    ctx.save(); ctx.translate(e.x, e.y); ctx.scale(1 / sq, sq);
    drawSpr(sn, 0, 0, r * (e.type === 'boss' ? 2.7 : e.r < 13 ? 3 : 2.6), e.flash > 0);
    ctx.restore();
    if (e.type === 'boss'){
      ctx.font = '400 14px "Dela Gothic One",sans-serif'; ctx.textAlign = 'center'; ctx.lineWidth = 4; ctx.strokeStyle = '#fff';
      ctx.strokeText(e.name, e.x, e.y - r * 1.4 - 10); ctx.fillStyle = '#4B3DC4'; ctx.fillText(e.name, e.x, e.y - r * 1.4 - 10);
    }
    return;
  }
  if (e.type === 'spark' || e.type === 'boss'){
    const n = e.type === 'boss' ? 12 : 8, spin = e.wob * (e.type === 'boss' ? 0.2 : 0.5);
    ctx.fillStyle = col; ctx.beginPath();
    for (let i = 0; i < n * 2; i++){ const a = i / (n * 2) * TAU + spin, rad = i % 2 ? r * 0.72 : r * 1.12; ctx.lineTo(e.x + Math.cos(a) * rad, e.y + Math.sin(a) * rad); }
    ctx.closePath(); ctx.fill();
    ctx.strokeStyle = e.type === 'boss' ? '#4B3DC4' : '#6C5CE7'; ctx.lineWidth = 2; ctx.stroke();
    if (e.type === 'boss'){
      ctx.strokeStyle = 'rgba(244,180,0,.8)'; ctx.lineWidth = 3;
      for (let i = 0; i < 3; i++){ const a = e.wob * 0.7 + i * 2.1; ctx.beginPath(); ctx.moveTo(e.x + Math.cos(a) * r * 1.2, e.y + Math.sin(a) * r * 1.2); ctx.lineTo(e.x + Math.cos(a + 0.2) * r * 1.5, e.y + Math.sin(a + 0.2) * r * 1.5); ctx.lineTo(e.x + Math.cos(a - 0.1) * r * 1.7, e.y + Math.sin(a - 0.1) * r * 1.7); ctx.stroke(); }
    }
  } else if (e.type === 'heat'){
    ctx.fillStyle = col; ctx.beginPath(); ctx.arc(e.x, e.y + 2, r, 0, TAU); ctx.fill();
    ctx.beginPath(); ctx.moveTo(e.x - r * 0.8, e.y - r * 0.2); ctx.quadraticCurveTo(e.x - r * 0.3, e.y - r * 1.9 - Math.sin(e.wob) * 3, e.x + r * 0.1, e.y - r * 0.9);
    ctx.quadraticCurveTo(e.x + r * 0.5, e.y - r * 1.6, e.x + r * 0.8, e.y - r * 0.2); ctx.fill();
    ctx.fillStyle = e.flash > 0 ? '#fff' : '#FFD08A'; ctx.beginPath(); ctx.arc(e.x, e.y + r * 0.35, r * 0.4, 0, TAU); ctx.fill();
  } else if (e.type === 'rust'){
    ctx.fillStyle = col; ctx.beginPath();
    for (let i = 0; i < 10; i++){ const a = i / 10 * TAU, rad = r * (1 + 0.1 * Math.sin(i * 3 + e.wob * 0.5)); ctx.lineTo(e.x + Math.cos(a) * rad, e.y + Math.sin(a) * rad); }
    ctx.closePath(); ctx.fill();
    ctx.strokeStyle = mix('#C8804A', -0.3); ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = e.flash > 0 ? '#fff' : '#A45F2E';
    ctx.beginPath(); ctx.arc(e.x - r * 0.4, e.y + r * 0.45, r * 0.2, 0, TAU); ctx.arc(e.x + r * 0.45, e.y + r * 0.3, r * 0.14, 0, TAU); ctx.fill();
  } else if (e.type === 'resist'){
    ctx.strokeStyle = '#8FA3B5'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(e.x - r * 1.5, e.y); ctx.lineTo(e.x + r * 1.5, e.y); ctx.stroke();
    ctx.fillStyle = col; rr(e.x - r, e.y - r * 0.7, r * 2, r * 1.4, r * 0.6); ctx.fill();
    ctx.strokeStyle = mix('#7F9CB5', -0.3); ctx.lineWidth = 2; ctx.stroke();
    if (e.flash <= 0){ ['#A0672F', '#E0604A', '#F4B400'].forEach((c, i) => { ctx.fillStyle = c; ctx.fillRect(e.x - r * 0.55 + i * r * 0.45, e.y - r * 0.7, r * 0.2, r * 1.4); }); }
  }
  eyes(e, P, e.type === 'boss' ? r * 0.6 : r);
  if (e.type === 'boss'){
    ctx.font = '400 14px "Dela Gothic One",sans-serif'; ctx.textAlign = 'center'; ctx.lineWidth = 4; ctx.strokeStyle = '#fff';
    ctx.strokeText(e.name, e.x, e.y - r - 16); ctx.fillStyle = '#4B3DC4'; ctx.fillText(e.name, e.x, e.y - r - 16);
  }
}
function drawCar(P){
  ctx.save(); ctx.translate(P.x, P.y);
  ctx.fillStyle = 'rgba(30,74,53,.10)'; ctx.beginPath(); ctx.ellipse(3, 14, 24, 9, 0, 0, TAU); ctx.fill();
  ctx.fillStyle = 'rgba(30,74,53,.14)'; ctx.beginPath(); ctx.ellipse(2, 13, 19, 6.5, 0, 0, TAU); ctx.fill();
  ctx.rotate(P.face);
  if (P.inv > 0 && Math.floor(P.inv * 20) % 2) ctx.globalAlpha = 0.45;
  // 進んでいるときはライトの光
  if (P.moving){
    ctx.save(); ctx.globalCompositeOperation = 'lighter';
    const lg = ctx.createLinearGradient(18, 0, 72, 0);
    lg.addColorStop(0, 'rgba(255,244,190,.5)'); lg.addColorStop(1, 'rgba(255,244,190,0)');
    ctx.fillStyle = lg; ctx.beginPath(); ctx.moveTo(17, -8); ctx.lineTo(72, -28); ctx.lineTo(72, 28); ctx.lineTo(17, 8); ctx.closePath(); ctx.fill();
    ctx.restore();
  }
  if (SPR.car){
    // 絵で描く（右向きの絵を進む向きに回す）。走っているときは小さく揺れる
    const jig = P.moving ? Math.sin((P.dist || 0) * 0.25) * 0.6 : 0;
    drawSpr('car', 0, jig, 50);
    ctx.restore(); ctx.globalAlpha = 1;
    drawHpBar(P);
    return;
  }
  // タイヤ（走った距離で筋が流れる）
  const off = ((P.dist || 0) * 0.35) % 3;
  for (const [x, y] of [[-14, -14.5], [6, -14.5], [-14, 10], [6, 10]]){
    ctx.fillStyle = C.ink; rr(x, y, 10, 4.5, 2); ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,.35)'; ctx.lineWidth = 1; ctx.beginPath();
    for (let k = x + off; k < x + 10; k += 3){ ctx.moveTo(k, y + 0.8); ctx.lineTo(k, y + 3.8); }
    ctx.stroke();
  }
  // 車体
  const body = ctx.createLinearGradient(0, -11, 0, 11);
  body.addColorStop(0, '#6BDA9D'); body.addColorStop(0.45, C.leaf); body.addColorStop(1, C.deep);
  ctx.fillStyle = body; rr(-19, -11, 38, 22, 8); ctx.fill();
  ctx.strokeStyle = C.deep; ctx.lineWidth = 1.6; ctx.stroke();
  ctx.strokeStyle = 'rgba(255,255,255,.4)'; ctx.lineWidth = 1.5; ctx.beginPath();
  ctx.moveTo(10, -6); ctx.lineTo(16, -6); ctx.moveTo(10, 6); ctx.lineTo(16, 6); ctx.stroke();
  // 屋根・リアガラス・フロントガラス
  ctx.fillStyle = '#93E0B6'; rr(-11, -8, 14, 16, 4); ctx.fill();
  ctx.fillStyle = '#D3F2E1'; rr(-16, -6.5, 4, 13, 2); ctx.fill();
  const gl = ctx.createLinearGradient(3, -7, 11, 7); gl.addColorStop(0, '#F5FFF9'); gl.addColorStop(1, '#B3E6CB');
  ctx.fillStyle = gl; rr(3, -7.5, 8, 15, 3); ctx.fill();
  ctx.fillStyle = 'rgba(255,255,255,.85)'; ctx.fillRect(4.6, -6, 1.6, 6);
  // 屋根の稲妻マーク（静電気に効くクルマ）
  ctx.fillStyle = C.spark; ctx.beginPath();
  ctx.moveTo(-2.5, -5.5); ctx.lineTo(-7.5, 1); ctx.lineTo(-4.5, 1); ctx.lineTo(-6.5, 5.5); ctx.lineTo(-1, -1); ctx.lineTo(-4, -1); ctx.closePath(); ctx.fill();
  // ヘッドライトとテールランプ
  ctx.fillStyle = '#FFF4C2'; rr(16, -9.5, 3, 4, 1.5); ctx.fill(); rr(16, 5.5, 3, 4, 1.5); ctx.fill();
  ctx.fillStyle = '#F07F6B'; ctx.fillRect(-19.5, -8.5, 2, 3.5); ctx.fillRect(-19.5, 5, 2, 3.5);
  ctx.restore(); ctx.globalAlpha = 1;
  drawHpBar(P);
}
function drawHpBar(P){
  // 車体の下のHPバー（太く・白ふち）
  const w = 48, f = Math.max(0, P.hp / P.maxHp), low = f < 0.3;
  ctx.fillStyle = '#fff'; rr(P.x - w / 2 - 3, P.y + 20, w + 6, 11, 5.5); ctx.fill();
  ctx.strokeStyle = low ? '#E0604A' : C.deep; ctx.lineWidth = 1.5; ctx.stroke();
  ctx.fillStyle = '#E7EFE9'; rr(P.x - w / 2, P.y + 23, w, 5, 2.5); ctx.fill();
  if (f > 0){ ctx.fillStyle = low ? '#E0604A' : C.leaf; rr(P.x - w / 2, P.y + 23, Math.max(5, w * f), 5, 2.5); ctx.fill(); }
}
function drawItem(it){
  const bob = Math.sin(performance.now() / 250 + it.x) * 2;
  const sn = {heal:'item-heal', mag:'item-magnet', chest:'item-chest'}[it.type];
  if (SPR[sn]){ drawSpr(sn, it.x, it.y + bob, it.type === 'chest' ? 34 : 26); return; }
  ctx.save(); ctx.translate(it.x, it.y + bob);
  if (it.type === 'heal'){
    ctx.fillStyle = C.leaf; rr(-8, -10, 16, 20, 3); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.fillRect(-2, -6, 4, 12); ctx.fillRect(-6, -2, 12, 4);
    ctx.fillStyle = C.deep; ctx.fillRect(-3, -13, 6, 3);
  } else if (it.type === 'mag'){
    ctx.fillStyle = C.spark; ctx.beginPath(); ctx.arc(0, 0, 11, 0, TAU); ctx.fill();
    ctx.strokeStyle = '#fff'; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = C.ink; ctx.font = '900 12px "Zen Maru Gothic",sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('P', 0, 1);
  } else {
    ctx.fillStyle = '#F4C542'; rr(-13, -10, 26, 20, 4); ctx.fill();
    ctx.strokeStyle = '#B98A12'; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = C.leaf; ctx.fillRect(-13, -3, 26, 5);
    ctx.fillStyle = '#fff'; ctx.fillRect(-3, -4, 6, 7);
  }
  ctx.restore();
}

// ---------- 画面 ----------
function setState(s){
  state = s;
  $('ovTitle').hidden = s !== 'title';
  $('ovLvup').hidden = s !== 'lvup';
  $('ovLot').hidden = s !== 'lot';
  $('ovPause').hidden = s !== 'pause';
  $('ovEnd').hidden = s !== 'end';
  $('hud').hidden = s === 'title';
  if (s !== 'play'){ joy.on = false; keys.clear(); }
  if (s === 'play' && G && G.t === 0 && !G.bgmStarted){ G.bgmStarted = true; bgmNewRun(); }
  bgmSync();
}
function togglePause(){
  if (state === 'play'){ $('pauseList').innerHTML = usedHtml(); setState('pause'); $('resumeBtn').focus({preventScroll:true}); }
  else if (state === 'pause') setState('play');
}
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const imgSrc = p => p.img || ('img/' + p.h + '.jpg');

// 商品カード：画像・商品名・定価・（セール）・性能の倍率
function cardHtml(g, prod, key, isStarter){
  const def = GROUPS[g], cur = isStarter ? 0 : lvOf(g), sale = saleOf(prod);
  const pw = powerOf(prod);
  const lvTxt = cur ? `Lv ${cur} → ${cur + 1}` : '新しく取り付け';
  const desc = def.kind === 'w' ? def.desc[cur] : passiveText(g, pw);
  const price = sale
    ? `<span>定価 <s>${yen(listPrice(prod))}</s></span><span class="now">${yen(sale.now)}</span>`
    : `<span>定価 ${yen(listPrice(prod))}</span>`;
  const pwTxt = sale ? `効果 ×${pricePower(prod).toFixed(2)} → ×${pw.toFixed(2)}（セール特典で2倍）` : `定価に応じた効果 ×${pw.toFixed(2)}`;
  return `${sale ? `<span class="badge">${sale.label} ${sale.pct}%OFF</span>` : ''}
    <img class="ph" src="${imgSrc(prod)}" alt="" loading="lazy" decoding="async">
    <span class="role"><span class="code ${def.kind === 'p' ? 'p' : ''}">${esc(prod.code)}</span>${def.role}</span>
    <span class="nm">${esc(prod.name)}</span>
    <span class="price">${price}</span>
    <span class="pw">${pwTxt}</span>
    <span class="ds">${isStarter ? '' : `<b>${lvTxt}</b>　`}${desc}</span>
    ${WX_NOTE[g] ? `<span class="ds wx">${WX_NOTE[g]}</span>` : ''}
    ${key ? `<span class="key">キー ${key}</span>` : ''}`;
}
// レベルアップの選択肢（3つまで）。持てる数（武器6・能力6）を超える新しいパーツは出さない
function levelPicks(){
  const owned = {w:0, p:0};
  for (const g of G.order) owned[GROUPS[g].kind]++;
  const pool = [];
  for (const g in GROUPS){
    const cur = lvOf(g), k = GROUPS[g].kind;
    if (cur >= GROUPS[g].max) continue;
    if (!cur && owned[k] >= SLOT_MAX[k]) continue;
    if (!(DB.byG[g] || []).some(inStock) && !DB.byH[GROUPS[g].rep]) continue;
    const w = (cur ? 2 : 1) + ((DB.byG[g] || []).some(p => inStock(p) && saleOf(p)) ? 2 : 0); // 所持中・セール中は出やすく
    for (let i = 0; i < w; i++) pool.push(g);
  }
  const picks = [];
  while (pool.length && picks.length < 3){
    const g = pool.splice((Math.random() * pool.length) | 0, 1)[0];
    if (!picks.includes(g)) picks.push(g);
  }
  return picks;
}
function openLevelUp(){
  if (G.lots > 0){ G.lots--; openLottery(); return; }   // 宝箱は先に抽選
  $('lvTitle').textContent = G.chest > 0 ? (G.chest > 1 ? `宝箱を開けた！（のこり ${G.chest} つ）` : '宝箱を開けた！') : `レベル ${G.lv} に到達！`;
  const picks = levelPicks();
  const box = $('choices'); box.innerHTML = '';
  picks.forEach((g, i) => {
    const prod = productFor(g);
    const b = document.createElement('button'); b.type = 'button'; b.className = 'card' + (saleOf(prod) ? ' sale' : ''); b.id = 'choice-' + i;
    b.innerHTML = cardHtml(g, prod, i + 1);
    b.onclick = () => choose(() => install(g, prod));
    box.appendChild(b);
  });
  if (!picks.length){
    [['オイル缶','HPを50回復',() => { G.p.hp = Math.min(G.p.maxHp, G.p.hp + 50); }],
     ['ボーナスポイント','100 pt 獲得',() => { G.pts += 100; }]].forEach(([nm, ds, fn], i) => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'card'; b.id = 'choice-' + i;
      b.innerHTML = `<span class="role"><span class="code n">BONUS</span></span><span class="nm">${nm}</span><span class="ds">${ds}</span><span class="key">キー ${i + 1}</span>`;
      b.onclick = () => choose(fn);
      box.appendChild(b);
    });
  }
  setState('lvup');
  $('ovLvup').scrollTop = 0;
}
function choose(fn){
  if (state !== 'lvup') return;
  fn(); recompute();
  G.pending--; if (G.chest > 0) G.chest--;
  if (G.pending > 0) openLevelUp(); else setState('play');
}

// ---------- 宝箱の抽選（スロット・ルーレット・カードめくりの3種類から毎回くじで選ぶ） ----------
// 結果は始める前に決めてあり、演出はそれを見せるだけ。運（BCD）が高いほど大当たりが出やすい
const LOT_TIERS = [
  {n:1, name:'当たり', txt:'パーツを1つ選べる', cls:'t0'},
  {n:2, name:'大当たり！', txt:'パーツを2つ選べる', cls:'t1'},
  {n:3, name:'超大当たり！！', txt:'パーツを3つ選べる＋HP全回復', cls:'t2'},
];
const LOT_KINDS = ['slot', 'roulette', 'cards'];
let LOT = null, lotLastKind = '';
const pickOne = a => a[(Math.random() * a.length) | 0];
function lotTier(){
  const p3 = Math.min(0.2, 0.07 * S.luck), p2 = Math.min(0.45, 0.25 * S.luck), r = Math.random();
  return r < p3 ? 2 : r < p3 + p2 ? 1 : 0;
}
// スロットの絵柄：在庫のある商品の写真から6つ。足りなければ型番の文字で
function lotSymbols(){
  const seen = new Set(), out = [];
  for (const p of Object.values(DB.byH).filter(inStock).sort(() => Math.random() - 0.5)){
    if (seen.has(p.g)) continue; seen.add(p.g); out.push(p);
    if (out.length >= 6) break;
  }
  for (const c of ['EC-17', 'TA-03', 'FC-01', 'SB-01']) if (out.length < 4) out.push({code:c});
  return out;
}
const lotTile = s => s === 'T' ? '<span class="lt-logo">TERAISM</span>'
  : (s.h ? `<img src="${imgSrc(s)}" alt="">` : `<span class="lt-code">${esc(s.code)}</span>`);

function openLottery(){
  const tier = lotTier();
  let kind = pickOne(LOT_KINDS.filter(k => k !== lotLastKind)); lotLastKind = kind;
  const stage = $('lotStage'); stage.className = 'lot-stage lot-' + kind;   // 「slot」は画面上のパーツ欄と同じ名前になるので lot- を付ける stage.innerHTML = '';
  $('lotTitle').textContent = '宝箱の抽選！'; $('lotTitle').className = 'display';
  $('lotResult').hidden = true; $('lotGo').hidden = true;
  LOT = {tier, kind, t0:performance.now(), done:false, skipAt:null, revealed:false};
  ({slot:lotSlot, roulette:lotRoulette, cards:lotCards})[kind](LOT, stage);
  ovArt('ovLot', 'lot-bg');
  setState('lot');
  sfx('chest');
  requestAnimationFrame(lotFrame);
}
function lotFrame(now){
  if (!LOT || state !== 'lot' || LOT.revealed) return;
  LOT.step((now - LOT.t0) / 1000);
  if (LOT.done) lotReveal(); else requestAnimationFrame(lotFrame);
}
// 画面をタップ・スペースキーで早送り（カードめくりは真ん中を選ぶ）
function lotSkip(){
  if (!LOT) return;
  if (LOT.revealed){ if (performance.now() - LOT.revAt > 600) lotGo(); return; }
  if (LOT.pick) LOT.pick(1); else if (LOT.skipAt == null) LOT.skipAt = (performance.now() - LOT.t0) / 1000;
}
function lotReveal(){
  const L = LOT, T = LOT_TIERS[L.tier]; L.revealed = true; L.revAt = performance.now();
  $('lotTitle').textContent = T.name; $('lotTitle').className = 'display lot-' + T.cls;
  $('lotResult').innerHTML = `<b>${T.name}</b>${T.txt}`; $('lotResult').className = 'lot-result ' + T.cls; $('lotResult').hidden = false;
  $('lotGo').hidden = false; $('lotGo').focus({preventScroll:true});
  const msg = $('lotStage').querySelector('.lot-msg'); if (msg) msg.textContent = '';
  G.pending += T.n - 1; G.chest += T.n - 1;
  if (L.tier === 2) G.p.hp = G.p.maxHp;
  sfx(L.tier === 2 ? 'jackpot' : L.tier === 1 ? 'win' : 'chest');
  if (L.tier > 0 && !reduceMotion) G.flash = 0.3;
}
function lotGo(){
  if (state !== 'lot' || !LOT || !LOT.revealed) return;
  LOT = null; openLevelUp();
}

// 1) スロット：TERAISM が3つで超大当たり、同じ商品が3つで大当たり。最初の2つがそろうと「リーチ！」
function lotSlot(L, stage){
  const syms = lotSymbols();
  let fin;
  if (L.tier === 2) fin = ['T', 'T', 'T'];
  else if (L.tier === 1){ const s = pickOne(syms); fin = [s, s, s]; }
  else {
    const a = pickOne(syms), b = Math.random() < 0.45 ? a : pickOne(syms.filter(x => x !== a));
    fin = [a, b, pickOne(syms.filter(x => x !== a && x !== b).concat(Math.random() < 0.3 ? ['T'] : []))];
  }
  const reach = fin[0] === fin[1];
  for (const x of syms) if (x.h){ const im = new Image(); im.src = imgSrc(x); }   // 回っている途中で空白にならないよう先に読む
  const stops = [0.9, 1.4, reach ? 2.9 : 1.9], pool = syms.concat(['T']);
  stage.innerHTML = '<div class="reels">' + [0, 1, 2].map(() => '<div class="reel"><div class="lt"></div></div>').join('') + '</div><div class="lot-msg"></div>';
  const reels = [...stage.querySelectorAll('.reel')], last = [0, 0, 0], stopped = [false, false, false];
  reels.forEach(r => r.firstChild.innerHTML = lotTile(pickOne(pool)));
  L.step = el => {
    for (let i = 0; i < 3; i++){
      if (stopped[i]) continue;
      const at = L.skipAt == null ? stops[i] : Math.min(stops[i], L.skipAt + 0.12 * i);
      if (el >= at){
        stopped[i] = true; reels[i].firstChild.innerHTML = lotTile(fin[i]); reels[i].classList.add('stop'); sfx('reel');
        if (i === 1 && reach){ stage.querySelector('.lot-msg').textContent = 'リーチ！'; reels[2].classList.add('reach'); sfx('reach'); }
      } else if (el - last[i] > 0.05 + Math.max(0, el - (at - 0.6)) * 0.25){
        last[i] = el; reels[i].firstChild.innerHTML = lotTile(pickOne(pool)); if (i === 2) sfx('tick');
      }
    }
    if (stopped[2] && el > Math.min(stops[2], L.skipAt == null ? 99 : L.skipAt + 0.24) + 0.35){
      if (fin[0] === fin[1] && fin[1] === fin[2]) reels.forEach(r => r.classList.add('win'));
      L.done = true;
    }
  };
}

// 2) ルーレット：12マスを光が回り、だんだん遅くなって止まる
function lotRoulette(L, stage){
  const cells = [0, 0, 1, 0, 0, 2, 0, 1, 0, 0, 1, 0];
  const label = ['×1', '×2', '×3'];
  const target = pickOne(cells.map((c, i) => c === L.tier ? i : -1).filter(i => i >= 0));
  const total = 12 * 3 + target, dur = reduceMotion ? 1.2 : 2.8;
  stage.innerHTML = '<div class="wheel">' + cells.map((c, i) => {
    const a = i / 12 * Math.PI * 2 - Math.PI / 2;
    return `<span class="cell c${c}" style="left:${50 + Math.cos(a) * 40}%;top:${50 + Math.sin(a) * 40}%">${label[c]}</span>`;
  }).join('') + '<span class="hub">宝箱</span></div>';
  const els = [...stage.querySelectorAll('.cell')]; let cur = -1, end = dur;
  L.step = el => {
    if (L.skipAt != null) end = Math.min(end, L.skipAt + 0.25);
    const k = Math.min(1, el / end), pos = Math.floor(total * (1 - Math.pow(1 - k, 3)));
    const idx = Math.min(pos, total) % 12;
    if (idx !== cur){ if (cur >= 0) els[cur].classList.remove('on'); els[idx].classList.add('on'); cur = idx; sfx('tick'); }
    if (k >= 1 && el > end + 0.3){ els[target].classList.add('win'); L.done = true; }
  };
}

// 3) カードめくり：伏せた3枚から1枚を選ぶ（キー 1〜3 かタップ）。選ばなかった2枚もあとで見せる
function lotCards(L, stage){
  const others = [0, 1, 2].filter(t => t !== L.tier).sort(() => Math.random() - 0.5);
  stage.innerHTML = '<div class="lcards">' + [0, 1, 2].map(i => `<button type="button" class="lcard" data-i="${i}"><span class="back">?</span><span class="face"></span></button>`).join('') + '</div><div class="lot-msg">1枚えらんでめくってね</div>';
  const cards = [...stage.querySelectorAll('.lcard')];
  if (SPR['lot-cardback']) for (const c of cards){ const bk = c.querySelector('.back'); bk.textContent = ''; bk.style.background = `#fff url("${sprUrl('lot-cardback')}") center / 100% 100% no-repeat`; }
  let picked = -1, pickedAt = 0;
  L.pick = i => {
    if (picked >= 0) return;
    picked = i; pickedAt = (performance.now() - L.t0) / 1000; sfx('flip');
    let o = 0;
    cards.forEach((c, j) => {
      const t = j === i ? L.tier : others[o++];
      c.querySelector('.face').innerHTML = `<b>${label3(t)}</b><small>${LOT_TIERS[t].txt}</small>`;
      c.classList.add('t' + t);
      if (j === i) c.classList.add('open');
    });
    stage.querySelector('.lot-msg').textContent = '';
  };
  const label3 = t => ['当たり', '大当たり', '超大当たり'][t];
  cards.forEach((c, i) => c.onclick = e => { e.stopPropagation(); L.pick(i); });
  let shown = false;
  L.step = el => {
    if (picked < 0) return;
    if (!shown && el > pickedAt + 0.6){ shown = true; cards.forEach((c, j) => { if (j !== picked) c.classList.add('open', 'dim'); }); sfx('flip'); }
    if (el > pickedAt + 1.1) L.done = true;
  };
}
function renderSlots(){
  const nw = G.order.filter(g => GROUPS[g].kind === 'w').length, np = G.order.length - nw;
  $('slots').innerHTML = `<span class="slot">武器 <b>${nw}/${SLOT_MAX.w}</b>・能力 <b>${np}/${SLOT_MAX.p}</b></span>` + G.order.map(g => {
    const sale = G.installed.some(x => x.g === g && x.sale);
    const code = DB.byH[G.installed.filter(x => x.g === g).slice(-1)[0].h].code;
    return `<span class="slot ${GROUPS[g].kind}${sale ? ' s' : ''}">${esc(code)} <b>Lv${G.lv_[g]}</b></span>`;
  }).join('');
}
function usedHtml(){
  return G.installed.map(x => {
    const p = DB.byH[x.h];
    return `<a href="${STORE_URL + encodeURIComponent(p.h)}" target="_blank" rel="noopener"><img src="${imgSrc(p)}" alt=""><div><b>${esc(p.code)}｜${esc(p.name)}</b><span>${GROUPS[x.g].role}・定価 ${yen(listPrice(p))}${x.sale ? '・セール特典つき' : ''}</span></div></a>`;
  }).join('');
}

const fmt = t => { t = Math.max(0, Math.ceil(t)); return Math.floor(t / 60) + ':' + String(t % 60).padStart(2, '0'); };
let hudCache = {};
function updateHud(dt){
  if (toastT > 0){ toastT -= dt; if (toastT <= 0) $('toast').hidden = true; }
  if (!G || state === 'title') return;
  const set = (id, v) => { if (hudCache[id] !== v){ hudCache[id] = v; $(id).textContent = v; } };
  $('xpbar').style.width = Math.min(100, G.xp / need(G.lv) * 100) + '%';
  const hp = Math.max(0, Math.ceil(G.p.hp)), f = G.p.hp / G.p.maxHp;
  $('hpFill').style.width = Math.max(0, f * 100) + '%';
  set('hpTxt', hp + ' / ' + G.p.maxHp);
  $('hpBox').classList.toggle('low', f < 0.3);
  set('lv', 'Lv ' + G.lv);
  set('pts', Math.floor(G.pts).toLocaleString('ja-JP') + ' pt');
  set('time', endless() ? fmt(G.t) : fmt(MODES[G.mode].win - G.t));
  set('timeLbl', endless() ? 'エンドレス 走行時間' : G.mode === 'rush' ? 'のこり' : 'ゴールまで');
  const tl = endless() ? 99 : MODES[G.mode].win - G.t, tb = $('time').parentNode;
  tb.classList.toggle('hurry', tl <= 30 && tl > 10);
  tb.classList.toggle('final', tl <= 10);
  const b = G.boss && !G.boss.dead && !G.clearing ? G.boss : null;
  $('bossbar').hidden = !b;
  if (b){ $('bossfill').style.width = Math.max(0, b.hp / b.max * 100) + '%'; set('bossName', b.name); }
}

// ---------- 記録（端末の中。遊び方ごと） ----------
const bestKey = m => 'teraism-survivor-best-' + m;
function loadBest(m){ try { return JSON.parse(localStorage.getItem(bestKey(m || mode))) || null; } catch(e){ return null; } }
function saveBest(b, m){ try { localStorage.setItem(bestKey(m), JSON.stringify(b)); } catch(e){} }
function bestText(b, m){
  if (!b) return '';
  return `${MODES[m || mode].label}の自己ベスト：${b.clear ? 'クリア' : fmt(b.t) + ' 走行'}・Lv ${b.lv}・${b.kills.toLocaleString('ja-JP')} 体撃破`;
}

// ---------- ストアの受付（ログイン中の方だけ。ゲームは端末で動き、特典の出し入れだけサーバーに聞く） ----------
const API = SHOPCFG && SHOPCFG.proxy ? SHOPCFG.proxy.replace(/\/$/, '') : null;
const LOGGED = !!(SHOPCFG && SHOPCFG.loggedIn);
let SV = null, svErr = null;   // /game/state の答え
/* 遊ばれ方の記録（10/12 依頼者「日ごとのアクセス数やプレイ時間、時間帯ごとの記録」）。
   ストアのページで、ログインしていない方も含めて「開いた・始めた・終わった」だけを送る。誰が遊んだかは送らない。
   受け側は teraism-case-submit の /game/beacon（数を足すだけ）。ページを閉じる瞬間でも届くよう sendBeacon を使う */
/* どこから来たか（10/12 依頼者「どこから来たかの記録を足して」。広告の効果を測るため）。
   広告のリンクの印（utm_source・utm_content／utm_campaign）があればそれ、無ければ広告が自動で付ける印（gclid など）、
   それも無ければひとつ前のサイトで決める。同じ訪問のあいだは最初に決めたものを使う（ページ内で遊び直しても同じ来た場所）。
   広告のリンクの例：/pages/game?utm_source=youtube&utm_medium=ad&utm_content=v1 */
const TRAFFIC = (() => {
  const key = 'teraism-survivor-src';
  try { const c = sessionStorage.getItem(key); if (c) return JSON.parse(c); } catch(e){}
  const q = new URLSearchParams(location.search);
  const norm = v => String(v || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 32);
  let src = norm(q.get('utm_source')), camp = norm(q.get('utm_content') || q.get('utm_campaign'));
  if (!src){
    if (q.has('gclid') || q.has('gbraid') || q.has('wbraid')) src = 'google-ads';
    else if (q.has('fbclid')) src = 'meta';
    else if (q.has('ttclid')) src = 'tiktok';
    else if (q.has('twclid')) src = 'x';
  }
  if (!src){
    let host = '';
    try { host = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch(e){}
    src = !host ? 'direct'
      : host === location.hostname ? 'store'
      : /(^|\.)(youtube\.com|youtu\.be)$/.test(host) ? 'youtube'
      : /(^|\.)(x\.com|twitter\.com|t\.co)$/.test(host) ? 'x'
      : /instagram\.com$/.test(host) ? 'instagram'
      : /(facebook\.com|fb\.com|fb\.me)$/.test(host) ? 'facebook'
      : /tiktok\.com$/.test(host) ? 'tiktok'
      : /(line\.me|line-apps\.com|naver\.jp)$/.test(host) ? 'line'
      : /(^|\.)google\./.test(host) ? 'google'
      : /yahoo\.co\.jp$|yahoo\.com$/.test(host) ? 'yahoo'
      : 'other';
  }
  // 広告のリンクから来たか（utm_medium=ad など、または広告が自動で付ける印）。10/17 追加：広告から来た人には最初に「タップでスタート」の画面を出す
  const med = norm(q.get('utm_medium'));
  const ad = ['ad', 'cpc', 'paid', 'ppc'].includes(med) || ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'twclid'].some(k => q.has(k));
  const v = {src, camp, ad};
  try { sessionStorage.setItem(key, JSON.stringify(v)); } catch(e){}
  return v;
})();
/* 訪問ごとの記録（10/14 依頼者「誰が遊んだかの記録はあったほうがいい」）。
   vid＝このブラウザの訪問者の番号（ブラウザに保存するでたらめな文字。名前やメールとは結び付けない）、
   sid＝このページを開いた1回の番号、t＝開いてからのミリ秒。受け側が1回1行にまとめ、90日で消す */
const rid = () => { try { const a = new Uint8Array(8); crypto.getRandomValues(a); return Array.from(a, x => x.toString(16).padStart(2, '0')).join(''); } catch(e){ return (Math.random().toString(36) + Math.random().toString(36)).replace(/[^a-z0-9]/g, '').slice(0, 16); } };
const VISIT = (() => {
  let vid = '';
  try { vid = localStorage.getItem('teraism-survivor-vid') || ''; if (!/^[a-z0-9]{8,32}$/.test(vid)){ vid = rid(); localStorage.setItem('teraism-survivor-vid', vid); } } catch(e){ vid = ''; }
  return {vid, sid: rid()};
})();
function beacon(ev, extra){
  if (!API) return;
  const data = JSON.stringify(Object.assign({ev, game:'survivor', src:TRAFFIC.src, camp:TRAFFIC.camp, vid:VISIT.vid, sid:VISIT.sid, t:Math.round(performance.now())}, extra || {}));
  try { if (navigator.sendBeacon && navigator.sendBeacon(API + '/game/beacon', new Blob([data], {type:'text/plain'}))) return; } catch(e){}
  try { fetch(API + '/game/beacon', {method:'POST', body:data, keepalive:true, credentials:'same-origin'}); } catch(e){}
}
// 遊んでいる回が終わったことを1回だけ送る（クリア・倒れた・途中でやめた）
function beaconEnd(G0, extra){
  if (!G0 || G0.beaconSent) return;
  G0.beaconSent = true;
  beacon('end', Object.assign({mode:G0.mode, sec:Math.round(G0.mode === 'endless' ? G0.t : Math.min(G0.t, MODES[G0.mode].win))}, extra));
}
(() => {   // ページを開いた（その日にこのブラウザで初めてかどうかだけ添える）
  let first = true;
  try { const k = 'teraism-survivor-seen', d = todayJST(); first = localStorage.getItem(k) !== d; localStorage.setItem(k, d); } catch(e){}
  // vis＝開いた瞬間に画面に見えていたか（10/14 追加）。アプリが広告の裏で先読みしただけなら見えていない
  const vis0 = document.visibilityState === 'visible';
  beacon('view', {first, vis: vis0});
  if (!vis0){   // 裏で読み込まれた回：あとで初めて画面に出たら1回だけ知らせる
    const onShow = () => { if (document.visibilityState !== 'visible') return; document.removeEventListener('visibilitychange', onShow); beacon('shown'); };
    document.addEventListener('visibilitychange', onShow);
  }
  // 初めて画面に触れた（指・キー・ホイール・スクロール）。人か機械（先読みなど）かを見分ける手がかり
  let touched = false;
  const onTouch = () => { if (touched) return; touched = true; beacon('touch'); };
  for (const t of ['pointerdown', 'touchstart', 'keydown', 'wheel']) addEventListener(t, onTouch, {capture:true, passive:true, once:true});
  $('ovTitle').addEventListener('scroll', onTouch, {passive:true, once:true});
  // ページを離れた・見えなくなった（スマホは pagehide が来ないことがあるので、見えなくなるたびに送る。受け側はいちばん遅い時点を残す）
  addEventListener('pagehide', () => beacon('leave'));
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') beacon('leave'); });
})();
async function api(path, body){
  try {
    const r = await fetch(API + path, body
      ? {method:'POST', headers:{'content-type':'application/json'}, body:JSON.stringify(body), credentials:'same-origin'}
      : {credentials:'same-origin'});
    const j = await r.json().catch(() => ({}));
    if (!r.ok && !j.error) j.error = `通信に失敗しました（${r.status}）`;
    if (!r.ok) j.ok = false;
    return j;
  } catch(e){ return {ok:false, error:'通信できませんでした。電波の良いところでもう一度お試しください'}; }
}
async function loadState(){
  if (!API || !LOGGED) return;
  const r = await api('/game/state');
  if (r.ok){ SV = r; svErr = null; } else svErr = r.error;
  renderReward();
}
const mdToday = () => md(todayJST());
const C3_MIN_SEC = 20;   // 3分チャレンジで商品を選べる最低の遊び時間（受付の game.js と同じ）
const mypageLink = () => `受け取った特典は<a href="${(SHOPCFG && SHOPCFG.mypageUrl) || '/pages/case-mine'}" target="_blank" rel="noopener">マイページ</a>でも確認できます。`;

// 遊ぶ前に見せる特典の説明（日付つき）
function rewardHtml(m){
  const d = `<span class="day">${mdToday()}</span>`;
  if (m === 'endless'){
    if (!SHOPCFG) return `${d}特典はありません。倒れるまで走り続けて、自己ベストに挑戦。`;
    if (!LOGGED) return `${d}特典はありません。<a href="${SHOPCFG.loginUrl}">ログイン</a>すると、記録がランキングに載ります（1時間ごとに更新）。`;
    const b = SV && SV.endless.best;
    return `${d}特典はありません。記録はランキングに載ります（1時間ごとに更新）。${b ? `<br><span class="note">あなたの記録：${fmt(b.ms / 1000)} 走行・Lv ${b.lv}</span>` : ''}`;
  }
  const what = m === 'c1'
    ? `クリアで <b>50ポイント プレゼント</b>`
    : `遊び終わったら（<b>途中で倒れても</b>）、ゲーム中に取り付けた商品から<b>3つまで</b>選んで、<b>${mdToday()}のご注文に限り ポイント還元 +10%</b>`;
  const note = m === 'c1'
    ? '1日1回。翌朝9時ごろにお付けします。<b class="exp">有効期限は付与から7日間</b>（過ぎると使えなくなります）。'
    : '1日1回。選べるのは20秒以上遊んだ回からです。「キャンペーン対象外」の商品と販売していない商品は選べません。';
  if (!SHOPCFG) return `${d}<span class="off">${what}（TERAISM公式ストアのゲームページで遊ぶと受け取れます）</span>`;
  if (!LOGGED) return `${d}${m === 'c3' ? '<b>特典つきの挑戦は、やり直し3回まで</b>（最初の1回と合わせて1日4回）<br>' : ''}${what}<br><span class="note">特典を受け取るには<a href="${SHOPCFG.loginUrl}">ログイン</a>が必要です。ログインしなくても遊べます。${note}</span>`;
  if (!SV) return svErr ? `${d}<span class="off">特典の状況を確認できませんでした（${esc(svErr)}）。特典なしで遊べます。</span>` : `${d}特典の状況を確認しています…`;
  // 公開の切り替え（受付の GAME_OPEN）が閉じているあいだ
  if (SV.open === false) return `${d}<span class="off">ゲームの特典は準備中です。遊ぶことはできます。</span>`;
  if (m === 'c1'){
    if (SV.c1.claimed) return `${d}<span class="off">本日の50ポイントは受け取り済みです。このまま何度でも遊べます。</span>`;
    return `${d}${what}<br><span class="note">${note}受け取った特典はマイページでも確認できます。</span>`;
  }
  const c3 = SV.c3;
  if (c3.claimed) return `${d}<span class="off">本日の特典は受け取り済みです：${c3.picked.map(x => esc(x.title)).join('、')}（${mdToday()}のご注文で還元 +${c3.bonusRate}%）。このまま何度でも遊べます。</span>`;
  if (!c3.bonusAllowed) return `${d}<span class="off">ポイント還元キャンペーン中のため、本日の特典はお休みです。遊ぶことはできます。</span>`;
  if (!c3.startsLeft) return `${d}<span class="off">本日の特典の挑戦（4回）を使い切りました。このまま何度でも遊べます。</span>`;
  return `${d}<b>特典つきの挑戦は、やり直し3回まで</b>（最初の1回と合わせて1日4回。途中で倒れた回も1回に数えます）<br>${what}<br><span class="note">本日の挑戦 残り<b>${c3.startsLeft}回</b>。${note}受け取った特典はマイページでも確認できます。</span>`;
}
function renderReward(){ $('rewardBox').innerHTML = rewardHtml(mode); }

// サーバーに「特典つきで始める」と伝えるべきか（無駄な呼び出しをしない）
function wantsAttempt(m){
  if (m === 'rush' || !API || !LOGGED || !SV) return false;
  if (m === 'endless') return true;
  if (SV.open === false) return false;   // 特典が閉じているあいだは問い合わせない
  if (m === 'c1') return !SV.c1.claimed;
  return !SV.c3.claimed && SV.c3.bonusAllowed && SV.c3.startsLeft > 0;
}

// ---------- 遊ぶ・終わる ----------
let lastStart = null, starting = false;
async function startRun(g, h){
  if (starting) return;
  audioInit();
  lastStart = {g, h}; hudCache = {};
  let att = null;
  if (wantsAttempt(mode)){
    starting = true; toast('準備しています…');
    const r = await api('/game/start', {mode});
    starting = false; $('toast').hidden = true;
    if (r.attemptId) att = r;
    else if (r.message) toast(r.message);
    else if (r.error) toast('特典の確認ができませんでした。特典なしで始めます');
    if (SV && mode === 'c3' && r.startsLeft != null) SV.c3.startsLeft = r.startsLeft;
    if (SV && mode === 'c3' && r.reason === 'limit') SV.c3.startsLeft = 0;
    if (SV && r.reason === 'claimed') SV[mode].claimed = true;
  }
  newGame(g, DB.byH[h]);
  G.attempt = att;
  beacon('start', {mode:G.mode});
  // Google 広告のコンバージョン「ゲーム開始」（10/17。gtag はストアのゲーム専用の枠だけが読み込む。1回の広告クリックにつき1件だけ数えられる設定）
  try { if (typeof window.gtag === 'function') window.gtag('event', 'conversion', {send_to:'AW-16847462776/0TLGCNfj0J8dEPjCv-E-'}); } catch(e){}
}

// ---------- 1分・3分の終わりの演出 ----------
const CLEAR_SEC = 2.8;
const CONFETTI_COL = ['#F4B400', '#1FA35C', '#F07F6B', '#4FB3E8', '#FFD84D', '#FFFFFF', '#9BD86B'];
function startClear(){
  const P = G.p;
  G.t = MODES[G.mode].win; G.clearing = true; G.clearT = 0;
  P.inv = 99; G.ebullets = []; G.warn = 0; G.flash = 0.6; G.shake = reduceMotion ? 0 : 8;
  // 近い敵から順にはじけさせる（撃破数には数えない）
  G.enemies.sort((a, b) => Math.hypot(b.x - P.x, b.y - P.y) - Math.hypot(a.x - P.x, a.y - P.y));
  G.fx.push({k:'ring', x:P.x, y:P.y, r0:20, r1:Math.hypot(W, H), col:'#F4B400', life:1.1, max:1.1});
  G.fx.push({k:'ring', x:P.x, y:P.y, r0:10, r1:Math.hypot(W, H) * 0.7, col:'#FFFFFF', life:0.8, max:0.8});
  G.confetti = [];
  for (let i = 0; i < (reduceMotion ? 40 : 150); i++){
    G.confetti.push({x:rnd(0, W), y:rnd(-H * 0.9, -10), vx:rnd(-40, 40), vy:rnd(120, 260), rot:rnd(0, TAU), vr:rnd(-8, 8),
      w:rnd(6, 11), h:rnd(9, 16), col:CONFETTI_COL[i % CONFETTI_COL.length], sw:rnd(0, TAU)});
  }
  sfx('gameclear');
}
function clearUpdate(dt){
  G.clearT += dt;
  if (G.enemies.length){
    const n = Math.max(1, Math.ceil(G.enemies.length * Math.min(1, dt * 6)));
    for (let i = 0; i < n && G.enemies.length; i++){
      const e = G.enemies.pop();
      for (let j = 0; j < 6 && G.parts.length < 420; j++){
        const a = rnd(0, TAU), s = rnd(80, 220);
        G.parts.push({x:e.x, y:e.y, vx:Math.cos(a) * s, vy:Math.sin(a) * s, life:rnd(0.3, 0.6), col:j % 2 ? e.col : '#FFF4C2', r:rnd(2, 4.5)});
      }
      if (G.fx.length < 90) G.fx.push({k:'burst', x:e.x, y:e.y, s:e.r * 3, life:0.3, max:0.3});
    }
    sfx('pop');
  }
  for (const p of G.parts){ p.x += p.vx * dt; p.y += p.vy * dt; p.life -= dt; }
  G.parts = G.parts.filter(p => p.life > 0);
  for (const f of G.fx) f.life -= dt;
  G.fx = G.fx.filter(f => f.life > 0);
  for (const t of G.texts){ t.y -= 30 * dt; t.life -= dt; }
  G.texts = G.texts.filter(t => t.life > 0);
  if (G.flash > 0) G.flash -= dt;
  if (G.shake > 0) G.shake = Math.max(0, G.shake - dt * 30);
  for (const c of G.confetti){ c.sw += dt * 5; c.x += (c.vx + Math.sin(c.sw) * 40) * dt; c.y += c.vy * dt; c.rot += c.vr * dt; }
  if (G.clearT >= CLEAR_SEC){ G.clearing = false; endGame(true, true); }
}
// 文字を白い縁どりで描く
function bigText(s, x, y, px, fill, edge){
  ctx.font = `400 ${px}px "Dela Gothic One",sans-serif`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  const tw = ctx.measureText(s).width, mw = W * 0.9;   // 画面の幅に収まるように縮める
  if (tw > mw){ px = px * mw / tw; ctx.font = `400 ${px}px "Dela Gothic One",sans-serif`; }
  ctx.lineJoin = 'round';
  ctx.lineWidth = Math.max(6, px * 0.16); ctx.strokeStyle = '#FFFFFF'; ctx.strokeText(s, x, y);
  if (edge){ ctx.lineWidth = Math.max(3, px * 0.07); ctx.strokeStyle = edge; ctx.strokeText(s, x, y); }
  ctx.fillStyle = fill; ctx.fillText(s, x, y);
}
function rewardShort(){
  if (!G.attempt) return '';
  return G.mode === 'c1' ? '50ポイント 獲得！' : 'ポイント還元 +10% の権利 獲得！';
}
function drawFinale(){
  const m = MODES[G.mode];
  if (!m.win) return;
  const S0 = Math.min(W, H);
  if (G.clearing){
    const k = G.clearT;
    // 背景を明るく
    ctx.fillStyle = `rgba(255,251,234,${Math.min(0.45, k * 1.2)})`; ctx.fillRect(0, 0, W, H);
    // 回る光の筋
    const cy = H * 0.4;
    ctx.save(); ctx.translate(W / 2, cy); ctx.rotate(k * 0.6);
    ctx.globalAlpha = Math.min(0.5, k * 1.5);
    for (let i = 0; i < 14; i++){
      ctx.rotate(TAU / 14);
      ctx.fillStyle = i % 2 ? 'rgba(244,180,0,.35)' : 'rgba(255,216,77,.25)';
      ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(Math.hypot(W, H), -40); ctx.lineTo(Math.hypot(W, H), 40); ctx.fill();
    }
    ctx.restore(); ctx.globalAlpha = 1;
    // GAME CLEAR!（大きく出てから弾んで落ち着く）
    const t = Math.min(1, k / 0.45);
    const sc = t < 1 ? 2.4 - 1.4 * (1 - Math.pow(1 - t, 3)) + Math.sin(t * Math.PI) * 0.15 : 1 + Math.sin(k * 5) * 0.025;
    const px = Math.min(76, W / 7.5) * sc;
    ctx.globalAlpha = Math.min(1, k * 4);
    bigText(G.mode === 'rush' ? 'FINISH!' : 'GAME CLEAR!', W / 2, cy, px, '#157A44', '#F4B400');
    // 達成したモードと獲得した特典
    if (k > 0.6){
      ctx.globalAlpha = Math.min(1, (k - 0.6) * 4);
      const sp = Math.min(26, W / 15), base = Math.min(76, W / 7.5);
      bigText(G.mode === 'rush' ? `${G.kills.toLocaleString('ja-JP')} 体 撃破！` : `${m.label} 達成！`, W / 2, cy + base * 0.5 + sp * 1.2, G.mode === 'rush' ? sp * 1.4 : sp, '#1E4A35');
      const r = rewardShort();
      if (r && k > 1.0){
        ctx.globalAlpha = Math.min(1, (k - 1.0) * 4);
        const rp = Math.min(30, W / 13) * (1 + Math.max(0, 0.25 - (k - 1.0)) * 1.6);
        bigText(r, W / 2, cy + base * 0.5 + sp * 3, rp, '#E07B2E', '#FFE7A3');
      }
    }
    ctx.globalAlpha = 1;
    // 紙吹雪
    for (const c of G.confetti){
      if (c.y < -20 || c.y > H + 20) continue;
      ctx.save(); ctx.translate(c.x, c.y); ctx.rotate(c.rot); ctx.scale(1, Math.abs(Math.cos(c.sw)) * 0.8 + 0.2);
      ctx.fillStyle = c.col; ctx.fillRect(-c.w / 2, -c.h / 2, c.w, c.h); ctx.restore();
    }
    return;
  }
  const left = m.win - G.t;
  if (left > 10 || left <= 0) return;
  const n = Math.ceil(left), f = n - left;   // f：その秒に入ってからの経過（0→1）
  const last3 = n <= 3;
  // 画面のふちが1秒ごとに光る（残り3秒は強く）
  const ga = (1 - f) * (last3 ? 0.55 : 0.32);
  const gr = ctx.createRadialGradient(W / 2, H / 2, S0 * 0.3, W / 2, H / 2, Math.max(W, H) * 0.72);
  gr.addColorStop(0, 'rgba(255,216,77,0)'); gr.addColorStop(1, `rgba(${last3 ? '255,170,60' : '255,216,77'},${ga})`);
  ctx.fillStyle = gr; ctx.fillRect(0, 0, W, H);
  // 大きな数字：秒が変わった瞬間に大きく出て、すっと縮む
  const pop = 1 + Math.pow(Math.max(0, 1 - f * 3.5), 2) * (last3 ? 0.9 : 0.6);
  const base = Math.min(S0 * (last3 ? 0.36 : 0.3), 230), px = base * pop;
  // 自機（画面の中央）と上のボスの帯を避けて、自機のすぐ下から下半分に出す
  const sp = Math.min(26, W / 14), ly = H / 2 + 56 + sp * 0.5, cy = ly + sp * 0.7 + base * 0.55;
  ctx.globalAlpha = 0.9 - f * 0.25;
  bigText(String(n), W / 2 + (last3 && !reduceMotion ? Math.sin(G.t * 60) * (1 - f) * 4 : 0), cy, px, last3 ? '#E8603C' : '#157A44', last3 ? '#FFD84D' : '#9BD86B');
  ctx.globalAlpha = 1;
  bigText(G.mode === 'rush' ? `のこり ${n} 秒` : `クリアまで あと ${n} 秒`, W / 2, ly, sp, '#1E4A35', '#FFD84D');
}
// クライマックスの「3・2・1」と、遊んでいるあいだの撃破数
function drawRush(){
  if (!G || G.mode !== 'rush' || G.clearing) return;
  const S0 = Math.min(W, H), sp = Math.min(28, W / 13);
  if (G.pre > 0){
    const n = Math.ceil(G.pre), f = n - G.pre, pop = 1 + Math.pow(Math.max(0, 1 - f * 3), 2) * 0.6;
    ctx.fillStyle = 'rgba(232,246,236,.35)'; ctx.fillRect(0, 0, W, H);
    bigText(String(n), W / 2, H * 0.42, Math.min(S0 * 0.34, 240) * pop, '#157A44', '#9BD86B');
    bigText('フル装備で、敵を一掃しろ！', W / 2, H * 0.42 + Math.min(S0 * 0.22, 150), sp, '#1E4A35', '#FFD84D');
    return;
  }
  if (G.t < 1){ ctx.globalAlpha = 1 - G.t; bigText('スタート！', W / 2, H * 0.42, Math.min(S0 * 0.2, 130) * (1 + (1 - G.t) * 0.3), '#E07B2E', '#FFE7A3'); ctx.globalAlpha = 1; }
  bigText(`撃破 ${G.kills.toLocaleString('ja-JP')}`, W / 2, Math.max(120, H * 0.18), Math.min(44, W / 8), '#157A44', '#F4B400');
}

function endGame(win, quiet){
  const m = G.mode, cur = {t:m === 'endless' ? G.t : Math.min(G.t, MODES[m].win), lv:G.lv, kills:G.kills, clear:win};
  const old = loadBest(m);
  const isNew = !old || (cur.clear && !old.clear) || (cur.clear === !!old.clear && (cur.t > old.t || (cur.t === old.t && cur.kills > old.kills)));
  if (isNew) saveBest(cur, m);
  G.result = cur;
  $('endTitle').textContent = m === 'rush' ? `${cur.kills.toLocaleString('ja-JP')} 体 撃破！` : win ? 'GAME CLEAR!' : m === 'endless' ? `エンドレス ${fmt(cur.t)} 走行` : 'オーバーヒート…';
  $('ovEnd').classList.toggle('clear', !!win);
  ovArt('ovEnd', win ? 'result-clear' : 'result-over');
  $('endSub').textContent = m === 'rush' ? 'クライマックスは30秒の体験版です。本編では、パーツを集めて強くしながら生き残ります。'
    : win ? `${MODES[m].label}を走り切りました！ 愛車は絶好調です。`
    : m === 'endless' ? `${G.reached10 ? '10分到達！ ' : ''}倒れるまでに ${cur.kills.toLocaleString('ja-JP')} 体を撃破。集めたポイント ${Math.floor(G.pts).toLocaleString('ja-JP')} pt。`
    : `集めたポイント ${Math.floor(G.pts).toLocaleString('ja-JP')} pt。パーツを組み直してもう一度。`;
  $('eTime').textContent = fmt(cur.t);
  $('eLv').textContent = cur.lv;
  $('eKills').textContent = cur.kills.toLocaleString('ja-JP');
  $('endBest').textContent = isNew ? '自己ベスト更新！' : bestText(old, m);
  $('endList').innerHTML = usedHtml();
  beaconEnd(G, {clear:!!win});
  renderHero(win);
  renderClaim(win);
  renderNext(win);
  setState('end');
  $('ovEnd').scrollTop = 0;
  if (!quiet) sfx(win ? 'clear' : 'over');
}

// クリア後の特典の画面
function renderClaim(win){
  const box = $('claimBox'), m = G.mode, att = G.attempt;
  box.hidden = true; box.innerHTML = '';
  if (m === 'endless'){
    if (att && G.result && (!SV || !SV.endless.best || G.result.t * 1000 > SV.endless.best.ms)){
      api('/game/score', {attemptId:att.attemptId, ms:Math.round(G.result.t * 1000), kills:G.result.kills, lv:G.result.lv}).then(r => {
        if (r.ok && SV){ SV.endless.best = {ms:r.ms, kills:G.result.kills, lv:G.result.lv}; }
        box.hidden = false;
        box.innerHTML = r.ok ? `<p class="ok">記録を送りました。ランキングは1時間ごとに更新されます。</p>` : `<p class="err">${esc(r.error || '記録を送れませんでした')}</p>`;
      });
    }
    return;
  }
  if (!att) return;
  box.hidden = false;
  // 1分チャレンジはクリアが条件。3分チャレンジは途中で倒れても選べる（20秒以上遊んだ回だけ）
  if (!win && m === 'c1'){
    box.innerHTML = `<h3>特典はクリアで受け取れます</h3><p>「もう一度走る」で何度でも挑戦できます。</p>`;
    return;
  }
  if (!win && G.t < C3_MIN_SEC){
    const left = SV ? SV.c3.startsLeft : 0;
    box.innerHTML = `<h3>${C3_MIN_SEC}秒以上遊んだ回から選べます</h3><p>${left > 0 ? `本日の挑戦は残り<b>${left}回</b>です。「もう一度走る」で挑戦できます。` : '本日の挑戦（4回）を使い切りました。遊ぶことはできます。'}</p>`;
    return;
  }
  if (m === 'c1'){
    box.innerHTML = `<h3>50ポイントを受け取っています…</h3>`;
    api('/game/claim', {mode:'c1', attemptId:att.attemptId}).then(r => {
      if (r.ok){
        if (SV) SV.c1.claimed = true;
        // 有効期限は日付で目立たせる（10/11 依頼者「7日間有効が見えづらい」）。付与は翌朝9時、期限はその7日後の朝9時ごろ
        const ex = c1Dates(r.day);
        box.innerHTML = `<h3>受け取りが完了しました</h3><p class="ok">${ex.grant}の朝9時ごろにお付けします。</p>
          <p class="expire">有効期限：<b>${ex.expire}の朝9時ごろまで</b><small>付与から7日間。過ぎると使えなくなります</small></p><p>${mypageLink()}</p>`;
      } else { $('rewardHero').hidden = true; box.innerHTML = `<h3>特典を受け取れませんでした</h3><p class="err">${esc(r.error || '')}</p>`; }
    });
    return;
  }
  // 3分チャレンジ：取り付けた商品から3つまで選ぶ
  const eligible = G.installed.map(x => DB.byH[x.h]).filter(p => p && p.id && inStock(p) && !(p.tags || []).includes('キャンペーン対象外'));
  eligible.sort((a, b) => (saleOf(b) && saleOf(b).kind === 'daily' ? 1 : 0) - (saleOf(a) && saleOf(a).kind === 'daily' ? 1 : 0));
  const picked = new Set();
  const left = SV ? SV.c3.startsLeft : 0;
  const draw = () => {
    box.innerHTML = `<h3>${win ? 'ポイントアップする商品を選ぶ（3つまで）' : 'ここまでに取り付けた商品から選ぶ（3つまで）'}</h3>
      <p>選んだ商品は、<b>${mdToday()}のご注文に限り</b>ポイント還元が <b>+10%</b> になります。ゲーム中に取り付けた商品から選べます。${win ? '' : 'やり直して、もっと先まで進めば選べる商品が増えます。'}</p>
      <div class="picks">${eligible.map(p => {
        const on = picked.has(p.id), daily = saleOf(p) && saleOf(p).kind === 'daily';
        return `<button type="button" class="pick${daily ? ' daily' : ''}" data-id="${p.id}" aria-pressed="${on}" ${!on && picked.size >= 3 ? 'disabled' : ''}>
          <img src="${imgSrc(p)}" alt=""><span><b>${esc(p.code)}｜${esc(p.name)}</b><small>${daily ? '本日の日替わりセール品・' : ''}定価 ${yen(listPrice(p))}</small></span></button>`;
      }).join('') || '<p class="err">選べる商品がありません（在庫切れ・対象外の商品だけでした）。</p>'}</div>
      <div class="btns">
        <button type="button" class="btn" id="claimGo" ${picked.size ? '' : 'disabled'}>${picked.size ? `この${picked.size}つで決定` : '商品を選んでください'}</button>
        ${left > 0 ? `<button type="button" class="btn ghost" id="claimRetry">もう一度やり直す（残り${left}回）</button>` : ''}
      </div>
      <p class="note muted">決定すると本日は変更できません。やり直すと、今回のパーツからは選べなくなります。</p>`;
    box.querySelectorAll('.pick').forEach(b => b.onclick = () => { const id = b.dataset.id; picked.has(id) ? picked.delete(id) : picked.size < 3 && picked.add(id); draw(); });
    const go = $('claimGo');
    if (go) go.onclick = async () => {
      go.disabled = true; go.textContent = '手続きしています…';
      const r = await api('/game/claim', {mode:'c3', attemptId:att.attemptId, acquired:eligible.map(p => p.id), picks:[...picked]});
      if (r.ok){
        if (SV){ SV.c3.claimed = true; SV.c3.picked = r.picked; }
        box.innerHTML = `<h3>ポイントアップが決まりました！</h3><p class="ok">${esc(r.note)}</p>
          <p>${mypageLink()}</p>
          <div class="used">${r.picked.map(x => { const p = Object.values(DB.byH).find(y => y.id === x.id); return p ? `<a href="${STORE_URL + encodeURIComponent(p.h)}" target="_blank" rel="noopener"><img src="${imgSrc(p)}" alt=""><div><b>${esc(p.code)}｜${esc(p.name)}</b><span>${mdToday()}のご注文で還元 +10%</span></div></a>` : ''; }).join('')}</div>`;
      } else {
        if (r.ng) for (const x of r.ng){ const i = eligible.findIndex(p => p.id === x.id); if (i >= 0){ eligible.splice(i, 1); picked.delete(x.id); } }
        draw();
        box.insertAdjacentHTML('beforeend', `<p class="err">${esc(r.error || '手続きに失敗しました')}${r.ng ? '：' + r.ng.map(x => `${esc(x.title)}（${esc(x.why)}）`).join('、') : ''}</p>`);
      }
    };
    const rt = $('claimRetry');
    if (rt) rt.onclick = () => $('againBtn').click();
  };
  draw();
}

// クリアの画面の一番上に、獲得した特典を大きく出す（10/11 依頼者「獲得した商品を表示してあげるとよさそう」）
function renderHero(win){
  const el = $('rewardHero'), m = G.mode;
  el.hidden = true; el.className = 'reward-hero'; el.innerHTML = '';
  if (!win || m === 'endless' || m === 'rush') return;
  const big = m === 'c1' ? '<b>50</b>ポイント' : 'ポイント還元 <b>+10%</b> の権利';
  if (G.attempt){
    const ex = c1Dates(todayJST());
    el.innerHTML = `<span class="lbl">🎁 獲得した特典</span><span class="big">${big}</span>`
      + (m === 'c1'
        ? `<span class="sub">${ex.grant}の朝9時ごろにお付けします</span><span class="exp">有効期限：<b>${ex.expire}の朝9時ごろまで</b><span class="nw">（付与から7日間）</span></span>`
        : `<span class="sub">下の一覧から、還元をアップする商品を<b>3つまで</b>選んでください</span><span class="exp">${mdToday()}のご注文に限り有効</span>`);
  } else {
    el.classList.add('none');
    let why = '今回は特典の対象外です。';
    if (!API) why = `<a href="https://shop.light-technical.com/pages/game">TERAISMのストア</a>でログインして遊ぶと受け取れます。`;
    else if (!LOGGED) why = `<a href="${SHOPCFG.loginUrl}">ログイン</a>して遊ぶと、この特典を受け取れます。`;
    else if (SV && SV[m] && SV[m].claimed) why = '本日の特典は受け取り済みです。また明日も遊んでくださいね。';
    else if (SV && SV.open === false) why = '特典の受付はお休み中です。';
    el.innerHTML = `<span class="lbl">クリアでもらえる特典</span><span class="big">${big}</span><span class="sub">${why}</span>`;
  }
  el.hidden = false;
}

// 1分チャレンジのあとの「次の一手」（10/17 依頼者「1分チャレンジ後の画面も工夫して」）。
// クリアしたら同じパーツで3分へ、だめならもう一度1分。ログインしていない方には50ポイントの案内（クリア時は上の特典の枠が案内する）
function renderNext(win){
  const box = $('nextBox'), m = G.mode;
  box.hidden = true; box.innerHTML = '';
  $('endListHead').textContent = 'ゲームのパーツは、TERAISM の本物のカー用品です（押すと商品ページが開きます）';
  if (m === 'rush'){
    box.innerHTML = `<h3>本編で遊んでみよう</h3>
      <button type="button" class="btn big" id="nextC1">本編の 1分チャレンジで遊ぶ<small>ログインして遊ぶと、クリアで50ポイント（1日1回）</small></button>
      <button type="button" class="stepback" id="nextPick">遊び方・パーツを選ぶ</button>`;
    box.hidden = false;
    $('nextC1').onclick = () => { setMode('c1'); beacon('mode', {mode:'c1'}); startRun(lastStart.g, lastStart.h); };
    $('nextPick').onclick = () => { setMode('c1'); G = null; buildTitle(); showStep('mode'); setState('title'); };
    return;
  }
  if (m !== 'c1') return;
  const go = win
    ? `<button type="button" class="btn big" id="nextC3">同じパーツで 3分チャレンジへ<small>NORMAL・少し手ごわくなります</small></button>`
    : `<button type="button" class="btn big" id="nextAgain">もう一度 1分チャレンジ<small>操作に慣れれば、きっとクリアできます</small></button>`;
  const login = API && !LOGGED && !win
    ? `<div class="nextlogin"><b>ログインして遊ぶと、1分クリアで 50ポイント</b><span>1日1回・TERAISM 公式ショップのお買い物に使えます（付与から7日間）</span><a class="btn ghost small" href="${SHOPCFG.loginUrl}">ログイン・会員登録（無料）</a></div>` : '';
  box.innerHTML = `<h3>${win ? '次は何で遊ぶ？' : '惜しい！'}</h3>${go}${login}`;
  box.hidden = false;
  const c3 = $('nextC3'); if (c3) c3.onclick = () => { setMode('c3'); beacon('mode', {mode:'c3'}); startRun(lastStart.g, lastStart.h); };
  const ag = $('nextAgain'); if (ag) ag.onclick = () => startRun(lastStart.g, lastStart.h);
}

// 1分チャレンジの50pt：付与の日（クリアの翌日）と有効期限（付与の7日後）。日本時間で M/D（曜）
function c1Dates(day){
  const base = day ? Date.parse(day + 'T12:00:00+09:00') : Date.now();
  const f = ms => new Date(ms).toLocaleDateString('ja-JP', {timeZone:'Asia/Tokyo', month:'numeric', day:'numeric', weekday:'short'}).replace(/\((.)\)/, '（$1）');
  return { grant: f(base + 86400000), expire: f(base + 8 * 86400000) };
}

// ---------- 記録をシェア ----------
function shareText(){
  const r = G && G.result; if (!r) return '';
  const head = r.clear ? `${MODES[G.mode].label}をクリア！` : G.mode === 'endless' ? `エンドレスで ${fmt(r.t)} 走行！` : `${fmt(r.t)} 走行でオーバーヒート…`;
  return `TERAISM サバイバー：${head} Lv${r.lv}・${r.kills.toLocaleString('ja-JP')}体撃破！ 一緒に遊ぼう🚗⚡ #TERAISMサバイバー`;
}
// 友だちを誘う文（タイトル画面の「友だちを誘う」）
const INVITE_TEXT = '一緒に「TERAISM サバイバー」で遊ぼう！ 静電気モンスターから愛車を守り抜け🚗⚡ TERAISMのパーツで戦う無料のブラウザゲーム #TERAISMサバイバー';
const gameUrl = () => SHOPCFG ? location.origin + location.pathname : 'https://shop.light-technical.com/pages/game';
function shareImage(){
  const c = document.createElement('canvas'); c.width = 1200; c.height = 630;
  const x = c.getContext('2d'), r = G.result;
  x.fillStyle = '#E3F2E6'; x.fillRect(0, 0, 1200, 630);
  x.strokeStyle = '#CBE5D2'; x.lineWidth = 3;
  for (let i = 0; i < 1200; i += 96){ x.beginPath(); x.moveTo(i, 0); x.lineTo(i, 630); x.stroke(); }
  for (let i = 0; i < 630; i += 96){ x.beginPath(); x.moveTo(0, i); x.lineTo(1200, i); x.stroke(); }
  x.fillStyle = '#157A44'; x.font = '400 96px "Dela Gothic One",sans-serif'; x.textAlign = 'center';
  x.fillText('TERAISM', 600, 160);
  x.fillStyle = '#F4B400'; x.strokeStyle = '#157A44'; x.lineWidth = 6;
  x.strokeText('SURVIVOR', 600, 265); x.fillText('SURVIVOR', 600, 265);
  x.fillStyle = '#1E4A35'; x.font = '900 54px "Zen Maru Gothic",sans-serif';
  x.fillText(r.clear ? `${MODES[G.mode].label} クリア！` : G.mode === 'endless' ? `エンドレス ${fmt(r.t)} 走行` : `${fmt(r.t)} 走行`, 600, 380);
  x.font = '700 40px "Zen Maru Gothic",sans-serif'; x.fillStyle = '#4F7462';
  x.fillText(`Lv ${r.lv}　${r.kills.toLocaleString('ja-JP')} 体撃破`, 600, 460);
  x.font = '700 30px "Zen Maru Gothic",sans-serif'; x.fillText('#TERAISMサバイバー', 600, 560);
  return new Promise(res => c.toBlob(b => res(b), 'image/png'));
}
/* シェアのボタン（10/11 依頼者「シェアの仕方が面倒」）：LINE・X・Facebook・コピー・その他（端末の共有メニュー）を最初から並べる。
   文は押した時点で作る（記録は終わった回の結果） */
const SHARE_ICON = {
  line: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3C6.5 3 2 6.6 2 11c0 3.9 3.5 7.2 8.3 7.9.3.1.8.2.9.5.1.3.1.7 0 1l-.1.9c0 .3-.2 1 .9.5s5.9-3.5 8-6C21.4 14.2 22 12.7 22 11c0-4.4-4.5-8-10-8z"/></svg>',
  x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.8 3h3.1l-6.8 7.8L22 21h-6.2l-4.9-6.4L5.3 21H2.2l7.3-8.3L2 3h6.4l4.4 5.8L17.8 3zm-1.1 16.2h1.7L7.4 4.7H5.6l11.1 14.5z"/></svg>',
  fbk: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 8.5V6.8c0-.8.2-1.3 1.4-1.3H17V2.6c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1v1.9H8v3.2h2.6V22H14v-10.3h2.6l.4-3.2h-3z"/></svg>',
  copy: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H10V7h9v14z"/></svg>',
};
function buildShareRow(id, getText, withImage){
  const box = $(id); if (!box) return;
  const btn = (cls, label, fn) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'sbtn ' + cls; b.innerHTML = (SHARE_ICON[cls] || '') + `<span>${label}</span>`; b.onclick = fn; box.appendChild(b); };
  const open = u => window.open(u, '_blank', 'noopener');
  const enc = encodeURIComponent;
  btn('line', 'LINE', () => open(`https://social-plugins.line.me/lineit/share?url=${enc(gameUrl())}&text=${enc(getText())}`));
  btn('x', 'X', () => open(`https://twitter.com/intent/tweet?text=${enc(getText())}&url=${enc(gameUrl())}`));
  btn('fbk', 'Facebook', () => open(`https://www.facebook.com/sharer/sharer.php?u=${enc(gameUrl())}`));
  btn('copy', 'コピー', async () => {
    const t = getText() + ' ' + gameUrl();
    try { await navigator.clipboard.writeText(t); toast('コピーしました。SNS やメッセージに貼り付けてください'); }
    catch(e){ window.prompt('この文をコピーしてください', t); }
  });
  if (navigator.share) btn('more', 'その他', () => shareWith(getText(), withImage));
}
async function share(){ return shareWith(shareText(), true); }
async function shareWith(text, withImage){
  const url = gameUrl();
  try {
    if (navigator.share){
      const blob = withImage ? await shareImage() : null;
      const file = blob && new File([blob], 'teraism-survivor.png', {type:'image/png'});
      const data = file && navigator.canShare && navigator.canShare({files:[file]}) ? {text, url, files:[file]} : {text, url};
      await navigator.share(data);
      return;
    }
  } catch(e){ if (e && e.name === 'AbortError') return; }
}

// ---------- タイトル：今日のセール・キャンペーン・ランキング ----------
function buildTitle(){
  const box = $('starters'); box.innerHTML = '';
  STARTERS.forEach((g, i) => {
    const prod = productFor(g, true);
    if (!prod) return;
    const b = document.createElement('button'); b.type = 'button'; b.className = 'card' + (saleOf(prod) ? ' sale' : ''); b.id = 'starter-' + g;
    b.innerHTML = cardHtml(g, prod, i + 1, true);
    b.onclick = () => startRun(g, prod.h);
    box.appendChild(b);
  });
  $('bestTxt').textContent = bestText(loadBest());
  renderToday();
  renderReward();
  renderRanking();
}
function renderRanking(){
  const rk = SHOPCFG && SHOPCFG.ranking;
  if (!rk || !rk.list || !rk.list.length){ $('rankBox').hidden = true; return; }
  $('rankList').innerHTML = rk.list.slice(0, 10).map(x =>
    `<li><b>${x.rank}</b><span>${esc(x.name)}</span><small>Lv ${x.lv}</small><span>${fmt(x.ms / 1000)}</span></li>`).join('');
  const d = new Date(rk.updatedAt), j = new Date(d.getTime() + 9 * 3600e3);
  $('rankSrc').textContent = `${j.getUTCMonth() + 1}/${j.getUTCDate()} ${j.getUTCHours()}:${String(j.getUTCMinutes()).padStart(2, '0')} 更新（1時間ごと）`;
  $('rankBox').hidden = false;
}
function renderToday(){
  const t = todayJST(), rows = [];
  const camp = activeCampaign();
  if (camp) rows.push(`<div class="ev"><span class="tag">開催中</span><div><b>${esc(camp.name)}</b>（${esc(camp.label)}・${md(camp.to)}まで）<br>ゲーム内のポイント獲得も +${camp.rate}%</div></div>`);
  const saleItems = Object.values(DB.byH).filter(p => inStock(p) && saleOf(p));
  const daily = saleItems.filter(p => saleOf(p).kind === 'daily');
  const others = saleItems.filter(p => saleOf(p).kind === 'sale');
  for (const p of daily.slice(0, 3)){
    const s = saleOf(p);
    rows.push(`<div class="ev"><img src="${imgSrc(p)}" alt=""><div><span class="tag s">本日の日替わりセール ${s.pct}%OFF</span><b>${esc(p.code)}｜${esc(p.name)}</b><br><s>${yen(listPrice(p))}</s> → <b style="color:var(--sale)">${yen(s.now)}</b>　ゲームでは「${GROUPS[p.g].role}」の効果2倍</div></div>`);
  }
  if (others.length) rows.push(`<div class="ev"><span class="tag s">セール中</span><div>${others.slice(0, 4).map(p => esc(p.code)).join('・')}${others.length > 4 ? ` ほか${others.length - 4}点` : ''}：ゲームでは効果2倍</div></div>`);
  for (const e of (DB.promo.events || [])){
    if (e.from > t && daysBetween(t, e.from) <= 21){
      rows.push(`<div class="ev"><span class="tag u">${md(e.from)}から</span><div><b>${esc(e.name)}</b>（${esc(e.label)}）${e.kind === 'daily' ? '<br>セール品はゲームでも効果2倍になります' : ''}</div></div>`);
    }
  }
  if (!rows.length) rows.push('<div class="ev"><span class="tag u">お知らせ</span><div>いま開催中のセール・キャンペーンはありません。</div></div>');
  $('todayList').innerHTML = rows.join('');
  renderSource();
}
const daysBetween = (a, b) => Math.round((Date.parse(b) - Date.parse(a)) / 86400e3);

// ---------- Shopify から最新のセール情報を読む ----------
const LIVE_Q = `{ shop { dd: metafield(namespace:"teraism", key:"daily_deal"){ value } pc: metafield(namespace:"teraism", key:"promo_calendar"){ value } }
  daily: collectionByHandle(handle:"daily-sale"){ products(first:20){ nodes{ handle } } }
  products(first:150, query:"status:active"){ nodes{ handle tags totalInventory variants(first:1){ nodes{ price compareAtPrice } } } } }`;
let srcState = {kind:'snapshot'};
function renderSource(){
  const el = $('srcTxt'); el.classList.remove('warn');
  const asOf = md(SNAPSHOT.asOf);
  if (DB.demo){ el.textContent = '見本表示：日替わりセールを仮に表示しています（実際のセールではありません）'; el.classList.add('warn'); return; }
  if (SHOPCFG){ el.textContent = 'ストアの最新の価格・セール情報で表示しています'; return; }
  const k = srcState.kind;
  if (k === 'live'){ const d = new Date(srcState.at); el.textContent = `Shopifyの最新情報を反映（${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')} 取得）`; return; }
  if (k === 'loading'){ el.textContent = 'Shopifyから最新のセール情報を読んでいます…'; return; }
  const why = {
    needs_reauth:'Shopifyの接続が切れています。claude.ai の設定 → コネクタで再接続すると、最新のセールが反映されます。',
    server_not_connected:'Shopifyコネクタが未接続です。claude.ai の設定 → コネクタで追加すると、最新のセールが反映されます。',
    not_in_manifest:'Shopifyの読み取りが許可されていません。',
    selection_required:'Shopifyコネクタが複数あり、どれを使うか選ばれていません。',
    server_unavailable:'Shopifyが応答しませんでした。少し待って開き直してください。',
  }[srcState.code];
  el.textContent = `${asOf}時点の控えで表示中。` + (why || (srcState.code ? `最新情報を読めませんでした（${srcState.code}）。` : ''));
  if (srcState.code) el.classList.add('warn');
}
function applyLive(d){
  if (!d || !d.products) throw {code:'bad_shape'};
  for (const n of d.products.nodes){
    const p = DB.byH[n.handle]; if (!p) continue;
    const v = n.variants.nodes[0]; if (!v) continue;
    p.price = Math.round(+v.price); p.cmp = v.compareAtPrice ? Math.round(+v.compareAtPrice) : null; p.inv = n.totalInventory;
    p.lim = (n.tags || []).includes('数量限定');
  }
  try { DB.dailyDeal = JSON.parse(d.shop.dd.value); } catch(e){}
  try { DB.promo = JSON.parse(d.shop.pc.value); } catch(e){}
  DB.dailyCol = d.daily ? d.daily.products.nodes.map(n => n.handle) : [];
}
async function liveRefresh(retried){
  if (DB.demo || SHOPCFG) return;
  if (!window.claude || typeof window.claude.use !== 'function'){ srcState = {kind:'snapshot'}; renderSource(); return; }
  let mcp = null;
  try { mcp = await window.claude.use('mcp'); } catch(e){}
  if (!mcp){ srcState = {kind:'snapshot'}; renderSource(); return; }
  srcState = {kind:'loading'}; renderSource();
  try {
    const r = await mcp.callTool('Shopify', 'graphql_query', {query:LIVE_Q}, {cache:{staleTime:60000}});
    let p = r.payload;
    if (typeof p === 'string'){ try { p = JSON.parse(p); } catch(e){} }
    applyLive(p && p.data ? p.data : p);
    srcState = {kind:'live', at:(r.cache && r.cache.storedAt) || Date.now()};
    if (state === 'title') buildTitle(); else renderSource();
  } catch(e){
    if (e && e.retryable && !retried){ setTimeout(() => liveRefresh(true), (e.retryAfterMs || 1500) + Math.random() * 1000); return; }
    srcState = {kind:'snapshot', code:(e && e.code) || 'upstream_error'}; renderSource();
  }
}

// 見本表示（リンクの末尾に #salepreview）：日替わりセールを仮に置いて見た目を確かめる
if (location.hash === '#salepreview'){
  DB.demo = true;
  DB.dailyDeal = {date:todayJST(), percent:30, handles:['teraism-ec-17', 'teraism-ae-09-eb-13-set']};
}

$('pauseBtn').onclick = togglePause;
for (const id of ['soundBtn', 'soundBtnTitle']) $(id).onclick = () => { audioInit(); setSound(!soundOn); if (soundOn) sfx('click'); };
setSound(soundOn);
$('resumeBtn').onclick = () => setState('play');
$('lotGo').onclick = e => { e.stopPropagation(); lotGo(); };
$('ovLot').onclick = () => lotSkip();
const toTitle = () => { beaconEnd(G, {quit:true}); G = null; if (mode === 'rush') setMode('c1'); buildTitle(); showStep('top'); setState('title'); };
$('quitBtn').onclick = toTitle;
$('titleBtn').onclick = toTitle;
$('againBtn').onclick = () => startRun(lastStart.g, lastStart.h);
buildShareRow('inviteRow', () => INVITE_TEXT, false);
buildShareRow('shareRow', () => shareText() || INVITE_TEXT, true);
// 感想を送る：ストアのページでだけ（お問い合わせと同じ仕組みで、ストアのメールに届く）
{
  const ov = $('ovFeedback');
  if (ov){
    const open = () => {
      const r = G && G.result, rec = $('fbRecord');
      if (rec) rec.value = r ? `${MODES[G.mode].label}・${fmt(r.t)}・Lv${r.lv}・${r.kills}体撃破${r.clear ? '・クリア' : ''}` : 'タイトル画面から';
      ov.hidden = false; const t = ov.querySelector('textarea'); if (t) t.focus({preventScroll:true});
    };
    for (const id of ['fbBtnTitle', 'fbBtnEnd']){ const b = $(id); if (b){ b.hidden = false; b.onclick = open; } }
    $('fbClose').onclick = () => { ov.hidden = true; };
    // 送る：まず保管の入口（Worker、たまったら公開するため）。保管できなかったときだけ、お問い合わせの仕組みでメールに送る
    const form = $('gameFeedbackForm');
    if (form && API) form.addEventListener('submit', async (e) => {
      if (form.dataset.fallback) return;   // メールで送る2回目はそのまま送信
      e.preventDefault();
      const f = n => form.elements[n];
      const btn = form.querySelector('button[type=submit]'); btn.disabled = true;
      const rating = 6 - Math.max(1, f('contact[評価]').selectedIndex + 1);
      const r = await api('/game/feedback', {game:'survivor', ver:f('contact[バージョン]').value, rating, body:f('contact[body]').value,
        nickname:f('contact[name]').value, email:f('contact[email]').value, allowPublish:f('contact[紹介してよい]').checked, record:f('contact[記録]').value});
      btn.disabled = false;
      if (r.ok){ ov.hidden = true; f('contact[body]').value = ''; toast('感想を送りました。ありがとうございます！'); return; }
      if (r.error && !/通信/.test(r.error)){ toast(r.error); return; }   // 入力の不足・1日の上限など
      form.dataset.fallback = '1'; form.submit();   // 通信できないときはメールで
    });
    if (ov.querySelector('.fb-err')) ov.hidden = false;   // 送れなかったとき（入力の不足など）は開いたまま
    if (/[?&]contact_posted=true/.test(location.search)){
      setTimeout(() => toast('感想を送りました。ありがとうございます！'), 300);
      try { history.replaceState(null, '', location.pathname); } catch(e){}
    }
  }
}
function setMode(m){
  mode = m;
  try { localStorage.setItem('teraism-survivor-mode', m); } catch(e){}
  for (const k of PLAY_MODES) $('mode-' + k).setAttribute('aria-pressed', String(k === m));
  $('bestTxt').textContent = bestText(loadBest());
  renderReward();
}
// タイトルは3つの画面を1つずつ出す（10/15 依頼者「画面がスクロールすると何が起きているのか分かりづらい。
// 今すぐ遊ぶ→画面が切り替わる→難易度を選ぶ→画面が変わる→武器を選ぶとゲームスタート」）
//   top＝最初の画面 → mode＝遊び方を選ぶ → part＝最初に積むパーツを選ぶ（選ぶと始まる）
let titleStep = 'top';
function showStep(s){
  titleStep = s;
  $('stepAd').hidden = s !== 'ad';
  $('stepTop').hidden = s !== 'top';
  $('stepMode').hidden = s !== 'mode';
  $('stepPart').hidden = s !== 'part';
  if (s === 'part') $('partMode').textContent = `${MODES[mode].label}（${{c1:'EASY', c3:'NORMAL', endless:'HARD'}[mode]}）で走ります`;
  $('ovTitle').scrollTop = 0;
}
for (const k of PLAY_MODES) $('mode-' + k).onclick = () => { setMode(k); showStep('part'); beacon('mode', {mode:k}); };
$('quickBtn').onclick = () => { showStep('mode'); beacon('quick'); };
$('backToTop').onclick = () => showStep('top');
$('backToMode').onclick = () => showStep('mode');
// 広告から来た人の最初の画面（10/17 依頼者「1回タップで始める」）：動画と同じ絵を大きく出し、押せばすぐ1分チャレンジ（おすすめのパーツで）
$('adHero').style.backgroundImage = `linear-gradient(rgba(232,246,236,.85), rgba(232,246,236,.6) 34%, rgba(232,246,236,0) 56%), url("${sprUrl('title-tall', 'jpg')}")`;   // 上は明るくして文字を読みやすく
// 音あり・音なしを選んで始める（10/17 依頼者「BGMオン・オフを選べると優しい」）。押した瞬間に音の可否が決まるので、自動再生の制限にもかからない
function startRush(on){
  const g = STARTERS.find(x => productFor(x, true)); if (!g) { showStep('top'); return; }
  audioInit(); setSound(on);
  beacon('quick'); mode = 'rush';
  startRun(g, productFor(g, true).h);
}
$('adStartOn').onclick = () => startRush(true);
$('adStartOff').onclick = () => startRush(false);
$('adToTop').onclick = () => showStep('top');
if (SHOPCFG) $('backLink').hidden = false;
// 結果と抽選の画面の背景：読み込めた絵だけ薄く敷く（無ければ今までの色）
const OV_ART = {};
for (const n of ['result-clear', 'result-over', 'lot-bg']){ const im = new Image(); im.onload = () => { OV_ART[n] = true; }; im.src = sprUrl(n, 'jpg'); }
function ovArt(id, n){
  if (OV_ART[n]) $(id).style.backgroundImage = `linear-gradient(rgba(232,246,236,.62), rgba(232,246,236,.78)), url("${sprUrl(n, 'jpg')}")`;
}
// タイトル画面の背景：PCは横長、スマホは縦長の絵を薄く敷く
function titleArt(){
  const tall = innerHeight > innerWidth;
  const url = sprUrl(tall ? 'title-tall' : 'title-wide', 'jpg');
  $('ovTitle').style.backgroundImage = `linear-gradient(rgba(232,246,236,.3), rgba(232,246,236,.5) 38%, rgba(232,246,236,.88) 68%), url("${url}")`;
}
titleArt(); addEventListener('resize', titleArt);
if (matchMedia('(pointer: coarse)').matches) $('helpTxt').innerHTML = '移動：画面のどこでも指でなぞる　一時停止：右上のボタン<br>攻撃は自動。パーツの性能は定価で決まり、セール中の商品は効果2倍。';

buildTitle();
setMode(mode);
showStep(TRAFFIC.ad ? 'ad' : 'top');
setState('title');
setTimeout(liveRefresh, 300);
loadState();

let last = performance.now();
function frame(now){
  const dt = Math.min(0.05, (now - last) / 1000); last = now;
  if (G && state === 'play') (G.clearing ? clearUpdate(dt) : update(dt));
  render(); updateHud(dt);
  requestAnimationFrame(frame);
}
requestAnimationFrame(frame);
})();
